// Slides de theorie par chapitre (sous-theme), generes une fois via LLM.
export const CHAPTER_THEORY = {
 "basic": {
  "B-001-002": [
   {
    "title": "Gestion du Certificat d'Opérateur Radioamateur",
    "body": "Le certificat d'opérateur radioamateur est valide pour toute la vie et est délivré gratuitement. Il doit être conservé à la station ou à l'adresse enregistrée auprès d'Innovation, Sciences et Développement économique Canada.",
    "points": [
     "**Validité** : le certificat est valable à vie.",
     "**Coût** : délivré gratuitement.",
     "**Conservation** : le certificat doit être gardé à la station ou à l'adresse officielle."
    ]
   },
   {
    "title": "Obligations liées au changement d'adresse et contrôle",
    "body": "Tout changement d'adresse doit être communiqué rapidement à Innovation, Sciences et Développement économique Canada. Un inspecteur peut demander à voir le certificat, que vous devez présenter dans un délai de 48 heures.",
    "points": [
     "Informer ISDE de tout changement d'adresse postale.",
     "Conserver le certificat à l'adresse indiquée à ISDE.",
     "Montrer le certificat (ou copie) à un inspecteur dans les **48 heures** sur demande."
    ]
   }
  ],
  "B-001-004": [
   {
    "title": "Introduction au Certificat d'Opérateur Radioamateur",
    "body": "Le certificat d'opérateur radioamateur avec compétence de base est accessible à tous, sans limite d'âge. Pour l'obtenir, il faut réussir l'examen de compétence de base, garantissant ainsi une connaissance minimale des règlements et techniques.",
    "points": [
     "Aucune limite d'âge pour détenir un certificat radioamateur.",
     "Examen requis : compétence de base.",
     "Doit avoir une adresse valide au Canada pour passer l'examen."
    ]
   },
   {
    "title": "Compétences et Autorisations Associées au Certificat",
    "body": "Le certificat de base permet d'exploiter une station du service de radioamateur, et la compétence Morse demandée est minimale, à 5 mots par minute. Les candidats peuvent passer des examens pour compétences supplémentaires dans n'importe quel ordre.",
    "points": [
     "Autorisation d'exploiter une station autorisée par le service radioamateur.",
     "Compétence en code Morse requise : 5 mots/minute.",
     "Compétences supplémentaires peuvent être obtenues dans n'importe quel ordre.",
     "Certificat général d'opérateur des radiocommunications maritime (CGRM) peut également être autorisé."
    ]
   }
  ],
  "B-001-005": [
   {
    "title": "Règles de responsabilité et d'installation en radioamateur",
    "body": "Les titulaires de certificats radioamateur doivent respecter des règles strictes concernant l'installation, la modification et la gestion des équipements au nom d'autrui. Ces règles visent à garantir que seules des personnes compétentes opèrent des appareils radioamateurs.",
    "points": [
     "Un titulaire avec **certificat et compétence supérieure** peut installer et entretenir un équipement pour une autre personne **seulement si cette dernière possède un certificat radioamateur valide**.",
     "Posséder un certificat radioamateur **ne donne pas automatiquement le droit d'agir pour une personne sans certificat**.",
     "Un titulaire avec une compétence de base ne peut pas installer, modifier ou permettre l'utilisation d'appareils au nom d'un ami sans certificat."
    ]
   },
   {
    "title": "Conception et assemblage du matériel d'émission",
    "body": "La fabrication et l'assemblage d'équipements d'émission radioamateurs sont soumis à un niveau de compétence réglementé. Seuls certains titulaires sont autorisés à réaliser ces opérations.",
    "points": [
     "Le droit de concevoir et assembler du matériel d'émission est réservé aux détenteurs d'un certificat avec **compétence supérieure**.",
     "Cette règle assure que le matériel respecte les normes techniques et réglementaires applicables au service radioamateur."
    ]
   }
  ],
  "B-001-001": [
   {
    "title": "Cadre légal de la radiocommunication au Canada",
    "body": "La réglementation des radiocommunications au Canada s'appuie principalement sur la Loi sur la radiocommunication, qui établit les bases légales pour toutes les activités radio.",
    "points": [
     "Le pouvoir d'établir des règlements et des normes pour les stations radioamateurs découle de la **Loi sur la radiocommunication**.",
     "Cette loi permet de créer des règles spécifiques pour la gestion du spectre et l'exploitation des services radio.",
     "Elle encadre aussi les responsabilités et les interdictions liées aux radiocommunications."
    ]
   },
   {
    "title": "Organismes responsables et définitions réglementaires",
    "body": "Innovation, Sciences et Développement économique Canada (ISDE) est le ministère chargé d'appliquer la Loi sur la radiocommunication et de superviser les activités radioamateurs au Canada.",
    "points": [
     "Le ministère responsable de l'application de la loi est **Innovation, Sciences et Développement économique Canada (ISDE)**.",
     "Le service de radioamateur est défini précisément dans le **Règlement sur la radiocommunication** qui complète la loi.",
     "Le Règlement détaille les conditions d'utilisation et les critères pour le service radioamateur."
    ]
   }
  ],
  "B-001-003": [
   {
    "title": "Règlements sur les émissions radioamateurs",
    "body": "Les opérateurs radioamateurs doivent respecter strictement les bandes attribuées au service radioamateur. Les émissions hors de ces bandes sont interdites et peuvent entraîner des sanctions.",
    "points": [
     "Les émissions **hors des bandes** autorisées sont interdites.",
     "L'opérateur responsable peut faire l'objet de **sanctions** en cas d'infraction.",
     "Respecter les fréquences attribuées garantit la bonne coexistence des services."
    ]
   },
   {
    "title": "Utilisation des signaux d'urgence et infractions",
    "body": "L'utilisation inappropriée des signaux d'urgence, comme 'MAYDAY', est considérée comme une émission de signaux erronés ou mensongers et est sévèrement sanctionnée par la loi.",
    "points": [
     "Le mot **MAYDAY** indique une situation d'urgence réelle.",
     "Faire croire faussement à une urgence constitue un **signal mensonger**.",
     "Les infractions peuvent entraîner une amende maximale de **5 000 $**, un emprisonnement jusqu'à **1 an**, ou les deux.",
     "Ces dispositions sont régies par la **Loi sur la radiocommunication**."
    ]
   },
   {
    "title": "Pouvoirs des autorités et droits des opérateurs",
    "body": "Le ministre peut suspendre un certificat d'opérateur, mais doit respecter la procédure, notamment en donnant un avis et un droit de représentation. Un inspecteur ne peut entrer dans une résidence sans consentement ou mandat.",
    "points": [
     "La suspension d'un certificat nécessite un **avis préalable** et un droit de représentation.",
     "Un inspecteur de la radio ne peut pénétrer dans une habitation sans **consentement** ou **mandat**.",
     "Les droits des opérateurs sont protégés face aux interventions des autorités."
    ]
   }
  ],
  "B-001-006": [
   {
    "title": "Règles de supervision et communication en service radioamateur",
    "body": "La puissance maximale d'une station radioamateur à l'entrée de l'étage final est limitée pour certains cas, mais toute station doit être supervisée par une personne qualifiée. La communication est restreinte aux stations ayant une autorisation similaire.",
    "points": [
     "**2 watts** est la puissance maximale à l'entrée de l'étage final nécessitant supervision.",
     "La supervision doit être assurée par un opérateur détenant un **certificat radioamateur** et un **indicatif d'appel** valide.",
     "La communication est permise uniquement avec des stations ayant une **autorisation équivalente**."
    ]
   },
   {
    "title": "Usage des amplificateurs et respect des normes en radioamateur",
    "body": "Les amplificateurs linéaires ne peuvent pas être utilisés sans autorisation en dehors des bandes allouées au service radioamateur. De plus, la qualité des signaux émis doit respecter des normes de convenance.",
    "points": [
     "L'utilisation d'un **amplificateur linéaire** est interdite **hors bandes radioamateur** sans autorisation.",
     "Un radioamateur doit éviter d'émettre des signaux **superflus ou grossiers**.",
     "Respecter les normes convenables garantit un bon usage du spectre et évite les infractions."
    ]
   },
   {
    "title": "Utilisation légale des fréquences et appareils dual usage",
    "body": "Une personne ne peut pas utiliser un appareil radio autorisé pour le service radioamateur sur des fréquences des services mobiles comme aéronautique, maritime ou terrestre, sauf si l'appareil correspond aux exigences réglementaires spécifiques.",
    "points": [
     "Il est interdit d'émettre sur les fréquences des services mobiles aéronautique, maritime ou terrestre avec un appareil radioamateur.",
     "Les appareils VHF/UHF FM compatibles avec service mobile terrestre doivent être conformes au **Cahier des charges sur les normes radioélectriques (CNR)**.",
     "Une licence spécifique d'**Innovation, Sciences et Développement économique Canada** est requise pour utiliser ces fréquences."
    ]
   }
  ],
  "B-001-008": [
   {
    "title": "Exploitation des stations radioamateurs au Canada",
    "body": "Un titulaire d'un certificat d'opérateur radioamateur peut exploiter une station partout au Canada sans restriction géographique.",
    "points": [
     "Un certificat d'opérateur radioamateur autorise l'opération de la station à **partout au Canada**.",
     "La réglementation canadienne ne limite pas l'emplacement géographique d'exploitation.",
     "Les opérateurs peuvent installer et faire fonctionner leurs appareils radio sur l'ensemble du territoire canadien."
    ]
   },
   {
    "title": "Types de stations et leurs autorisations",
    "body": "Une station balise émet des communications à sens unique tandis que certaines installations spécifiques requièrent un certificat avec des compétences précises.",
    "points": [
     "Une **station balise** émet des communications **à sens unique** sans possibilité de retour.",
     "Pour installer un appareil recevant et retransmettant automatiquement des communications radiotéléphoniques dans la même bande, il faut un certificat avec les **compétences de base et supérieure**.",
     "La gestion des stations de club demande également un certificat détenant ces mêmes compétences de base et supérieure.",
     "L'utilisation d'émetteurs ou amplificateurs RF non commerciaux nécessite obligatoirement un certificat avec compétences de base et supérieure."
    ]
   }
  ],
  "B-001-007": [
   {
    "title": "Règlements essentiels pour le service radioamateur",
    "body": "Les radioamateurs doivent respecter des règles strictes concernant les contenus et la nature des communications qu'ils échangent.",
    "points": [
     "La **communication commerciale** est **interdite** sur les réseaux de radioamateurs.",
     "La diffusion d'information au **public en général est interdite.**",
     "Les messages **erronés, mensongers ou secrets** sont **jamais** permis sur ces fréquences.",
     "La **radiodiffusion à sens unique** destinée au grand public est interdite.",
     "Les communications doivent rester **transparentes et non codées secrètement.**"
    ]
   },
   {
    "title": "Utilisation des codes et techniques en radioamateur",
    "body": "L'utilisation de codes et de nouvelles techniques doit être conforme aux règles pour garantir la légalité et la transparence des communications.",
    "points": [
     "Les codes comme les **codes Q** peuvent être transmis, mais aucun code ne doit être secret.",
     "Les **abréviations et codes** ne doivent pas être utilisés de manière secrète.",
     "Une nouvelle technique d'encodage peut être utilisée seulement si ses spécifications sont publiées dans le **domaine public**.",
     "L'utilisation d'un **code secret** par un opérateur radioamateur est strictement interdite."
    ]
   },
   {
    "title": "Pratiques correctes pour éviter les interférences non autorisées",
    "body": "Pour éviter toute retransmission non autorisée de signaux ou de musique provenant d'autres services, il faut appliquer des mesures simples.",
    "points": [
     "Pour éviter de retransmettre des signaux non radioamateurs, il faut **baisser le volume des autres appareils** émettant ces signaux.",
     "Les radioamateurs doivent toujours s'assurer que les transmissions restent dans les règles définies par ISED."
    ]
   }
  ],
  "B-001-009": [
   {
    "title": "Responsabilité de l'opérateur et du propriétaire",
    "body": "Le bon fonctionnement d'une station radioamateur est sous la double responsabilité de l'opérateur responsable et du propriétaire. Cette responsabilité s'applique même si vous utilisez la station d’un autre radioamateur.",
    "points": [
     "Le propriétaire est responsable du respect des règlements lors de l’utilisation de sa station.",
     "L'opérateur responsable peut être toute personne compétente désignée par le propriétaire.",
     "Cette responsabilité s'exerce à chaque émission effectuée avec la station."
    ]
   },
   {
    "title": "Conditions d'utilisation et supervision",
    "body": "Une station radioamateur doit être sous la garde d’un opérateur responsable chaque fois qu’elle est utilisée. Cette personne doit se trouver à proximité pour contrôler la station durant les émissions.",
    "points": [
     "Un opérateur responsable doit toujours être présent lors des émissions.",
     "Les membres de la famille sans certificat compétent ne peuvent pas émettre en votre absence.",
     "Le propriétaire peut permettre l’usage de sa station uniquement en présence et sous la supervision d’un titulaire de certificat officiel.",
     "Toute personne peut utiliser la station si un opérateur qualifié est présent et supervise les émissions."
    ]
   }
  ],
  "B-001-010": [
   {
    "title": "Le brouillage en radioamateurisme",
    "body": "Le brouillage préjudiciable désigne une émission qui dégrade ou interrompt sérieusement une communication. Jamais un radioamateur ne doit intentionnellement causer de brouillage aux autres communications.",
    "points": [
     "**Brouillage préjudiciable** : émission perturbant gravement une communication.",
     "**Jamais permis** de brouiller volontairement les communications d'une autre station.",
     "Si brouillage causé, le ministre peut exiger des mesures correctives."
    ]
   },
   {
    "title": "Règlements sur l'usage des bandes et fréquentielle",
    "body": "Les radioamateurs doivent respecter les priorités des bandes. Sur les bandes secondaires, ils ne peuvent causer de brouillage aux services primaires. Sur une même fréquence, tous les radioamateurs ont des droits égaux.",
    "points": [
     "Service secondaire : usage permis **sans causer de brouillage aux primaires**.",
     "Sur une fréquence donnée, **droits d'utilisation égaux** entre radioamateurs.",
     "Bande 430,0–450,0 MHz : radioamateurs doivent éviter de causer du brouillage.",
     "Bandes 902–928 MHz et 2300–2450 MHz : présence importante de dispositifs exemptés de licence."
    ]
   },
   {
    "title": "Particularités des bandes de fréquences ISM",
    "body": "Certains bandes partagées avec des dispositifs industriels, scientifiques et médicaux (ISM) peuvent être très achalandées, et les radioamateurs ne sont pas protégés contre les brouillages causés par ces dispositifs.",
    "points": [
     "902–928 MHz : bande non protégée contre brouillages par d'autres services.",
     "2300–2450 MHz : bande partagée avec de nombreux dispositifs ISM exemptés de licence.",
     "Utilisation sur ces bandes peut engendrer des interférences importantes."
    ]
   }
  ],
  "B-001-012": [
   {
    "title": "Règlement sur la rémunération et l'usage des communications",
    "body": "Les opérateurs radioamateurs ne peuvent recevoir aucune forme de rémunération pour transmettre des communications au nom d'autrui. Cette règle garantit que le service radioamateur reste non commercial et dédié à l'expérimentation et au service bénévole.",
    "points": [
     "Aucune rémunération n'est permise pour transmettre un message au nom d'un tiers.",
     "L'opérateur ne doit ni demander ni accepter de paiement pour ses transmissions."
    ]
   },
   {
    "title": "Confidentialité et utilisation des communications radio",
    "body": "Les communications destinées à d'autres stations sont privées, sauf si elles proviennent d'une station du service radioamateur, ce qui autorise leur divulgation. Toute autre interception, divulgation ou utilisation non autorisée est sanctionnée par la loi.",
    "points": [
     "On peut divulguer ou utiliser les radiocommunications d'autres stations uniquement si elles proviennent d'une station radioamateur.",
     "Divulguer ou utiliser des informations interceptées est interdit, sauf exceptions prévues par la loi.",
     "Fournir ces informations à un journaliste n'est pas une exception légale."
    ]
   }
  ],
  "B-001-013": [
   {
    "title": "Identification des stations radioamateurs au Canada",
    "body": "Chaque station du service radioamateur doit être clairement identifiée par son indicatif d'appel, qui commence normalement par **VA**, **VE**, **VO** ou **VY** au Canada.",
    "points": [
     "L'indicatif d'appel est une combinaison unique de lettres et chiffres (exemple : **VA3XYZ**).",
     "Il sert à identifier officiellement la station pendant les transmissions.",
     "L'identification est obligatoire en français ou en anglais."
    ]
   },
   {
    "title": "Règles de transmission de l'identification",
    "body": "L'indicatif doit être transmis au début, à la fin de chaque communication, et au moins toutes les 30 minutes pendant l'émission continue.",
    "points": [
     "Chaque station présente dans une communication doit s'identifier au début et à la fin.",
     "L’identification doit être répétée au maximum toutes les **30 minutes** pendant la transmission.",
     "Il est interdit d’émettre des communications non identifiées, sauf lors de la télécommande de modèles réduits."
    ]
   }
  ],
  "B-001-011": [
   {
    "title": "Règlements fondamentaux du service radioamateur",
    "body": "Le service radioamateur est strictement réservé à la communication entre stations de radioamateur. Toute autre utilisation ou communication hors bandes réglementaires est interdite, sauf dans des conditions très spécifiques.",
    "points": [
     "Les stations radioamateurs communiquent uniquement entre elles.",
     "Il est interdit d'utiliser des fréquences hors bandes radioamateurs, même en situation de relève post-désastre.",
     "En situation de détresse, il est permis d'utiliser tout moyen de radiocommunication nécessaire.",
     "Une station en détresse a une puissance illimitée pour ses transmissions."
    ]
   },
   {
    "title": "Rôles et limitations en situation d'urgence et détresse",
    "body": "Les communications de détresse et d'urgence dans le service radioamateur sont priorisées et soumises à des règles adaptées pour garantir la sauvegarde des vies et des biens. Les opérations de relève et retransmissions essentielles sont autorisées dans des conditions précises.",
    "points": [
     "Une station de détresse peut gêner d'autres émissions pour assurer la sécurité.",
     "Les radiocommunications nécessaires à la sauvegarde immédiate de la vie humaine ou la protection immédiate de la propriété sont autorisées en diffusion.",
     "Les radioamateurs peuvent offrir leur aide s'ils captent un signal de détresse, même sur des bandes non autorisées.",
     "Les communications essentielles durant un désastre sont acheminées sur fréquences pré-établies par des réseaux spécialisés.",
     "Les opérateurs non engagés dans les opérations d'urgence doivent éviter toute émission non nécessaire sur ces fréquences."
    ]
   },
   {
    "title": "Utilisation des messages et opérations en temps de paix et d’urgence",
    "body": "Les radioamateurs peuvent traiter des messages émis par des organismes de service public reconnus, en temps normal ou pendant les urgences et exercices, contribuant ainsi à la coordination et au soutien des communications.",
    "points": [
     "Les messages des organismes de service public peuvent être traités durant les urgences et en temps de paix.",
     "Durant un désastre, les radioamateurs assistent les opérations de relève si les systèmes réguliers sont surchargés, endommagés ou hors service."
    ]
   }
  ],
  "B-001-014": [
   {
    "title": "Communications au nom d'un tiers et supervision",
    "body": "Un radioamateur peut transmettre des messages non commerciaux ou personnels pour une tierce personne, uniquement si ces communications sont autorisées par les administrations concernées. Lorsqu'un tiers non qualifié utilise votre station, vous devez toujours superviser et écouter l'émission.",
    "points": [
     "Les communications au nom d'un tiers doivent être autorisées par le pays destinataire.",
     "La supervision constante est obligatoire lorsque la station est utilisée par un tiers non qualifié.",
     "En cas de doute lors d'une communication avec un radioamateur étranger, il faut confirmer l'autorisation de son administration avant de continuer."
    ]
   },
   {
    "title": "Restrictions internationales et exceptions",
    "body": "Il est interdit de communiquer avec un pays qui a formellement notifié à l'Union internationale des télécommunications son opposition aux communications radioamateur. Les communications d'urgence au nom d'un tiers sont permises sauf interdiction explicite de l'administration étrangère.",
    "points": [
     "Aucune communication avec un pays opposé officiellement aux communications radioamateur internationales.",
     "Les communications d'urgence ou secours au nom d'un tiers sont autorisées sauf interdiction expresse.",
     "Les messages provenant des réseaux militaires comme CFARS et MARS ne sont pas considérés comme communication au nom d'un tiers."
    ]
   },
   {
    "title": "Licences et opérations au Canada",
    "body": "Un radioamateur étranger de passage au Canada n'a pas besoin d'obtenir un certificat canadien s'il possède une licence valide de son pays, sous réserve des accords internationaux. Transmettre des messages au nom d'un tiers sans restriction est interdit.",
    "points": [
     "Un radioamateur américain en visite n'a pas forcément besoin d'un certificat canadien pour opérer.",
     "Il est interdit pour un radioamateur canadien de transmettre des messages au nom d'un tiers à n'importe quel pays sans vérification.",
     "Le respect des règlements ISED et des accords internationaux est obligatoire pour toutes les communications."
    ]
   }
  ],
  "B-001-016": [
   {
    "title": "Largeur de bande autorisée selon les bandes de fréquences",
    "body": "Chaque bande de fréquences en service radioamateur possède des limites spécifiques quant à la largeur de bande maximale autorisée pour les émissions, afin d'éviter les interférences.",
    "points": [
     "Entre **50 et 148 MHz**, la largeur de bande maximale est de **30 kHz**.",
     "Dans la bande **28,0 à 29,7 MHz**, la largeur maximale est de **20 kHz**.",
     "Dans la bande **7 à 28 MHz**, sauf exception, la largeur maximale est de **6 kHz**.",
     "Dans la bande **50 à 54 MHz**, la largeur maximale est aussi de **30 kHz**."
    ]
   },
   {
    "title": "Restrictions spécifiques dans certaines bandes",
    "body": "Certaines sous-bandes ont des règles plus strictes, notamment concernant l'usage de la modulation et la largeur de bande, pour protéger les autres services et éviter les brouillages.",
    "points": [
     "Dans la bande de **10,1 à 10,15 MHz**, la largeur de bande maximale autorisée est inférieure à **6 kHz**.",
     "L'utilisation de la modulation en **bande latérale unique (BLU)** est interdite dans cette même bande (10,1 - 10,15 MHz).",
     "Les modes de télévision radioamateur à balayage rapide (**ATV**) sont interdits sur **14,23 MHz** et sur **145 MHz**.",
     "L'opérateur doit éviter que la largeur de bande nécessaire dépasse les limites de la bande près des extrémités, pour éviter les émissions hors bande."
    ]
   }
  ],
  "B-001-015": [
   {
    "title": "Privilèges et utilisation des stations radioamateurs",
    "body": "Un radioamateur opérant une station ne peut utiliser que les privilèges qui correspondent au certificat associé à cette station. De même, un opérateur utilisant une station d'un autre amateur est limité par ses propres compétences.",
    "points": [
     "**Privilèges d'opération limités** à ceux autorisés par votre propre certificat même si vous utilisez une station d'un opérateur plus compétent.",
     "Un opérateur utilisant une autre station doit respecter **seulement ses propres privilèges**, pas ceux du titulaire de la station.",
     "Les modèles télécommandés peuvent être utilisés uniquement sur les bandes **au-dessus de 30 MHz**."
    ]
   },
   {
    "title": "Exigences supplémentaires pour certaines permissions",
    "body": "Au-delà de la réussite de l'examen de compétence de base, des épreuves supplémentaires permettent l’accès à des fréquences spécifiques pour utilisation plus large.",
    "points": [
     "Pour utiliser les fréquences **inférieures à 30 MHz**, il faut réussir soit :",
     "- Le code Morse,",
     "- L'examen de compétence supérieure,",
     "- Ou obtenir un score d'au moins **80 %** à l'examen de compétence de base."
    ]
   },
   {
    "title": "Bandes de fréquences radioamateurs au Canada",
    "body": "Les bandes allouées aux radioamateurs ont des plages de fréquences définies et sont essentielles pour bien comprendre l'utilisation légale des ondes.",
    "points": [
     "**160 mètres :** 1,8 à 2,0 MHz",
     "**75-80 mètres :** 3,5 à 4,0 MHz",
     "**40 mètres :** 7,0 à 7,3 MHz",
     "**20 mètres :** 14,000 à 14,350 MHz",
     "**15 mètres :** 21,000 à 21,450 MHz"
    ]
   }
  ],
  "B-001-018": [
   {
    "title": "Stations radioamateurs et retransmission",
    "body": "Un répéteur est une station radioamateur conçue pour retransmettre automatiquement les signaux d'autres stations afin d'étendre la portée de communication.",
    "points": [
     "**Répéteur** : station qui retransmet automatiquement les signaux reçus.",
     "Permet d'élargir la couverture radio sans intervention humaine directe."
    ]
   },
   {
    "title": "Règles d'émission de porteuse et de retransmission",
    "body": "L'émission d'une porteuse non modulée est limitée à des essais brefs sur des fréquences inférieures à 30 MHz. De plus, les signaux radiotéléphoniques en dessous de 29,5 MHz ne peuvent être retransmis automatiquement que s'ils proviennent d'une station opérée par une personne qualifiée pour la fréquence concernée.",
    "points": [
     "Porteuse non modulée permise uniquement pour brefs essais sous **30 MHz**.",
     "Retransmission automatique de signaux radiotéléphoniques impossible sous **29,5 MHz** sauf si opérateur qualifié.",
     "Cette règle vise à éviter les interférences non contrôlées."
    ]
   },
   {
    "title": "Restrictions sur les retransmissions en radiotéléphonie",
    "body": "La retransmission automatique de signaux radiotéléphoniques dans la bande des 21 MHz n’est pas permise si elle est fournie par un radioamateur ayant uniquement la compétence de base. Ceci protège la gestion rigoureuse et la coordination des communications sur ces fréquences.",
    "points": [
     "Retransmission en radiotéléphonie à 21 MHz interdites si opérateur a seulement la compétence de base.",
     "Les compétences avancées sont nécessaires pour retransmettre sur certaines bandes.",
     "Assure une utilisation responsable et conforme des fréquences réglementées."
    ]
   }
  ],
  "B-001-019": [
   {
    "title": "Stabilité et modulation des émetteurs radioamateurs",
    "body": "La stabilité de fréquence et le contrôle de modulation sont essentiels aux stations radioamateurs pour assurer une communication claire et conforme aux règlements.",
    "points": [
     "Pour les fréquences inférieures à **148 MHz**, un émetteur doit avoir une **stabilité comparable à un oscillateur à cristal**.",
     "Le taux maximal de modulation en **radiotéléphonie** est de **100 %** pour éviter la distorsion du signal.",
     "Un dispositif fiable doit prévenir ou indiquer la **surmodulation** pour toutes les stations utilisant la radiotéléphonie."
    ]
   },
   {
    "title": "Dispositifs obligatoires pour les stations radioamateurs",
    "body": "Toutes les stations radioamateurs doivent être équipées d'outils afin de garantir une émission correcte et réglementaire.",
    "points": [
     "Un dispositif fiable doit permettre de **déterminer précisément la fréquence d'exploitation** quelle que soit la méthode d'émission.",
     "En radiotéléphonie, un dispositif doit servir à **prévenir ou indiquer la surmodulation** afin de maintenir la qualité du signal."
    ]
   }
  ],
  "B-001-017": [
   {
    "title": "Puissance d'émission en radioamateur",
    "body": "La puissance d'émission doit toujours être la puissance minimale légale nécessaire pour assurer la communication, afin de limiter les interférences.",
    "points": [
     "Toujours utiliser la **puissance minimale légale** pour permettre la communication.",
     "La puissance maximale légale varie selon la compétence détenue et la bande de fréquence.",
     "La puissance est souvent mesurée au **connecteur d'antenne** pour vérifier la conformité."
    ]
   },
   {
    "title": "Limites de puissance selon les compétences et bandes",
    "body": "Les puissances maximales autorisées diffèrent selon la qualification du radioamateur et la bande de fréquence utilisée, définies en puissance de sortie RF ou puissance d'entrée en courant continu.",
    "points": [
     "Titulaire de compétence de base : max **250 watts** de puissance d'entrée CC en VHF (ex : 147 MHz).",
     "Compétence de base avec code Morse ou distinction : max **560 watts** de puissance de sortie en crête de modulation en BLU sur bandes HF (ex : 3750 kHz, 7055 kHz).",
     "Compétence supérieure : max **1 000 watts** de puissance d'entrée CC à l'étage final.",
     "Pour une émission à bande latérale unique, la puissance en sortie RF ne doit pas dépasser **560 watts** en crête de modulation pour les compétences de base."
    ]
   },
   {
    "title": "Mesure et équipement autorisé",
    "body": "La puissance doit être mesurée au bon endroit et l'équipement utilisé doit respecter les limites prévues selon la qualification du titulaire.",
    "points": [
     "La puissance d'émission se mesure au **connecteur d'antenne** de l'émetteur ou de l'amplificateur.",
     "Puissance d'entrée en courant continu mesurée au circuit d'anode ou collecteur de l'étage final RF.",
     "Le titulaire de base avec distinction peut légalement exploiter un amplificateur VHF jusqu'à **160 watts** de porteuse."
    ]
   }
  ],
  "B-001-020": [
   {
    "title": "Règles de communication en radioamateur",
    "body": "Les radioamateurs doivent limiter leurs communications à des messages techniques ou personnels sans importance politique ou commerciale.",
    "points": [
     "**Messages permis** : uniquement de nature technique ou d'intérêt personnel sans importance",
     "Communication interdite pour messages commerciaux ou politiques",
     "Les échanges peuvent se faire avec des stations internationales sous ces conditions"
    ]
   },
   {
    "title": "Réglementation internationale applicable aux radioamateurs canadiens",
    "body": "Les radioamateurs au Canada doivent respecter la Loi et le Règlement sur la radiocommunication ainsi que les règlements de l'Union internationale des télécommunications (UIT).",
    "points": [
     "L'UIT régule les activités globales des radioamateurs, y compris au Canada",
     "L'UIT n'impose pas d'exigences en code Morse pour l'utilisation de fréquences supérieures",
     "L'UIT ne limite pas la nature technique ou personnelle des messages échangés"
    ]
   }
  ],
  "B-001-021": [
   {
    "title": "Régions de l'Union internationale des télécommunications (UIT)",
    "body": "Le monde est divisé en 3 régions par l'UIT pour gérer l'utilisation des fréquences radio. Chaque région a ses propres règles et allocations de fréquences pour éviter les interférences.",
    "points": [
     "**Canada** appartient à la **Région 2** de l'UIT.",
     "L'**Australie, le Japon et le Sud-Est asiatique** font partie de la **Région 3**.",
     "Les régions influencent les bandes de fréquences utilisables."
    ]
   },
   {
    "title": "Limites applicables pour les radioamateurs en déplacement",
    "body": "Un radioamateur canadien opérant aux États-Unis doit se conformer aux règles américaines, même si c'est à quelques kilomètres au large des côtes.",
    "points": [
     "Opération sur le territoire américain (y compris jusqu'à 7 km ou 4 milles au large) suit les limites des radioamateurs américains.",
     "Les règles de la région UIT où se trouve la station s'appliquent en priorité.",
     "Respecter les réglementations locales garantit un usage légal des bandes de fréquences."
    ]
   }
  ],
  "B-001-022": [
   {
    "title": "Frais et examens pour les radioamateurs au Canada",
    "body": "Passer un examen de radioamateur au bureau d'Innovation, Sciences et Développement économique Canada est gratuit. Cependant, les frais pour un examen avec un examinateur accrédité sont à négocier directement entre le candidat et l'examinateur.",
    "points": [
     "Les examens au bureau d'ISDE sont **sans frais**.",
     "Les frais chez un examinateur accrédité sont **à négocier entre l’examinateur et le candidat**.",
     "Aucun montant fixe, comme 5 $ par compétence, n’est exigé par ISDE."
    ]
   },
   {
    "title": "Règles spécifiques concernant les candidats handicapés et l’utilisation d’un interprète",
    "body": "Les candidats handicapés ne sont pas obligés de passer par l’examen régulier sans accommodation. Par ailleurs, un candidat dont la maîtrise de l’anglais ou du français est insuffisante ne peut pas être accompagné d’un interprète lors de l'examen.",
    "points": [
     "Les candidats handicapés peuvent bénéficier d’accommodations adaptées pour passer l’examen.",
     "Il est **faux** de dire qu’un candidat doit obligatoirement subir l’examen régulier sans aide spécifique.",
     "L'utilisation d'un interprète pendant l'examen n'est **pas autorisée**, même si le candidat ne maîtrise pas bien l’anglais ou le français."
    ]
   }
  ],
  "B-001-025": [
   {
    "title": "Immunité aux interférences selon le bulletin ACEM-2",
    "body": "Le bulletin ACEM-2 établit des critères pour évaluer les plaintes de brouillage causées par des émissions radio. L'intensité du champ sur le lieu affecté est comparée à des seuils d'immunité définis par Innovation, Sciences et Développement économique Canada (ISED).",
    "points": [
     "Si l'intensité du champ sur le récepteur radiosensible est inférieure aux critères ISED, le brouillage provient d'un manque d'immunité du matériel affecté.",
     "Si l'intensité du champ sur le terrain du voisin excède les critères ISED, les émissions radio en cause sont responsables du brouillage.",
     "L'intensité du champ est une mesure du niveau de signal radio sur un site donné pour évaluer les interférences."
    ]
   },
   {
    "title": "Définitions et exclusions dans le bulletin ACEM-2",
    "body": "Le bulletin ACEM-2 définit clairement ce qu'est un matériel radiosensible et précise les équipements considérés pour l'application des critères d'immunité.",
    "points": [
     "Un matériel radiosensible est tout dispositif, machine ou équipement (sauf appareil radio) pouvant être perturbé par des émissions radio lorsqu'il fonctionne ou est utilisé.",
     "Les critères d'intensité du champ s'appliquent pour résoudre les plaintes d'immunité liées à ces matériels radiosensibles.",
     "Les émetteurs de radiodiffusion ne font pas partie des équipements inclus dans ces critères d'intensité du champ pour résoudre les plaintes."
    ]
   }
  ],
  "B-002-002": [
   {
    "title": "Identification claire en téléphonie",
    "body": "Pour assurer que votre indicatif est compris sans erreur lors d'une communication téléphonique, il est crucial d'utiliser une méthode standardisée.",
    "points": [
     "Utiliser l'**alphabet phonétique international** pour épeler chaque lettre de votre indicatif.",
     "Cela facilite la compréhension en évitant les confusions entre lettres semblables (ex. B, D, E).",
     "Permet une identification précise et rapide de votre station par l'interlocuteur."
    ]
   },
   {
    "title": "Alphabet phonétique international - lettres clés",
    "body": "Apprenez la prononciation standard des lettres les plus fréquentes pour communiquer clairement votre indicatif en phonétique.",
    "points": [
     "**A** se prononce **Alfa**",
     "**B** se prononce **Bravo**",
     "**D** se prononce **Delta**",
     "**E** se prononce **Echo**",
     "**G** se prononce **Golf**"
    ]
   }
  ],
  "B-001-023": [
   {
    "title": "Autorité et Consultation pour l'Installation des Antennes",
    "body": "L'installation ou la modification des structures d'antennes est régie principalement par le ministre de l'Innovation, Sciences et Développement économique Canada (ISDE). Toutefois, pour l'utilisation du sol et les consultations publiques, les autorités locales ou municipales jouent un rôle important.",
    "points": [
     "Le ministre de l'Innovation, Sciences et Développement économique détient l'autorité sur les installations d'antennes et pylônes.",
     "Les autorités responsables de l'utilisation du sol (municipalités) décident des processus de consultation publique relatifs aux antennes.",
     "Un radioamateur ne peut pas ériger une antenne de n'importe quelle grandeur sans consulter les voisins ou autorités locales.",
     "Les autorités locales définissent comment se déroule la consultation publique."
    ]
   },
   {
    "title": "Processus de Consultation Publique et Exclusions",
    "body": "Les radioamateurs doivent respecter le processus de consultation publique défini par les autorités locales ou, en leur absence, le processus par défaut d'ISDE. Certaines exclusions s'appliquent selon la hauteur ou d'autres critères.",
    "points": [
     "Si un critère d'exclusion ISDE s'applique, la consultation auprès de l'autorité locale peut ne pas être nécessaire.",
     "Sans processus local, le radioamateur suit le processus par défaut ISDE pour la consultation publique.",
     "L'avis de consultation publique dure 30 jours, durant lesquels le promoteur doit répondre aux préoccupations écrites pertinentes et raisonnables.",
     "La hauteur maximale pour une exclusion dépend du plus haut seuil entre le processus local et celui d'ISDE.",
     "Les exclusions sont précisées dans la CPC-2-0-03 d'ISDE ou par l'autorité responsable du sol."
    ]
   },
   {
    "title": "Résolution des Conflits et Limites du Processus",
    "body": "En cas de désaccord entre le promoteur et une partie autre qu'un membre du public, ISDE tranche finalement. Par ailleurs, le processus de consultation ne comprend pas de réunions publiques obligatoires.",
    "points": [
     "La décision finale en cas d'impasse revient à Innovation, Sciences et Développement économique Canada.",
     "Le processus standard ISDE ne requiert pas la participation à des réunions publiques.",
     "Le promoteur doit respecter les exigences même si la consultation locale n'est pas mise en place, sauf exclusion spécifique.",
     "Le processus garantit un équilibre entre droits des radioamateurs et préoccupations publiques."
    ]
   }
  ],
  "B-001-024": [
   {
    "title": "Sécurité et exposition aux radiofréquences (RF)",
    "body": "La sécurité concernant l'exposition humaine aux radiofréquences est réglementée par Santé Canada. Le Code de sécurité 6 établit les limites maximales d'exposition aux RF pour le corps humain afin de prévenir les effets nocifs.",
    "points": [
     "Santé Canada publie les règles de sécurité sur l'exposition aux RF.",
     "Le Code de sécurité 6 définit les limites d'exposition pour toutes les fréquences RF.",
     "Il s'applique à tous les émetteurs, indépendamment de leur puissance."
    ]
   },
   {
    "title": "Limites d'exposition selon la fréquence",
    "body": "Les risques liés à l'exposition aux RF sont plus importants entre **30 MHz et 300 MHz**, car le corps humain absorbe plus facilement cette énergie dans cette gamme. Les limites d'exposition varient avec la fréquence, augmentant au-delà de 300 MHz jusqu'à 1,5 GHz.",
    "points": [
     "La limite d'exposition est la plus basse entre **30 MHz et 300 MHz**.",
     "Le corps humain absorbe plus intensément les RF dans cette bande.",
     "Au-dessus de 300 MHz jusqu'à 1,5 GHz, la limite d'exposition augmente.",
     "La norme ne réduit pas la limite à des fréquences inférieures à 10 MHz."
    ]
   },
   {
    "title": "Applications et précisions du Code de sécurité 6",
    "body": "Le Code de sécurité 6 ne spécifie pas de puissance maximale sécuritaire à la sortie d’une antenne pour les radios portatives VHF/UHF. Tous les émetteurs doivent respecter les limites d'exposition sans exemption, et les limites sont basées sur l'exposition, non pas directement sur la puissance à l'antenne.",
    "points": [
     "Pas de puissance maximale spécifiée pour les radios portatives VHF/UHF.",
     "Les émetteurs portatifs ne sont pas exemptés des règles.",
     "Les limites sont définies par niveau d'exposition, pas en puissance à l'antenne."
    ]
   }
  ],
  "B-002-001": [
   {
    "title": "Fonctionnement et Utilisation des Répéteurs",
    "body": "Les répéteurs améliorent la portée des stations portables et mobiles en retransmettant les signaux sur une fréquence différente. Leur utilisation nécessite des procédures spécifiques pour assurer une communication efficace et respectueuse.",
    "points": [
     "Un répéteur reçoit sur une fréquence (rx) et retransmet sur une fréquence différente (tx), typiquement séparées de **600 kHz** sur la bande des 2 mètres.",
     "On utilise la **tonalité CTCSS**, une fréquence sous-audible, pour activer la sortie audio du récepteur d’un répéteur.",
     "Les répéteurs ont une **minuterie limitant la durée des transmissions** pour éviter les longs blocages.",
     "Faire une **pause entre transmissions** permet de vérifier si quelqu’un souhaite utiliser le répéteur."
    ]
   },
   {
    "title": "Procédures d’Appel et de Communication sur Répéteur",
    "body": "Les appels sur répéteur doivent être clairs et respectueux pour permettre un usage partagé optimal. Connaître les bonnes méthodes facilite un contact efficace et ordonné.",
    "points": [
     "Pour contacter une station, dites d'abord son **indicatif d’appel**, puis votre propre indicatif.",
     "Pour rejoindre une conversation déjà en cours, donnez votre **indicatif** pendant les pauses.",
     "Les conversations doivent être **courtes** pour laisser la place à d’autres, surtout en cas d’urgence.",
     "Pour localiser une station, demandez simplement : « Où êtes-vous situé? »"
    ]
   },
   {
    "title": "Coordination des Fréquences et Usage Responsable",
    "body": "La coordination des fréquences évite les interférences et optimise l’usage des bandes VHF/UHF. Le respect des règles garantit une expérience radio agréable et efficiente pour tous.",
    "points": [
     "La **coordination des fréquences** signifie attribuer les fréquence avec soin pour minimiser le brouillage entre répéteurs voisins.",
     "Respectez toujours les règles d’utilisation pour préserver la fonctionnalité des équipements et des réseaux.",
     "Utiliser les répéteurs de manière responsable aide à garantir leur disponibilité en cas d’urgence."
    ]
   }
  ],
  "B-002-004": [
   {
    "title": "Préparation à l'émission et usage des fréquences",
    "body": "Avant d'émettre, il est essentiel d'écouter la fréquence pour éviter d'interrompre un contact existant. Le respect d'un plan de bande garantit une utilisation organisée selon les modes et les bandes.",
    "points": [
     "Toujours **écouter la fréquence** avant d'émettre pour s'assurer qu'elle est libre.",
     "**Plan de bande** : guide d'utilisation des fréquences selon les modes sur une bande spécifique.",
     "En cas d'occupation habituelle d'une fréquence, demander la permission pour libérer ou déplacer le réseau de **3 à 5 kHz**.",
     "Respecter une séparation minimale d'environ **3 kHz** entre émissions en **phonie en bande latérale unique** pour éviter le brouillage."
    ]
   },
   {
    "title": "Gestion de la puissance et prévention du brouillage",
    "body": "Adaptez la puissance d'émission au minimum nécessaire pour maintenir un contact clair. Utilisez une charge fictive pour syntoniser ou tester votre émetteur afin d'éviter le brouillage sur les fréquences en service.",
    "points": [
     "Si le signal reçu est très fort et lisible, **réduire la puissance de sortie au minimum requis**.",
     "La **charge fictive** permet de régler ou tester l'émetteur sans émettre dans l'air, évitant ainsi le brouillage.",
     "Utiliser une charge fictive pour réduire la durée d'émission lors des tests ou ajustements prolongés.",
     "En cas d'augmentation des interférences sur une fréquence, il faut **changer de fréquence** rapidement."
    ]
   }
  ],
  "B-002-007": [
   {
    "title": "Introduction aux codes Q en radiocommunication",
    "body": "Les codes Q sont des abréviations universelles utilisées en radiocommunication pour transmettre rapidement des messages standards, principalement en code Morse.",
    "points": [
     "Les codes Q facilitent la communication entre radioamateurs à travers le monde.",
     "Ils sont composés de trois lettres commençant toujours par 'Q'.",
     "Chaque code Q a une signification précise et standardisée."
    ]
   },
   {
    "title": "Significations essentielles des codes Q pour l'exploitation Morse",
    "body": "Voici les codes Q fréquents en radiocommunication Morse et leurs significations respectives pour assurer un échange clair et efficace.",
    "points": [
     "**QRS** : Émettez plus lentement pour faciliter la réception.",
     "**QTH** : Indique la position géographique de l'émetteur.",
     "**QRL?** : Question demandant si la fréquence est occupée avant d'émettre.",
     "**QSY** : Demande à changer de fréquence.",
     "**QSB** : Signal signifiant que le signal s'évanouit ou varie en intensité."
    ]
   }
  ],
  "B-002-003": [
   {
    "title": "Procédures de base pour la téléphonie radioamateur",
    "body": "Lors d'un appel général en téléphonie, dites \"CQ\" trois fois, suivi de \"ici\" puis votre indicatif répété trois fois. Pour répondre à ce CQ, énoncez l'indicatif de la station appelante une fois, ajoutez \"ici\", puis votre indicatif en alphabet phonétique.",
    "points": [
     "Lancer un appel: \"CQ CQ CQ\", \"ici\", indicatif trois fois",
     "Répondre à un CQ: indicatif appelé, \"ici\", indicatif en alphabet phonétique",
     "L'utilisation de l'alphabet phonétique garantit la clarté de l'identification"
    ]
   },
   {
    "title": "Communications simplex vs répéteur",
    "body": "La communication en simplex utilise la même fréquence pour émettre et recevoir, idéale quand tous les participants sont à portée directe. Avant d'utiliser un répéteur, vérifiez si une communication simplex fiable est possible pour réduire le trafic et la complexité.",
    "points": [
     "Simplex = fréquence d'émission = fréquence de réception",
     "Utilisez simplex si la communication directe est fiable entre tous",
     "Évitez d'opérer en simplex sur la fréquence d'entrée d'un répéteur pour ne pas perturber son fonctionnement",
     "Vérifiez la possibilité de simplex en écoutant la fréquence d'entrée du répéteur",
     "Si utilisé par inadvertance, changez poliment de fréquence"
    ]
   },
   {
    "title": "Choix des fréquences et bandes latérales en phonie",
    "body": "Pour les communications locales, privilégiez les fréquences VHF/UHF pour réduire le brouillage sur HF, qui est mieux réservé aux communications longue distance. Sur 20 mètres, la bande latérale supérieure est généralement utilisée en phonie, tandis que sur 3755 kHz, on utilise la bande latérale inférieure. Avant de transmettre, écoutez la bande pour vérifier sa disponibilité et la propagation en vous référant à des stations proches de la région cible.",
    "points": [
     "Préférez VHF/UHF pour communications locales, préservent les bandes HF",
     "Bande latérale supérieure (BLU) pour la phonie sur 20 mètres",
     "Bande latérale inférieure (BLB) pour la phonie à 3755 kHz",
     "Écoutez les balises et stations locales avant transmission pour confirmer ouverture de la bande"
    ]
   }
  ],
  "B-002-005": [
   {
    "title": "Appels et réponses en code Morse",
    "body": "Le signal \"CQ\" est un appel général à toutes les stations, annoncé trois fois, suivi de \"DE\" (abréviation signifiant \"De\") et de votre indicatif répété trois fois. Pour répondre à un \"CQ\" en Morse, annoncez deux fois l'indicatif de la station appelante, suivi de \"DE\" et de votre indicatif répété deux fois.",
    "points": [
     "\"CQ\" signifie **appel à toute station à l'écoute**",
     "\"DE\" signifie **de, pour indiquer l'expéditeur**",
     "Appeler en Morse : **\"CQ\" x3 + \"DE\" + indicatif x3**",
     "Répondre : **Indicatif de la station appelante x2 + \"DE\" + votre indicatif x2**"
    ]
   },
   {
    "title": "Vitesse et communication en télégraphie Morse",
    "body": "La vitesse d'émission de l'appel \"CQ\" doit s'adapter à votre capacité : émettez à la vitesse à laquelle vous pouvez confortablement recevoir le Morse. Le code \"K\" invite une autre station à répondre, et l'expression \"73\" signifie \"amitiés\", souvent utilisée en clôture des échanges.",
    "points": [
     "Appeler à une vitesse confortablement reçue",
     "\"K\" = **invitation à répondre**",
     "\"73\" = **amitiés, salutations**",
     "DX = **station éloignée**"
    ]
   },
   {
    "title": "Principes d'exploitation et gestion de fréquence en CW",
    "body": "La télégraphie 'full break-in' (QSK) permet d'entendre le signal entrant entre les éléments du code Morse transmis. Avant d'émettre, il est essentiel d'écouter la fréquence pour s'assurer qu'elle est libre. Il faut aussi laisser un décalage de fréquence entre 150 et 500 Hz pour éviter le brouillage des stations proches.",
    "points": [
     "QSK = **écoute du signal entrant entre points et traits**",
     "Vérifier la fréquence avant d'émettre",
     "Séparations de fréquence : **150 à 500 Hz** pour éviter brouillage"
    ]
   }
  ],
  "B-002-006": [
   {
    "title": "Le rapport de signal RST en radioamateur",
    "body": "Le rapport RST est un code standard utilisé pour décrire la qualité de la réception d'un signal radio. Il se compose de trois chiffres indiquant la lisibilité, la force du signal et la tonalité (pour les transmissions en télégraphie).",
    "points": [
     "**R** = Lisibilité du signal (1 à 5)",
     "**S** = Force du signal (1 à 9)",
     "**T** = Tonalité du signal (1 à 9), utilisé surtout en code Morse",
     "Exemple : RST 5 7 signifie lisibilité parfaite (5) et force modérée (7)"
    ]
   },
   {
    "title": "Interprétation des valeurs RST et lecture du S-mètre",
    "body": "Les chiffres du rapport RST donnent une évaluation rapide et standardisée de la qualité du signal reçu. La lecture du S-mètre indique la force du signal avec S9 comme référence élevée.",
    "points": [
     "Un signal RST 3 3 est faible et difficile à lire",
     "Le rapport 1 1 signifie un signal imperceptible et non lisible",
     "Une augmentation de la puissance de sortie par 4 augmente la lecture S-mètre d'environ 1 unité",
     "Passer de S8 à S9 nécessite à peu près une puissance multipliée par 4",
     "Indiquer +20 dB au-dessus de S9 signifie un signal très fort et excellent"
    ]
   },
   {
    "title": "Considérations pratiques avec les répéteurs",
    "body": "Quand une station éloignée entendue via un répéteur demande un rapport de signal, il faut évaluer la qualité avec laquelle le répéteur reçoit cette station, non pas avec laquelle vous recevez le répéteur.",
    "points": [
     "Le rapport doit refléter la réception au niveau du répéteur",
     "Cela permet à la station éloignée d'ajuster son émission pour être bien reçue au répéteur",
     "Ne pas confondre la réception du répéteur et votre propre réception via le répéteur"
    ]
   }
  ],
  "B-002-008": [
   {
    "title": "Signaux et Priorités en Situation de Détresse",
    "body": "Les signaux de détresse sont utilisés uniquement pour des situations mettant en péril la vie d'une personne. En phonie, répétez clairement **'MAYDAY'** plusieurs fois. En code Morse, le signal universel est **SOS**. Un message de détresse a la priorité la plus haute sur les transmissions radio.",
    "points": [
     "**MAYDAY** : signal vocal de détresse répété plusieurs fois",
     "**SOS** : signal Morse de détresse (· · · – – – · · ·)",
     "Les messages de détresse priment sur tous, y compris les messages d'urgence",
     "Utiliser ces signaux uniquement en cas de danger de vie"
    ]
   },
   {
    "title": "Procédures lors d'un Signal de Détresse",
    "body": "À l'écoute d'un appel de détresse, interrompez toute communication et accusez réception. Si vous ne pouvez aider directement, contactez immédiatement les autorités compétentes et restez à l'écoute.",
    "points": [
     "Interrompre toute conversation pour répondre à un appel de détresse",
     "Informer la station en détresse que son message a été reçu",
     "Collecter les coordonnées et fournir l'assistance possible",
     "Contactez les autorités si vous ne pouvez aider directement",
     "Restez à l'écoute jusqu'à confirmation d'aide"
    ]
   },
   {
    "title": "Équipement et Opérations en Situation d'Urgence",
    "body": "Pour opérer en situation d'urgence, il est essentiel de pouvoir fonctionner sans courant alternatif domestique. Un équipement portatif avec piles rechargées est vital. Pour une station HF portative, une antenne dipôle est pratique et efficace.",
    "points": [
     "Pouvoir opérer sans alimentation secteur en cas d'urgence",
     "Avoir des piles rechargées pour les radios portatives",
     "Antenne dipôle recommandée pour opérations HF portatives",
     "Interrompre les transmissions sur un répéteur pendant une pause pour signaler la détresse"
    ]
   }
  ],
  "B-002-009": [
   {
    "title": "Preuves de communication en radioamateur",
    "body": "La communication entre stations de radioamateurs est confirmée par une preuve écrite appelée \"carte QSL\". Cette carte postale signée contient les détails essentiels du contact radio.",
    "points": [
     "**Carte QSL** : preuve écrite d'une communication entre deux stations",
     "Doit indiquer la **date**, l'**heure** (en UTC), la **fréquence**, le **mode** et la **puissance** utilisée",
     "Les entrées de communications sont souvent consignées dans un **journal de bord**, mais ce n'est pas une obligation réglementaire au Canada"
    ]
   },
   {
    "title": "Orientation des antennes directionnelles et cartes azimutales",
    "body": "Une **carte azimutale** positionne votre localisation au centre, facilitant le calcul du trajet le plus court entre deux points sur la Terre. Elle est utile pour orienter les antennes directionnelles HF.",
    "points": [
     "Carte azimutale = carte centrée sur un point précis (voisine) utilisée pour trouver le plus court chemin (short path)",
     "Avec une antenne directionnelle, le **trajet long** (long path) est à environ **180 degrés** du trajet court (short path)",
     "Si aucun signal n'est entendu sur le trajet court, essayer de pointer l'antenne à 180° pour capter le trajet long"
    ]
   },
   {
    "title": "Temps universel coordonné (UTC) et réglages de la station",
    "body": "Les enregistrements et confirmations de contacts radioamateur doivent être horodatés en **UTC**. Ce temps est mesuré à partir du méridien de Greenwich, en Angleterre. Le réglage précis de l'horloge se fait via les signaux horaires radio CHU, WWV ou WWVH.",
    "points": [
     "UTC = Universal Time Coordinated, anciennement GMT, temps universel basé sur Greenwich",
     "Le méridien de référence pour UTC est celui de **Greenwich, Angleterre**",
     "Pour ajuster son horloge sur UTC, syntoniser les signaux horaires radiodiffusés comme **CHU (Canada)**, **WWV** et **WWVH (USA)**"
    ]
   }
  ],
  "B-003-002": [
   {
    "title": "Schéma fonctionnel d'un émetteur FM",
    "body": "Un émetteur à modulation de fréquence comprend plusieurs étages en série qui traitent le signal vocal jusqu'à sa transmission par l'antenne.",
    "points": [
     "**Microphone** : capte la voix et envoie le signal au préamplificateur.",
     "**Amplificateur microphonique** : amplifie le signal faible du microphone.",
     "**Modulateur** : situé entre l'amplificateur microphonique et l'oscillateur, il module la fréquence en fonction du signal audio."
    ]
   },
   {
    "title": "Chaîne de traitement du signal vers l'antenne",
    "body": "Après la modulation, le signal est transformé en fréquence adéquate et amplifié avant d'être transmis.",
    "points": [
     "**Oscillateur** : placé après le modulateur, il produit la porteuse modulée.",
     "**Multiplicateur de fréquence** : amplifie la fréquence émise par l'oscillateur pour atteindre la bande désirée.",
     "**Amplificateur de puissance** : situé après le multiplicateur de fréquence, il augmente la puissance avant l'émission.",
     "La sortie de l'amplificateur de puissance est connectée directement **à l'antenne** pour transmettre le signal."
    ]
   }
  ],
  "B-003-001": [
   {
    "title": "Filtre Passe-Bas et Harmoniques en HF",
    "body": "Le filtre passe-bas est essentiel pour éliminer les fréquences harmoniques nuisibles. Il doit être placé le plus près possible de la sortie de l'émetteur-récepteur ou de l'amplificateur linéaire pour une efficacité maximale.",
    "points": [
     "**Filtre passe-bas** réduit les fréquences harmoniques indésirables.",
     "Placement optimal : **près de la sortie** de l'émetteur ou de l'amplificateur.",
     "Réduit les interférences et respecte les normes d'émission."
    ]
   },
   {
    "title": "Composants Clés pour l'Adaptation et la Mesure en Station HF",
    "body": "Les appareils d'adaptation d'impédance et de mesure sont cruciaux pour optimiser la station HF. Le bloc d'accord adapte l'impédance entre l'émetteur et l'antenne, tandis que le ROS-mètre évalue l'efficacité du système d'antenne.",
    "points": [
     "Le **bloc d'accord d'antenne** adapte l'impédance entre l'émetteur et l'antenne.",
     "Il est surtout utilisé pour les antennes fonctionnant **en dessous de 14 MHz**.",
     "Le **ROS-mètre** mesure le rapport d'ondes stationnaires pour juger l'efficacité de l'antenne.",
     "Le **commutateur d'antenne** est placé près de l'antenne et du bloc d'accord.",
     "La **charge fictive** est utilisée temporairement pour accorder et tester l'émetteur."
    ]
   }
  ],
  "B-003-004": [
   {
    "title": "Structure de base d'un émetteur CW (ondes entretenues)",
    "body": "Un émetteur CW comprend plusieurs étages : le maître oscillateur, l'étage d'attaque/tampon, l'amplificateur de puissance, et enfin l'antenne.",
    "points": [
     "Le **maître oscillateur** génère la fréquence porteuse initiale.",
     "L'**étage d'attaque / tampon** reçoit la sortie du maître oscillateur et prépare le signal pour l'amplificateur.",
     "L'**amplificateur de puissance** amplifie le signal avant transmission vers l'antenne.",
     "La sortie de l'amplificateur est directement transférée à **l'antenne**."
    ]
   },
   {
    "title": "Alimentation et commande de l'émission",
    "body": "L'émetteur CW utilise un bloc d'alimentation pour fournir le courant continu nécessaire et un manipulateur télégraphique pour contrôler l'émission du signal.",
    "points": [
     "Le **bloc d'alimentation** est la source principale de courant continu pour tous les étages.",
     "Le **manipulateur télégraphique** commande le moment où l'énergie RF est appliquée à l'antenne, permettant de former les signaux Morse."
    ]
   }
  ],
  "B-003-003": [
   {
    "title": "Structure d'un récepteur à modulation de fréquence (FM)",
    "body": "Un récepteur FM est composé de plusieurs étages clés organisés dans un ordre précis pour extraire le signal audio du signal radiofréquence reçu par l'antenne.",
    "points": [
     "**L'antenne** capte le signal radio et le transmet à l'**amplificateur radiofréquence (RF)**.",
     "L'**amplificateur RF** améliore le signal avant qu'il ne passe au **mélangeur**.",
     "La sortie de l'**oscillateur local** est appliquée au **mélangeur** pour convertir la fréquence reçue en fréquence intermédiaire (FI)."
    ]
   },
   {
    "title": "Étages intermédiaires du récepteur FM",
    "body": "Le signal à fréquence intermédiaire est filtré, amplifié, puis limité afin de préparer la démodulation du signal FM.",
    "points": [
     "Le **filtre** est situé entre le mélangeur et l'**amplificateur de fréquence intermédiaire (FI)** pour isoler la fréquence désirée.",
     "L'**amplificateur FI** amplifie le signal filtré pour un traitement optimal.",
     "Le **limiteur** élimine les variations d'amplitude indésirables avant la démodulation."
    ]
   },
   {
    "title": "Extraction et restitution du signal audio",
    "body": "Après traitement du signal FI, le récepteur démodule la fréquence pour récupérer le signal audio, qui est amplifié avant d'être transmis au haut-parleur.",
    "points": [
     "Le **discriminateur de fréquence** démodule le signal FM pour extraire le signal audio.",
     "L'**amplificateur audiofréquence** amplifie le signal audio pour une écoute claire.",
     "Le signal amplifié est transmis au **haut-parleur** ou aux **écouteurs** pour restitution sonore."
    ]
   }
  ],
  "B-003-005": [
   {
    "title": "Structure d'un récepteur CW à bande latérale unique (BLS)",
    "body": "Un récepteur pour ondes entretenues (CW) et bande latérale unique (BLS) utilise plusieurs composants clés reliés dans un ordre précis pour extraire et amplifier le signal voulu.",
    "points": [
     "L'antenne est connectée à l'**amplificateur radiofréquence (RF)** pour capter le signal.",
     "La sortie de l'**amplificateur RF** est reliée au **mélangeur**.",
     "La sortie de l'**oscillateur local** est aussi raccordée au mélangeur pour produire une fréquence intermédiaire (FI)."
    ]
   },
   {
    "title": "Traitement du signal dans le récepteur CW BLS",
    "body": "Après le mélange, le signal à fréquence intermédiaire est filtré, amplifié puis détecté pour recevoir la modulation CW.",
    "points": [
     "Le **filtre** est placé entre le mélangeur et l'**amplificateur de fréquence intermédiaire (FI)** pour sélectionner la bande désirée.",
     "L'amplificateur FI est situé entre le filtre et le **détecteur de produit** qui extrait la modulation.",
     "La sortie de l'**oscillateur de battement** est connectée au détecteur de produit pour produire l'audio."
    ]
   },
   {
    "title": "Amplification et sortie audio",
    "body": "Le signal audio extrait est amplifié pour être audible via des haut-parleurs ou écouteurs.",
    "points": [
     "La sortie du détecteur de produit est raccordée à l'**amplificateur audiofréquence (AF)**.",
     "La sortie de l'amplificateur AF est connectée au **haut-parleur ou aux écouteurs** pour l'écoute."
    ]
   }
  ],
  "B-003-008": [
   {
    "title": "Fonctionnement d'une alimentation stabilisée",
    "body": "Une alimentation stabilisée convertit une tension alternative externe en une tension continue stable grâce à plusieurs étapes clés.",
    "points": [
     "**Entrée** : reçoit la tension depuis une source externe.",
     "**Transformateur** : placé entre l'entrée et le redresseur, il adapte la tension à la valeur souhaitée.",
     "**Redresseur** : convertit la tension alternative en tension continue pulsée."
    ]
   },
   {
    "title": "Filtrage et régulation dans l'alimentation",
    "body": "Après conversion par le redresseur, la tension doit être filtrée puis régulée pour être stable et utilisable.",
    "points": [
     "Le **filtre** suit le redresseur et atténue les ondulations de la tension.",
     "Le **régulateur** reçoit la tension filtrée et la stabilise à une valeur fixe.",
     "La **sortie** de l'alimentation est reliée au régulateur et fournit la tension stable aux équipements."
    ]
   }
  ],
  "B-003-009": [
   {
    "title": "Structure de l'antenne Yagi à 3 éléments",
    "body": "Une antenne Yagi comprend trois types d'éléments : le réflecteur, l'élément alimenté, et le directeur. Ces éléments ont des rôles distincts pour optimiser la réception et la transmission.",
    "points": [
     "Le **réflecteur** est l'élément rayonnant le plus **long**, placé derrière l'élément alimenté.",
     "L'**élément alimenté** est au centre et transmet ou reçoit le signal RF.",
     "Le **directeur** est l'élément rayonnant le plus **court** et est placé devant l'élément alimenté."
    ]
   },
   {
    "title": "Fonction mécanique de l'antenne Yagi",
    "body": "Pour maintenir la structure stable et alignée, un composant mécanique appelé le bras de support ou \"boom\" est utilisé. Il ne contribue pas à la radiation du signal.",
    "points": [
     "Le **bras de support (boom)** sert uniquement à soutenir et aligner les éléments.",
     "Il ne participe pas à l'émission ou la réception radio."
    ]
   }
  ],
  "B-003-007": [
   {
    "title": "Structure d'un système radioamateur numérique",
    "body": "Un système radioamateur numérique comprend plusieurs composants qui sont interconnectés pour transmettre et recevoir des données numériques.",
    "points": [
     "**Ordinateur** : génère et traite les données numériques.",
     "**Modem** : sert d'interface entre l'ordinateur et l'émetteur-récepteur.",
     "**Émetteur-récepteur** : envoie et reçoit les signaux radio."
    ]
   },
   {
    "title": "Connexions entre les composants",
    "body": "Les interfaces entre ces éléments sont cruciales pour un fonctionnement correct du système.",
    "points": [
     "Le **modem** est relié à **l'ordinateur** pour échanger les données numériques.",
     "L'**émetteur-récepteur** est raccordé au **modem** pour envoyer et recevoir les signaux audio-modulés.",
     "Les branchements audio, au niveau de la **carte son** ou du **modem**, sont connectés à l'**émetteur-récepteur**."
    ]
   },
   {
    "title": "Fonction du modem et carte audio",
    "body": "Dans de nombreux systèmes modernes, la fonction de modem est prise en charge par un composant intégré.",
    "points": [
     "La **carte audio** de l'ordinateur peut souvent exécuter la fonction de modem.",
     "Cela simplifie le système en éliminant le besoin d'un modem externe distinct.",
     "L'entrée-sortie audio agit donc comme interface entre l'ordinateur et l'émetteur-récepteur."
    ]
   }
  ],
  "B-003-006": [
   {
    "title": "Architecture d'un émetteur à bande latérale unique (BLU)",
    "body": "Un émetteur BLU utilise plusieurs composants clés reliés dans un ordre précis pour moduler et transmettre un signal radio.",
    "points": [
     "**Microphone** capte la voix et est raccordé à l'**amplificateur microphonique**.",
     "La sortie de l'**amplificateur microphonique** est envoyée au **modulateur équilibré**.",
     "La sortie de l'**oscillateur radiofréquence** va également au **modulateur équilibré**.",
     "Le **modulateur équilibré** génère un signal modulé dont la sortie est connectée au **filtre**."
    ]
   },
   {
    "title": "Traitement du signal et transmission",
    "body": "Après modulation, le signal passe par un filtre puis est transformé et amplifié avant d'être transmis par l'antenne.",
    "points": [
     "Le **filtre** est situé entre le modulateur équilibré et le mélangeur, éliminant une bande latérale.",
     "La sortie de l'**oscillateur à fréquence variable** est reliée au **mélangeur**.",
     "Le **mélangeur** combine les signaux du filtre et de l'oscillateur à fréquence variable.",
     "L'**amplificateur linéaire** se trouve entre le mélangeur et l'antenne, il amplifie le signal final.",
     "La sortie de l'**amplificateur linéaire** est raccordée directement à l'**antenne** pour émission."
    ]
   }
  ],
  "B-003-010": [
   {
    "title": "Modes d'émission et largeur de bande",
    "body": "Les modes d'émission varient en largeur de bande, ce qui impacte la qualité et la quantité d'informations transmises. La largeur de bande détermine aussi la quantité de bruit reçu.",
    "points": [
     "De la largeur de bande la plus étroite à la plus large : **CW** (code Morse), **RTTY**, phonie en **BLU** (bande latérale unique), phonie en **FM**.",
     "Une largeur de bande plus étroite réduit le bruit, favorisant des communications plus claires sur de faibles signaux.",
     "La bande latérale unique (BLU) utilise la suppression de la porteuse, nécessitant un oscillateur de battement (BFO) pour la démodulation."
    ]
   },
   {
    "title": "Sensibilité et sélectivité du récepteur",
    "body": "La sensibilité et la sélectivité sont essentielles pour un récepteur performant, affectant la capacité à recevoir les faibles signaux et à rejeter les interférences.",
    "points": [
     "**Sensibilité** : niveau de signal RF requis à l'entrée pour obtenir un rapport signal sur bruit défini.",
     "Un récepteur moins sensible produit **moins de signal utile** ou **plus de bruit**.",
     "**Sélectivité** : capacité à filtrer les signaux indésirables proches en fréquence.",
     "Utilisation de filtres adaptés (p. ex., coupe-bande pour éliminer une porteuse interfèrente) améliore la réception.",
     "Filtres internes typiques : bande passante de 250 Hz à 6 kHz selon le mode (ex. 250 Hz pour CW, 2,4 kHz pour BLU)."
    ]
   },
   {
    "title": "Fréquence intermédiaire et filtres audio",
    "body": "La fréquence intermédiaire (FI) est fixée pour faciliter la démodulation. Les filtres audio améliorent la réception selon le type de transmission audio.",
    "points": [
     "Calcul FI = |Fréquence de l'oscillateur local - fréquence reçue|. Exemple: 3995 kHz - 3540 kHz = **455 kHz**.",
     "Filtres audio RC, actifs ou passifs permettent d'améliorer la sélectivité audio.",
     "Pour le code Morse (CW), choisir une bande passante audio étroite entre **750 et 850 Hz** pour mieux discriminer le signal.",
     "Pour la BLU, un filtre de **2,4 kHz** est approprié pour ne pas déformer la parole.",
     "Le filtre le plus étroit (250 Hz) est conseillé en présence de brouillage important, notamment pour le code Morse."
    ]
   }
  ],
  "B-003-013": [
   {
    "title": "Modulation de fréquence (FM) en radioamateur",
    "body": "En modulation de fréquence, l'excursion détermine la variation de fréquence autour de la fréquence centrale. En FM, une surexcursion entraîne des émissions hors canal, causant des brouillages aux stations voisines.",
    "points": [
     "L'excursion typique est de +/- **5 kHz**, occupant une bande passante de **10 à 20 kHz**.",
     "Une surexcursion (« overdeviation ») provoque des émissions hors canal et brouille les stations proches.",
     "Le réglage d'excursion trop élevé ou un gain micro trop fort peut causer la distorsion du signal.",
     "En cas de surexcursion, il est recommandé d'**éloigner le microphone** de la bouche pour réduire l'excursion."
    ]
   },
   {
    "title": "Caractéristiques et précautions en émission FM",
    "body": "Le mode FM est idéal pour les communications locales en UHF/VHF grâce à sa résistance au bruit. Cependant, il n'est pas adapté aux fréquences inférieures à 28 MHz car sa bande passante dépasse les limites réglementaires.",
    "points": [
     "La FM produit une meilleure qualité audio grâce à un bon rapport signal/bruit à faibles signaux RF.",
     "En l'absence d'entrée micro, l'émetteur FM émet une **porteuse non modulée**.",
     "En FM, l'émetteur modulé par un modulateur à réactance produit une **modulation de phase**.",
     "Les récepteurs FM subissent l'**effet de capture** : seul le signal le plus fort est démodulé lorsqu'il y a plusieurs signaux simultanés."
    ]
   }
  ],
  "B-003-011": [
   {
    "title": "Stabilité et fonctionnement d'un émetteur CW",
    "body": "Un émetteur CW utilise un oscillateur à fréquence variable connecté à un amplificateur de puissance via un étage tampon. La stabilité de l'oscillateur est cruciale pour éviter la dérive en fréquence.",
    "points": [
     "Un oscillateur RF à fréquence variable est la base de l'émetteur CW.",
     "Un étage tampon protège l'oscillateur des charges variables.",
     "La stabilité électrique et mécanique prévient la dérive en fréquence, assurant une émission précise."
    ]
   },
   {
    "title": "Modulation, pépiement et transmission du code Morse",
    "body": "La modulation en amplitude (AM) consiste à varier l'amplitude de la porteuse RF en fonction du signal audio. Le code Morse est transmis par une porteuse interrompue, ce qui peut engendrer le pépiement (chirp), un changement de fréquence lors des manipulations de la porteuse.",
    "points": [
     "La modulation en amplitude varie l'amplitude instantanée (enveloppe) du signal RF.",
     "Le code Morse utilise une porteuse interrompue pour transmettre l'information.",
     "Le pépiement (chirp) est un léger changement de fréquence lors de la manipulation de la porteuse.",
     "Pour éviter le pépiement, la tension d'alimentation doit rester très stable lors de l'émission."
    ]
   },
   {
    "title": "Adaptation d'impédance et dissipation de puissance",
    "body": "Une bonne adaptation d'impédance entre l'émetteur et l'antenne est essentielle pour transférer efficacement la puissance. Une mauvaise adaptation entraîne une baisse du rayonnement et dissipation de puissance en chaleur dans l'émetteur.",
    "points": [
     "Une ligne ou antenne mal adaptée empêche la transmission de la pleine puissance à l'antenne.",
     "Un défaut d'adaptation entraîne une diminution du rayonnement de l'antenne.",
     "La différence entre la puissance d'entrée et de sortie de l'amplificateur est dissipée en chaleur.",
     "Par exemple, une entrée de 200W et une sortie de 125W signifient 75W dissipés en chaleur."
    ]
   }
  ],
  "B-003-012": [
   {
    "title": "Modulation en BLU et réglages essentiels",
    "body": "En modulation à bande latérale unique (BLU), l'onde porteuse est supprimée pour concentrer la puissance sur les bandes latérales contenant l'information. Un modulateur équilibré supprime l'onde porteuse tout en laissant passer les deux bandes latérales. La porteuse est réintroduite dans le récepteur pour la démodulation correcte.",
    "points": [
     "**Modulateur équilibré** : supprime l'onde porteuse et laisse passer les 2 bandes latérales",
     "Onde porteuse dans BLU : absente lors de l'émission, réinsérée au récepteur",
     "Suppression de la porteuse permet d'**utiliser efficacement la puissance** amplifiée",
     "Largeur de bande BLU typique : **2 à 3 kHz**"
    ]
   },
   {
    "title": "Réglages des niveaux et effets de la surmodulation",
    "body": "Le gain de l'amplificateur microphonique doit être ajusté pour que la commande automatique de niveau (ALC) indique une légère activation aux crêtes de modulation afin d'éviter la surmodulation. Un gain ou traitement excessif du processeur de voix produit une distorsion qui peut brouiller les stations voisines.",
    "points": [
     "Ajuster le gain microphonique pour que l'**ALC bouge légèrement aux crêtes**",
     "Un gain trop élevé ou processeur voix excessif provoque **distorsion** et brouillage des canaux adjacents",
     "Surmodulation entraîne une distorsion et une **augmentation de la largeur de bande**",
     "ALC contrôle les crêtes du signal audio pour protéger l'amplificateur de puissance"
    ]
   },
   {
    "title": "Puissance RF et filtres dans les émetteurs BLU",
    "body": "La puissance en crête de modulation est la puissance moyenne mesurée au sommet de l'enveloppe modulée au connecteur d'antenne. Un filtre reçoit les signaux du modulateur équilibré et les transmet au mélangeur dans un émetteur BLU, assurant la sélectivité des bandes latérales.",
    "points": [
     "Puissance en crête de modulation : puissance moyenne au sommet de l'enveloppe modulée",
     "Le **filtre** reçoit les signaux du modulateur équilibré et les envoie au mélangeur",
     "Suppression de la porteuse permet d'augmenter la puissance envoyée dans les bandes latérales"
    ]
   }
  ],
  "B-003-015": [
   {
    "title": "Radiocommunications par paquets et protocoles AX.25",
    "body": "La communication par paquets utilise le protocole AX.25 pour transmettre des données entre stations. Une station connectée transmet des données à une seule station réceptrice qui accuse réception, alors qu'en mode monitoring la station écoute sans envoyer d'accusé.",
    "points": [
     "**Connected**: envoi de données à une station avec accusé de réception",
     "**Monitoring**: écoute passive, pas d'accusé de réception",
     "Un **digipeater** est une station qui retransmet uniquement les données marquées pour retransmission",
     "Un **réseau** relie plusieurs stations pour étendre la portée des communications"
    ]
   },
   {
    "title": "Matériel et modulation en radiocommunications numériques",
    "body": "Le contrôleur de nœud terminal (TNC) est l'équipement clé reliant un émetteur-récepteur, un ordinateur et parfois un récepteur GPS. Pour moduler un émetteur-récepteur 2 mètres FM en mode paquets, on connecte le TNC à l'entrée microphone de l'appareil.",
    "points": [
     "Le **TNC** interface ordinateur et émetteur-récepteur en protocole AX.25",
     "Environ **250 à 500 Hz** de décalage entre fréquences en RTTY pour éviter le brouillage",
     "Les émissions numériques utilisent des signaux appelés **travail et repos** pour coder les bits 1 et 0"
    ]
   },
   {
    "title": "Modes de transmission et précautions techniques",
    "body": "Le système AMTOR utilise deux modes, dont le mode A à ARQ pour les communications établies. Un niveau audio trop élevé vers l’émetteur-récepteur provoque un élargissement des bandes latérales, nuisant à la qualité et au respect du canal.",
    "points": [
     "Le mode **ARQ** (Automatic Repeat Request) est utilisé pour assurer une communication fiable",
     "Un niveau audio trop élevé cause du **splatter** (émissions hors canal)",
     "Le terme **Baudot** n'est pas utilisé en radiocommunication par paquets"
    ]
   }
  ],
  "B-003-014": [
   {
    "title": "Matériel pour l'émission radioamateur",
    "body": "Pour émettre en téléphonie, le microphone doit être directement branché à l'émetteur-récepteur. En code Morse, de nombreux radioamateurs utilisent un manipulateur électronique pour une émission satisfaisante.",
    "points": [
     "Le microphone sert à moduler l'émetteur en téléphonie.",
     "Un manipulateur électronique active l'émission en code Morse.",
     "Certains haut-parleurs peuvent être utilisés comme microphones dynamiques."
    ]
   },
   {
    "title": "Fonctions et dispositifs de station",
    "body": "Un circuit VOX (Voice Operated eXchange) active automatiquement l'émetteur quand on parle au microphone. Lors du passage de réception à émission, il est essentiel de désactiver le récepteur pour éviter les interférences. Un commutateur d'antenne permet d'utiliser une seule antenne pour l'émetteur et le récepteur tout en désactivant l'appareil non utilisé.",
    "points": [
     "Le circuit VOX active l'émetteur automatiquement à la voix.",
     "Le commutateur d'antenne sélectionne l'antenne unique pour émettre ou recevoir.",
     "Lors du switch émission/réception, désactiver le récepteur évite les perturbations.",
     "Le commutateur empêche la coexistence de deux appareils sur la même antenne."
    ]
   },
   {
    "title": "Sécurité et traitement audio en BLU",
    "body": "Une antenne fictive dissipe la puissance RF en chaleur, c'est pourquoi elle peut chauffer. En BLU (bande latérale unique), un processeur de voix bien ajusté améliore l'intelligibilité sans augmenter la puissance de crête de modulation (PEP).",
    "points": [
     "L'antenne fictive transforme l'énergie RF en chaleur, causant de la chauffe.",
     "Un processeur de voix bien réglé améliore la clarté du signal vocal en BLU.",
     "Le processeur n'augmente pas la puissance en crête (PEP) lors d'une modulation 100%."
    ]
   }
  ],
  "B-003-016": [
   {
    "title": "Notions de Base sur les Batteries et Piles",
    "body": "Les batteries et piles fournissent une tension électrique pour alimenter la station radio. Elles possèdent un pôle positif et un pôle négatif. Une pile ordinaire a une tension nominale d'environ 1,5 V, tandis qu'une batterie ordinaire d'automobile fournit environ 12 V.",
    "points": [
     "**Batterie** : a un pôle **positif** et un pôle **négatif**.",
     "**Batterie automobile** : fournit environ **12 volts**.",
     "**Pile alcaline** : tension nominale de **1,5 volt**."
    ]
   },
   {
    "title": "Différences entre Piles et Accumulateurs",
    "body": "Une pile primaire ne peut pas être rechargée (ex : pile carbone-zinc). Un accumulateur ou batterie rechargeable, comme une batterie au plomb ou lithium-ion, peut être rechargée plusieurs fois.",
    "points": [
     "**Pile primaire (ex carbone-zinc)** : jamais rechargeable.",
     "Un **accumulateur** (batterie rechargeable) peut être rechargé plusieurs fois.",
     "Exemple d'accumulateur : **batterie lithium-ion**, batterie au plomb."
    ]
   },
   {
    "title": "Comportement Électrique et Sécurité des Batteries",
    "body": "Les piles ont une résistance interne qui fait chuter leur tension sous charge élevée. La capacité de la batterie dépend du courant puisé. Pour adapter la tension ou le courant, on peut associer plusieurs piles en série ou en parallèle. La batterie lithium-ion doit être manipulée avec précaution et jamais court-circuitée.",
    "points": [
     "**Résistance interne** cause une chute de tension sous forte charge (ex : pile alcaline passe de 1,5 V à 1,2 V).",
     "Capacité de la batterie dépend du courant et du temps ; dépasser le courant réduit l'autonomie.",
     "Augmenter le **courant** en connectant les piles **en parallèle**.",
     "Augmenter la **tension** en connectant les piles **en série**.",
     "Batterie **lithium-ion** ne doit jamais être **court-circuitée**."
    ]
   }
  ],
  "B-003-021": [
   {
    "title": "Sécurité et précautions avec les antennes UHF et micro-ondes",
    "body": "Lors de l'utilisation des antennes en UHF et micro-ondes, il est essentiel de garder l'antenne éloignée de votre tête et de votre regard pour limiter l'exposition aux rayonnements RF.",
    "points": [
     "Tenir l'antenne lontaine des yeux lorsque vous émettez en UHF ou micro-ondes.",
     "Éloigner l'antenne portative de la tête et des autres personnes pendant l'émission.",
     "Les tissus humains chauffent sous l'effet de l'exposition aux fréquences RF, particulièrement les yeux."
    ]
   },
   {
    "title": "Installation, manipulation et emplacement des antennes",
    "body": "Pour garantir la sécurité lors de l'érection et de l'utilisation des antennes, il faut s'assurer de leur emplacement et des précautions contre le contact accidentel aux sources RF.",
    "points": [
     "Installer les antennes là où personne n'a accès pendant l'émission.",
     "Positionner les antennes dipôles le plus haut possible pour éviter le contact.",
     "Les antennes directionnelles à gain élevé doivent être placées au-dessus des édifices pour minimiser l'exposition des habitants.",
     "Installer les antennes intérieures loin des espaces occupés pendant l'émission.",
     "Lorsque vous travaillez sur un amplificateur UHF, assurez-vous que personne ne puisse l'alimenter accidentellement."
    ]
   }
  ],
  "B-003-018": [
   {
    "title": "Sécurité d'assemblage et d'utilisation des équipements radio",
    "body": "Pour éviter l'utilisation non autorisée de votre émetteur, il est crucial de contrôler l'accès à l'alimentation électrique. Des dispositifs simples comme un interrupteur à clé ou retirer le microphone protègent efficacement vos équipements fixes ou mobiles.",
    "points": [
     "Installer un **interrupteur à clé** dans l'alimentation de l'émetteur empêche l'usage non autorisé.",
     "Retirer le **microphone** dans un émetteur mobile (ex: voiture) évite son usage par d'autres.",
     "Un interrupteur à clé protège aussi contre toute utilisation accidentelle ou involontaire."
    ]
   },
   {
    "title": "Précautions électriques pour la sécurité personnelle",
    "body": "Le courant électrique, même de faible intensité, peut être mortel. Il faut toujours couper l’alimentation avant toute intervention et ne jamais travailler sur un équipement sous tension pour éviter les risques d’électrocution.",
    "points": [
     "Un courant aussi faible que **20 mA** peut être fatal, principalement en affectant le **cœur**.",
     "Une tension à partir de **30 volts** est considérée **dangereuse** pour l’humain.",
     "Les blocs d'alimentation haute tension doivent couper automatiquement le courant lorsque le cabinet est ouvert.",
     "Avant toute réparation, **mettre hors tension** et **débrancher** le cordon d’alimentation est indispensable.",
     "Ne pas chercher à localiser un défaut sur un bloc sous tension pour éviter des décharges électriques graves."
    ]
   },
   {
    "title": "Intervention d’urgence en cas de choc électrique",
    "body": "En présence d'une personne touchée par une source haute tension, il est essentiel d'agir en coupant l'alimentation avant de déplacer la victime et de solliciter l'aide d'urgence.",
    "points": [
     "Couper l'alimentation électrique avant d’éloigner la victime pour éviter de recevoir le choc.",
     "Appeler immédiatement les services d'urgence spécialisés.",
     "Administrez les premiers soins seulement si vous êtes formé et que la situation est sécurisée."
    ]
   }
  ],
  "B-003-020": [
   {
    "title": "Protection contre la foudre et installation du parafoudre",
    "body": "La foudre représente un danger majeur pour les stations radioamateurs. Il est crucial de relier à la terre les antennes et câbles pour minimiser les risques. L'installation d'un parafoudre doit se faire aussi près que possible de la prise de terre extérieure pour protéger efficacement l'équipement.",
    "points": [
     "Relier antennes et câble rotateur à la terre quand la station n'est pas utilisée protège l'équipement et le bâtiment des dégâts causés par la foudre.",
     "Installer le parafoudre à l'extérieur, proche de la prise de terre, permet de dévier les surtensions dangereuses loin des appareils.",
     "Débrancher les lignes de transmission et l'alimentation électrique lors d'orages protège la station contre les dégâts électriques."
    ]
   },
   {
    "title": "Sécurité lors du travail en hauteur et autour des antennes",
    "body": "Le travail sur tour ou pylône nécessite le port d'équipement de sécurité conforme pour éviter les chutes. Port du casque obligatoire au sol pour se protéger des objets pouvant tomber. Les antennes et lignes doivent être installées suffisamment haut pour éviter tout contact direct qui peut provoquer des brûlures dues à l'énergie RF.",
    "points": [
     "Porter un équipement anti-chute approuvé pour prévenir les chutes dangereuses en hauteur.",
     "Port du casque de sécurité au sol pour se protéger contre la chute d'objets.",
     "Positionner les antennes à une hauteur où personne ne peut les toucher lors de l'émission afin d'éviter les brûlures RF.",
     "Ne jamais laisser quelqu'un toucher une ligne ouverte (en échelle) sous émission pour éviter les brûlures électriques."
    ]
   },
   {
    "title": "Précautions pratiques lors de l'installation et réparation d'antennes",
    "body": "Avant toute intervention sur une antenne, s'assurer que l'émetteur est hors tension et que la ligne est débranchée. Installer les antennes de façon à ce que personne ne puisse toucher les parties actives, même au sol, pour prévenir les accidents.",
    "points": [
     "Couper l'émetteur et débrancher la ligne de transmission avant toute réparation d'antenne.",
     "S'assurer qu'aucune personne ne peut toucher une antenne au sol lors de son installation.",
     "Sécurité et prévention d'accidents sont indispensables pour toute manipulation d'antennes."
    ]
   }
  ],
  "B-004-001": [
   {
    "title": "Fonction et rôle des amplificateurs",
    "body": "Un amplificateur est un circuit conçu pour augmenter le niveau du signal d'entrée, pouvant être en tension, courant ou puissance. Cette augmentation de signal s'appelle le gain, généralement exprimé en décibels (dB).",
    "points": [
     "**Amplificateur** : élève le niveau du signal d'entrée",
     "Gain = augmentation du signal, exprimé en **dB**",
     "Amplificateurs peuvent augmenter : **tension, courant, puissance**",
     "Un circuit sans amplification est une : **résistance**, qui ne modifie pas le niveau du signal"
    ]
   },
   {
    "title": "Types et caractéristiques des amplificateurs",
    "body": "Selon l'application, on utilise différents types d'amplificateurs, par exemple RF pour les signaux radio faibles et audio pour les signaux du microphone. La bande passante de l'amplificateur audio microphonique est typiquement de 300 à 3000 Hz.",
    "points": [
     "Amplificateur **RF** : amplifie les signaux radio faibles reçus par l'antenne",
     "Amplificateur **audio** : amplifie les signaux faibles d'un microphone",
     "Bande passante courante pour amplificateur audio microphonique : **300 à 3000 Hz**"
    ]
   },
   {
    "title": "Comportement non linéaire et propriétés clés",
    "body": "Un amplificateur idéal est linéaire; si la linéarité est perdue, le signal de sortie est affecté par la distorsion. Un amplificateur ne crée pas de perte, au contraire, il augmente la puissance ou tension du signal.",
    "points": [
     "Amplificateur **linéaire** : conserve la forme du signal",
     "Non-linéarité entraîne **distorsion** du signal de sortie",
     "Un amplificateur ne génère pas de **perte**",
     "Un amplificateur avec un gain de 10 dB signifie que le signal est amplifié d'un facteur correspondant"
    ]
   }
  ],
  "B-004-003": [
   {
    "title": "Introduction au transistor bipolaire",
    "body": "Le transistor est un semi-conducteur utilisé pour amplifier un signal faible en un signal de niveau plus élevé. Il possède trois bornes principales qui s'appellent le collecteur, l'émetteur et la base.",
    "points": [
     "**Transistor** : composant semi-conducteur amplificateur",
     "Trois bornes : **collecteur**, **émetteur**, **base**",
     "Amplification : signal faible en entrée, signal renforcé en sortie",
     "Deux types fondamentaux : **NPN** et **PNP**"
    ]
   },
   {
    "title": "Fonctionnement et caractéristiques du transistor",
    "body": "La base contrôle le courant entre le collecteur et l'émetteur, jouant un rôle similaire à la grille dans une triode à vide. Le transistor PNP est souvent utilisé pour amplifier des signaux avec un courant de base faible. Un excès de chaleur peut endommager un transistor.",
    "points": [
     "**Base** : commande le flux de courant (similaire à la grille d'une triode)",
     "**Collecteur** : similaire à l'anode d'une triode",
     "**Émetteur** : similaire à la cathode d'une triode",
     "**Transistor PNP** : amplification avec faible tension/base",
     "Protection : éviter un excès de chaleur pour ne pas détruire le transistor"
    ]
   }
  ],
  "B-004-002": [
   {
    "title": "Fonctionnement de la diode à semi-conducteur",
    "body": "Une diode est un composant électronique avec deux électrodes, l'anode et la cathode. Elle laisse passer le courant principalement dans un sens, de l'anode vers la cathode, quand elle est en polarisation directe.",
    "points": [
     "Les électrodes d'une diode sont l'**anode** et la **cathode**.",
     "Le courant circule de la **cathode vers l'anode** à l'intérieur de la diode, mais la diode conduit de l'**anode vers la cathode**.",
     "Pour qu'une diode conduise, elle doit être en **polarisation directe** (anode positive par rapport à la cathode)."
    ]
   },
   {
    "title": "Applications principales des diodes",
    "body": "Les diodes ont plusieurs fonctions dans les circuits radios et électroniques. Elles redressent le courant alternatif en courant continu, effectuent la démodulation des signaux, et certaines spéciales, comme les diodes Zener et électroluminescentes, ont des usages spécifiques.",
    "points": [
     "Le passage du courant alternatif au courant continu s'appelle le **redressement**.",
     "La récupération de l'information dans un signal modulé par une diode s'appelle la **démodulation**.",
     "Une **diode électroluminescente (DEL)** émet de la lumière de différentes couleurs selon sa composition chimique.",
     "Les **diodes Zener** sont utilisées pour **réguler la tension**, en maintenant une tension constante dans un circuit."
    ]
   }
  ],
  "B-003-017": [
   {
    "title": "Bloc d'alimentation et conversion du courant",
    "body": "Le bloc d'alimentation convertit le courant alternatif domestique en courant continu à la tension adaptée (souvent 12 V). Il doit fournir un courant suffisant pour l'émetteur-récepteur, souvent plusieurs ampères, et être équipé de composants comme des diodes pour redresser le courant.",
    "points": [
     "Le courant domestique est en général de **120 V ou 240 V AC**.",
     "Un bloc d'alimentation convertit ce AC en **courant continu (DC)** à une tension plus basse, typiquement **12 V DC**.",
     "Une diode dans le bloc permet le passage des électrons de la cathode à l'anode, réalisant la conversion AC vers DC pulsatif.",
     "Un émetteur-récepteur nécessite un bloc d'alimentation capable de délivrer un **fort courant** (par exemple, 5 A ou plus)."
    ]
   },
   {
    "title": "Protection, pertes, et problèmes liés à l'alimentation",
    "body": "La qualité du bloc d'alimentation impacte la stabilité du signal. Un condensateur de filtrage inadéquat peut causer un bourdonnement (« hum »). Il faut également protéger les circuits avec des fusibles proches de la batterie et choisir le bon calibre de fil pour limiter la chute de tension.",
    "points": [
     "Un condensateur de filtrage inadéquat dans le bloc d'alimentation provoque souvent un **bourdonnement 60 Hz** sur le signal.",
     "Des **fusibles** près de la batterie protègent contre les surintensités pouvant causer des incendies.",
     "Pour une intensité de 22 A, et une chute maximale de **0,5 V** sur 3 m, le fil doit être au moins du **numéro 10** (0,07 V/m).",
     "La chute de tension doit être minimisée pour assurer un fonctionnement optimal de l’émetteur."
    ]
   }
  ],
  "B-004-004": [
   {
    "title": "Introduction aux transistors à effet de champ (FET)",
    "body": "Le transistor à effet de champ (FET) est un semi-conducteur avec trois bornes : la porte, la source et le drain. Son fonctionnement est similaire à une triode à vide.",
    "points": [
     "Le FET contrôle le courant par la tension appliquée à la **porte**.",
     "Les porteurs de charge entrent par la **source** et sortent par le **drain**.",
     "Il existe deux types principaux de FET : à **canal N** et à **canal P**."
    ]
   },
   {
    "title": "Fonction et analogies des bornes du FET",
    "body": "Chaque borne du FET a un rôle précis, souvent comparable à celles du transistor bipolaire.",
    "points": [
     "La **porte** commande la conductance du canal du transistor.",
     "La **source** correspond à l'**émetteur** du transistor bipolaire (entrée des porteurs).",
     "Le **drain** correspond au **collecteur** du transistor bipolaire (sortie des porteurs).",
     "La source et le drain présentent des caractéristiques similaires."
    ]
   },
   {
    "title": "Contrôle du courant dans un transistor à effet de champ",
    "body": "Le courant dans un FET peut être modulé en ajustant la tension sur la porte.",
    "points": [
     "Augmenter la tension de polarisation inverse sur la porte diminue la circulation du courant.",
     "Le FET fonctionne principalement en modulant la conductance par la tension de la porte, pas par un courant comme dans le transistor bipolaire."
    ]
   }
  ],
  "B-003-019": [
   {
    "title": "Mise à la terre et sécurité électrique en station radioamateur",
    "body": "Pour assurer une protection efficace contre les décharges électriques, tous les appareils de la station doivent être reliés à une mise à la terre adéquate, généralement conforme au code de l'électricité en vigueur. Pour cela, une tige d'acier recouverte de cuivre plantée dans le sol est le meilleur choix. En l'absence d'un système de terre spécifique, une conduite d'eau froide métallique peut servir de point de terre de rechange.",
    "points": [
     "**Tous les appareils** doivent être reliés à une **mise à la terre** pour la sécurité",
     "**Tige d'acier recouverte de cuivre** est le meilleur matériau pour la mise à la terre",
     "Si possible, respecter la **longueur et normes** du code électrique local",
     "Une **conduite d'eau froide en métal** peut servir de mise à la terre de rechange"
    ]
   },
   {
    "title": "Connexions et prévention des risques RF",
    "body": "Le fil vert de mise à la terre dans un cordon à trois fils doit être relié au châssis métallique de l'équipement afin d'éviter qu'il ne prenne un potentiel dangereux. Pour limiter les dangers de brûlures RF et les «hot spots», le fil de mise à la terre doit être aussi court que possible, car un fil long présente une réactance élevée et peut agir comme une antenne.",
    "points": [
     "Le fil de mise à la terre (vert) est toujours raccordé au **châssis métallique**",
     "Un fil de terre long (ex. 10 m) peut agir comme une antenne, générant des **tensions RF parasites**",
     "Pour **prévenir l'énergie RF parasite**, garder la mise à terre **la plus courte possible**",
     "Le châssis relié à la terre évite l'élévation du potentiel en cas de défaut"
    ]
   }
  ],
  "B-004-005": [
   {
    "title": "Fonctionnement et composants d'une triode à vide",
    "body": "Une triode à vide est un composant électronique qui amplifie des signaux en utilisant le mouvement des électrons dans un espace vidé d'air. Elle est composée de trois électrodes principales : le filament, la grille et la plaque.",
    "points": [
     "**Triode** contient un **vide** à l'intérieur pour permettre le libre déplacement des électrons.",
     "Le **filament** (chauffage) est l'électrode la plus éloignée de l'anode et chauffe la cathode pour émettre des électrons.",
     "La **cathode** est l'électrode qui émet les électrons lorsqu'elle est chauffée.",
     "La **grille** est une électrode en forme de treillis métallique qui contrôle le flux des électrons entre cathode et plaque.",
     "La **plaque** (anode) porte le potentiel positif le plus élevé et collecte les électrons."
    ]
   },
   {
    "title": "Propriétés et utilisations des triodes comparées aux transistors",
    "body": "Les triodes peuvent amplifier des signaux faibles mais nécessitent généralement un haut voltage pour fonctionner. Elles peuvent parfois supporter des puissances plus élevées que les transistors.",
    "points": [
     "Les triodes et les transistors ont la capacité commune d'**amplifier des signaux**.",
     "Les triodes utilisent un **haut voltage** pour opérer efficacement.",
     "Elles peuvent être avantageuses dans les circuits haute puissance, où les transistors ne seraient pas adaptés.",
     "Une triode à un seul **filtre de contrôle** appelé la grille, contrairement à des tubes plus complexes."
    ]
   }
  ],
  "B-004-006": [
   {
    "title": "Lecture et interprétation du code de couleur des résistances",
    "body": "Les résistances utilisent un code de couleur pour indiquer leur valeur nominale et leur tolérance. Les trois premières bandes indiquent la valeur en ohms, tandis qu'une quatrième bande optionnelle indique la tolérance.",
    "points": [
     "**Trois premières bandes**: Premier chiffre, deuxième chiffre, puis multiplicateur (puissance de 10).",
     "Exemple: rouge(2), violet(7), jaune(4) signifie 27 × 10⁴ = **270 000 ohms (270 kΩ)**.",
     "**Quatrième bande**: tolérance, par exemple or = **±5%**, argent = ±10%, aucun anneau = ±20%.",
     "La bande de tolérance est essentielle pour connaître la précision de la résistance."
    ]
   },
   {
    "title": "Tolérance et efficacité dans les projets électroniques",
    "body": "La tolérance représente la variation maximale admissible de la résistance par rapport à sa valeur nominale. Choisir la tolérance adéquate dépend de l’application.",
    "points": [
     "Tolérance de **0,1%** pour des diviseurs de tension précis et stables.",
     "Tolérance plus large (**20%**) acceptée pour des composants comme les résistances d’alimentation de LED où la précision est moins critique.",
     "Par exemple, une résistance de **100 ohms ±10%** peut varier entre **90 et 110 ohms**.",
     "Le coefficient de température influence la valeur de résistance selon la température ambiante, notamment pour les résistances au carbone."
    ]
   }
  ],
  "B-005-002": [
   {
    "title": "Conducteurs et isolants électriques",
    "body": "Les matériaux électriques se classent selon leur capacité à laisser passer le courant. Les conducteurs facilitent le passage du courant tandis que les isolants l'empêchent.",
    "points": [
     "**Or, argent, aluminium** et **cuivre** sont d'excellents conducteurs électriques.",
     "Les isolants courants sont le **verre**, l'**air**, le **plastique** et la **porcelaine**.",
     "Un conducteur a une **faible résistance**, facilitant le passage du courant.",
     "Un isolant possède une résistance très élevée, empêchant le flux électrique."
    ]
   },
   {
    "title": "Résistance et conductance",
    "body": "La résistance mesure la difficulté pour un courant électrique de passer dans un circuit; son symbole est **R**. Son inverse est la conductance, qui mesure la facilité du passage du courant.",
    "points": [
     "La résistance est symbolisée par la lettre **R**.",
     "La conductance est l'inverse de la résistance.",
     "Les résistances sont souvent faites de **carbone**.",
     "La résistance varie selon la **température** du conducteur."
    ]
   },
   {
    "title": "Dissipation d'énergie et chute de tension",
    "body": "Lorsqu'un courant traverse une résistance, une partie de l'énergie électrique se transforme en chaleur, ce qui peut faire chauffer la résistance. La chute de tension est la tension qui apparaît aux bornes d'un composant.",
    "points": [
     "Une résistance peut devenir chaude car elle dissipe de l'énergie électrique en **chaleur**.",
     "La chute de tension est la tension aux bornes d'un composant dans un circuit.",
     "Cette chute correspond à la perte d'énergie électrique due à la résistance."
    ]
   }
  ],
  "B-005-001": [
   {
    "title": "Unités électriques et conversions de base",
    "body": "Les unités électriques courantes comprennent le volt, l'ampère, le ohm, le hertz, le farad, et le henry. Les multiples et sous-multiples sont essentiels pour exprimer correctement les valeurs.",
    "points": [
     "**1 kilo (k)** = 1 000 unités (ex. 1 kΩ = 1 000 Ω, 1 kV = 1 000 V)",
     "**1 méga (M)** = 1 000 000 unités (ex. 1 MHz = 1 000 kHz)",
     "**1 milli (m)** = 0,001 unités (ex. 1 mA = 0,001 A, 1 mV = 0,001 V)",
     "**1 micro (μ)** = 0,000001 unités (ex. 1 μF = 0,000001 F)",
     "**1 pico (p)** = 0,000000000001 unités (ex. 1 000 000 pF = 1 μF)"
    ]
   },
   {
    "title": "Conversions pratiques d'unités",
    "body": "Il est important de pouvoir convertir rapidement entre différentes unités pour comprendre et manipuler les mesures électriques.",
    "points": [
     "3 525 MHz = 3 525 000 kHz, donc à l’échelle simplifiée on considère 3 525 MHz = **3 525 kHz** (attention unité ici correspond au contexte de cadran qui indique en kHz).",
     "3 000 mA = 3 A (puisque 1 000 mA = 1 A), donc la lecture d’un ampèremètre en ampères sera **3 ampères**.",
     "3 500 mV = 3,5 V (1 000 mV = 1 V).",
     "1 000 000 pF = 1 μF (pF à μF : diviser par 1 000 000).",
     "500 mW = 0,5 W (1 000 mW = 1 W)."
    ]
   }
  ],
  "B-005-003": [
   {
    "title": "Comprendre la Puissance Électrique",
    "body": "La puissance électrique est la rapidité avec laquelle l'énergie électrique est utilisée dans un circuit. Elle s'exprime en watts (W) et se calcule en multipliant la tension (en volts) par le courant (en ampères).",
    "points": [
     "**Puissance (W)** = **Tension (V)** × **Courant (A)**",
     "Le watt est l'unité de mesure de la puissance électrique",
     "Une ampoule à plus haut wattage consomme plus d'électricité"
    ]
   },
   {
    "title": "Types de Circuits Électriques",
    "body": "Un circuit ouvert ne permet aucun passage de courant, tandis qu'un court-circuit laisse passer trop de courant, ce qui peut être dangereux et endommager les composants.",
    "points": [
     "Circuit ouvert = pas de courant",
     "Court-circuit = courant excessif",
     "Les courts-circuits provoquent souvent une surchauffe"
    ]
   },
   {
    "title": "Résistances et Dissipation de Puissance",
    "body": "Les résistances dissipe de la puissance sous forme de chaleur. Les résistances de puissance plus élevée sont plus grosses et utilisent des fils plus épais pour évacuer la chaleur plus efficacement et éviter qu'elles brûlent.",
    "points": [
     "Une résistance qui chauffe trop dissipe trop de puissance",
     "Une résistance de forte puissance est plus grande avec des fils à gros diamètre",
     "Une résistance de 20 watts peut dissiper plus de chaleur qu'une de plus faible puissance"
    ]
   }
  ],
  "B-005-004": [
   {
    "title": "Loi d'Ohm : Principes de base",
    "body": "La loi d'Ohm est fondamentale pour comprendre les relations entre voltage, courant et résistance dans un circuit à courant continu.",
    "points": [
     "La relation s'exprime par la formule : **E = I × R** (Voltage = Courant × Résistance).",
     "Le courant se calcule par : **I = E / R** (Courant = Voltage divisé par Résistance).",
     "La résistance s'obtient par : **R = E / I** (Résistance = Voltage divisé par Courant).",
     "Les unités utilisées sont : Voltage en **volts (V)**, courant en **ampères (A)**, résistance en **ohms (Ω)**."
    ]
   },
   {
    "title": "Applications pratiques de la loi d'Ohm",
    "body": "Utilisez les formules pour déterminer voltage, courant ou résistance selon les valeurs connues dans un circuit électrique.",
    "points": [
     "Exemple : Un courant de **2 A** traversant une résistance de **50 Ω** produit une tension de **100 V** (E = 2 × 50).",
     "Pour une batterie de **12 V** avec un courant de **0,25 A**, la résistance est de **48 Ω** (R = 12 / 0,25).",
     "Une résistance de **125 kΩ** (125 000 Ω) est nécessaire pour une chute de tension de **100 V** à un courant de **0,8 mA** (0,0008 A).",
     "Un courant de **0,2 A** circule dans une lampe de **30 Ω** alimentée en **6 V** (I = 6 / 30).",
     "Pour faire passer un courant de **0,2 A** dans une résistance de **25 Ω**, une tension de **5 V** est requise (E = I × R)."
    ]
   }
  ],
  "B-005-006": [
   {
    "title": "Puissance électrique et résistance",
    "body": "La puissance (en watts) dissipée ou consommée dans un circuit s'obtient en multipliant la tension (V) par le courant (A). Elle indique la quantité d'énergie électrique convertie en chaleur ou en lumière.",
    "points": [
     "Formule : **P = V × I** (Puissance = tension × courant)",
     "Exemple : une lampe de 12V et 0,2A consomme **2,4 watts**",
     "Une résistance dissipant 1 watt peut être combinée pour augmenter la puissance totale dissipée",
     "Les puissances se cumulent en additionnant la dissipation des résistances en série ou en parallèle"
    ]
   },
   {
    "title": "Résistances en série et en parallèle",
    "body": "La combinaison en série ou en parallèle modifie la résistance totale et la puissance dissipée possible. En série, les résistances s'additionnent, en parallèle leur équivalent diminue.",
    "points": [
     "Deux résistances de 500 Ω, 1W en série dissipent au total **2 watts** et ont une résistance totale de 1000 Ω",
     "En parallèle, ces deux résistances dissipent aussi **2 watts** avec une résistance totale de 250 Ω",
     "Remplacer une résistance de 50 Ω par deux résistances de 100 Ω en parallèle permet de tolérer une puissance plus élevée tout en gardant 50 Ω",
     "Quand la tension double sur deux résistances en série, la puissance totale **quadruple**"
    ]
   },
   {
    "title": "Dissipation thermique et choix des résistances",
    "body": "La dissipation nominale d’une résistance correspond à sa capacité à libérer la chaleur sans dommage. Utiliser des résistances plus grosses permet d’augmenter la dissipation thermique tout en conservant la même valeur ohmique.",
    "points": [
     "Choisir une résistance avec une puissance nominale plus élevée augmente la capacité de dissipation de chaleur",
     "Par exemple, quatre résistances de 200 Ω 2W en parallèle peuvent servir de charge fictive de 50 Ω 5W tolérée",
     "La puissance dissipée est limitée par la capacité thermique de la résistance, pas seulement sa valeur en ohms"
    ]
   }
  ],
  "B-005-005": [
   {
    "title": "Résistances en parallèle : courant et résistance totale",
    "body": "Dans un circuit avec plusieurs résistances en parallèle, le courant total fourni par la source est la somme des courants traversant chaque résistance. La résistance totale équivalente est toujours inférieure à la plus faible résistance du groupe.",
    "points": [
     "Le courant total I_total = somme des courants dans chaque branche : I_total = I1 + I2 + ... + In",
     "Résistance totale en parallèle R_tot < résistance la plus faible",
     "Formule résistance totale parallèle pour n résistances identiques de valeur R : R_tot = R / n",
     "Exemple : 4 résistances de 68 Ω en parallèle => R_tot = 68/4 = 17 Ω"
    ]
   },
   {
    "title": "Résistances en série : résistance totale et courant",
    "body": "Dans un circuit en série, la résistance totale est la somme des résistances individuelles. Le courant est le même dans toutes les résistances.",
    "points": [
     "Résistance totale en série R_tot = R1 + R2 + ... + Rn",
     "R_tot est toujours supérieure à la plus grande résistance du circuit",
     "Exemple : 5 résistances de 10 Ω en série => R_tot = 5 × 10 = 50 Ω",
     "Pour obtenir 120 Ω, on peut mettre 5 résistances de 24 Ω en série (5 × 24 = 120 Ω)"
    ]
   },
   {
    "title": "Relations entre courant, tension et résistance",
    "body": "La loi d'Ohm relie le courant, la tension et la résistance dans chaque branche. Dans un circuit parallèle, la tension aux bornes de chaque résistance est la même que la tension de la source.",
    "points": [
     "Tension identique sur chaque branche en parallèle : V1 = V2 = ... = V_source",
     "Courant dans chaque résistance I = V / R",
     "Exemple : 2 résistances de 1000 Ω en parallèle sur 40 V : courant total I_total = V / R_eq = 40 / 500 = 0,08 A (80 mA)",
     "Si un courant est deux fois plus élevé dans une résistance, sa valeur est deux fois plus faible"
    ]
   }
  ],
  "B-005-009": [
   {
    "title": "Inductance des bobines en série et en parallèle",
    "body": "La valeur totale d'inductance dépend du type de connexion entre les bobines. En série, l'inductance s'additionne, tandis qu'en parallèle, elle diminue selon une formule spécifique.",
    "points": [
     "Deux bobines de même inductance en série ont une inductance totale égale au **double** de l'une.",
     "Deux bobines de même inductance en parallèle ont une inductance totale égale à la **moitié** de celle d'une seule bobine.",
     "L'inductance d'une bobine dépend du **noyau**, du **diamètre**, de la **longueur** et du **nombre de tours** du fil."
    ]
   },
   {
    "title": "Capacité des condensateurs en série et en parallèle",
    "body": "La capacité résultante varie selon le branchement des condensateurs. En parallèle, les capacités s'additionnent, alors qu'en série, la capacité totale est inférieure à chaque capacité individuelle.",
    "points": [
     "Pour deux condensateurs égaux en série, la capacité totale est la **moitié** de la capacité d'un seul.",
     "Pour deux condensateurs égaux en parallèle, la capacité totale est le **double** de la capacité d'un seul.",
     "La capacité d’un condensateur dépend du **matériau diélectrique**, de la **surface des plaques**, du **nombre de plaques** et de la **distance entre plaques**.",
     "La capacité totale de condensateurs en série est toujours **inférieure** à la plus faible capacité individuelle."
    ]
   },
   {
    "title": "Exemples pratiques de remplacement et calcul",
    "body": "Il est possible de remplacer une bobine ou un condensateur par un ensemble en série ou en parallèle afin d'obtenir une valeur équivalente proche de celle d'origine.",
    "points": [
     "Une bobine de **10 millihenrys** peut être remplacée par deux bobines de **5 millihenrys en série**.",
     "Trois condensateurs de **15 microfarads** en série ont une capacité totale de **5 microfarads**.",
     "Pour remplacer un condensateur défectueux de **10 microfarads**, deux condensateurs de **20 microfarads en série** peuvent être utilisés."
    ]
   }
  ],
  "B-005-010": [
   {
    "title": "Réactance et Impédance dans les circuits CA",
    "body": "Les bobines et les condensateurs ont des comportements opposés face à la fréquence alternative (CA). Leur résistance dynamique est appelée réactance, qui varie selon la fréquence.",
    "points": [
     "La réactance inductive d'une bobine **augmente avec la fréquence** : elle freine plus le courant haute fréquence.",
     "La réactance capacitive d'un condensateur **diminue avec la fréquence** : il laisse passer plus facilement les hautes fréquences.",
     "L'**impédance** regroupe la résistance ohmique et la réactance (inductive et capacitive) d'un composant en CA."
    ]
   },
   {
    "title": "Utilisation pratique des bobines et condensateurs en radio",
    "body": "Les bobines sur noyau de ferrite et les condensateurs de dérivation sont utilisés pour filtrer ou détourner les signaux brouilleurs en fonction de leur réactance variable selon la fréquence.",
    "points": [
     "Une bobine sur noyau de ferrite offre une **haute réactance aux fréquences radio**, atténuant les brouilleurs.",
     "Un condensateur de dérivation RF a une **basse réactance aux fréquences radio** pour détourner ces signaux hors d'un circuit audio.",
     "Leur effet est négligeable sur les signaux audio car le condensateur a une **haute réactance aux basses fréquences** et la bobine une **basse réactance aux basses fréquences**."
    ]
   }
  ],
  "B-005-007": [
   {
    "title": "Fréquence et Longueur d'Onde",
    "body": "La **fréquence** représente le nombre de fois par seconde qu'un courant alternatif change de direction, mesurée en hertz (Hz). La **longueur d'onde** est la distance parcourue par le courant pendant un cycle complet. Ces deux grandeurs sont inversement proportionnelles : quand la fréquence augmente, la longueur d'onde diminue, et vice versa.",
    "points": [
     "**Fréquence (Hz)** = cycles par seconde",
     "**Longueur d'onde** = distance parcourue en un cycle complet",
     "Fréquence ↑ ⇒ longueur d'onde ↓",
     "Fréquence ↓ ⇒ longueur d'onde ↑"
    ]
   },
   {
    "title": "Gammes de Fréquences et Sons Audibles",
    "body": "Les signaux dont la fréquence varie entre **20 Hz et 20 000 Hz** sont appelés « signaux audio » car ils correspondent à la gamme audible par l'oreille humaine. Les fréquences plus élevées comme **7125 kHz** appartiennent à la gamme radio.",
    "points": [
     "Son audible : **20 Hz à 20 000 Hz**",
     "Signal audio = fréquence audible par l'humain",
     "Fréquences supérieures à 30 kHz : généralement radio ou au-delà",
     "Exemple : 7125 kHz est une fréquence radio"
    ]
   },
   {
    "title": "Calcul de la Fréquence et des Cycles",
    "body": "La fréquence d'un signal détermine la durée d'un cycle via l'inverse : la durée d'un cycle = 1 / fréquence. Par exemple, un signal de 100 Hz a un cycle de 0,01 seconde. Un courant qui effectue un cycle complet en 0,1 seconde a une fréquence de 10 Hz. Les fréquences multiples d'une fréquence fondamentale sont appelées harmoniques.",
    "points": [
     "Durée d'un cycle (s) = 1 / fréquence (Hz)",
     "100 Hz → 0,01 seconde par cycle",
     "Un cycle en 0,1 s → fréquence = 10 Hz",
     "Harmonique = fréquence multiple de la fondamentale",
     "Exemple : 4 kHz est harmonique de 2 kHz"
    ]
   }
  ],
  "B-005-012": [
   {
    "title": "Circuit Résonant : Principes de Base",
    "body": "Un circuit résonant est formé d'une bobine (inductance) et d'un condensateur (capacité), utilisés ensemble pour sélectionner ou filtrer des fréquences spécifiques.",
    "points": [
     "Un circuit accordé comprend une **bobine** et un **condensateur**.",
     "La résonance se produit lorsque la **réactance inductive** et la **réactance capacitive** sont égales en grandeur mais opposées en signe.",
     "À la fréquence de résonance, les effets de l'inductance et de la capacité se compensent."
    ]
   },
   {
    "title": "Comportement à la Fréquence de Résonance",
    "body": "La résonance modifie fortement l'impédance du circuit, ce qui affecte le courant et la sélection des fréquences soit en série soit en parallèle.",
    "points": [
     "Dans un circuit **série**, l'impédance est **faible** à la résonance, ce qui permet au courant de ligne d'atteindre un maximum.",
     "Dans un circuit **parallèle**, l'impédance est **élevée** à la résonance, limitant le courant dans le circuit.",
     "L'insertion d'une résistance ne change pas la fréquence de résonance mais affecte la qualité du circuit."
    ]
   },
   {
    "title": "Applications de la Résonance en Radioamateurisme",
    "body": "Les circuits résonants sont essentiels pour sélectionner les fréquences des signaux reçus ou transmis, améliorant ainsi la réception et l'émission.",
    "points": [
     "On utilise les circuits résonants dans les récepteurs pour **sélectionner les fréquences de signal**.",
     "La fréquence de résonance est la fréquence où l'impédance et les courants prennent des valeurs caractéristiques déterminant la réponse du circuit."
    ]
   }
  ],
  "B-005-011": [
   {
    "title": "Fonctionnement de base d'un transformateur",
    "body": "Un transformateur est constitué d'un enroulement primaire et secondaire. Le courant dans le primaire peut exister même sans charge connectée au secondaire, appelé **courant magnétisant**. La tension et le courant au secondaire sont liés au primaire par le rapport de transformation basé sur le nombre de tours.",
    "points": [
     "**Courant magnétisant** : courant dans le primaire sans charge au secondaire",
     "Rapport de transformation = Nb tours secondaire / Nb tours primaire",
     "Tension secondaire = Tension primaire × rapport de transformation",
     "En transformateur idéal : Puissance primaire = Puissance secondaire (P=U×I)",
     "Relation des courants : I primaire = I secondaire / rapport de transformation"
    ]
   },
   {
    "title": "Propriétés électriques et magnétiques importantes",
    "body": "Le champ magnétique autour d’un conducteur est proportionnel au courant qui le traverse. La tension induite dépend du taux de variation du courant ou de la position du conducteur dans le champ magnétique. La relation entre aimants et pôles suit la loi d'attraction/répulsion des pôles magnétiques.",
    "points": [
     "Champ magnétique ∝ courant électrique dans un conducteur",
     "Tension induite maximale quand le taux de variation du courant est maximal",
     "Tension induite maximale quand le mouvement est perpendiculaire aux lignes de force",
     "Pôles magnétiques de même nom se repoussent",
     "Aimant permanent souvent fabriqué en acier"
    ]
   },
   {
    "title": "Rendement du transformateur et pertes",
    "body": "Un transformateur idéal transférerait toute l'énergie du primaire au secondaire sans pertes. Dans la réalité, des pertes sont constatées à cause de l’échauffement des lamelles de fer dans le noyau, indiquant un transfert d’énergie non parfait.",
    "points": [
     "Échauffement des lamelles de fer = preuve de pertes dans noyau",
     "Rendement < 100% en pratique",
     "Pertes par courant de Foucault et hystérésis magnétique dans le noyau"
    ]
   }
  ],
  "B-005-013": [
   {
    "title": "Mesure de tension et de courant électrique",
    "body": "Le voltmètre et l'ampèremètre sont des instruments indispensables pour mesurer la tension et le courant dans un circuit électrique. Leur mode de branchement diffère selon la grandeur mesurée.",
    "points": [
     "Le voltmètre se connecte toujours **en parallèle** avec la partie du circuit à mesurer pour détecter la différence de potentiel sans modifier le courant.",
     "L'ampèremètre se connecte **en série** dans le circuit afin de mesurer le courant qui y circule, intégrant tout le passage du courant à travers l'instrument.",
     "Un ampèremètre doit avoir une **basse résistance interne** pour ne pas affecter le courant mesuré."
    ]
   },
   {
    "title": "Utilisation du multimètre et précautions de mesure",
    "body": "Le multimètre est un instrument polyvalent permettant de mesurer le voltage, le courant et la résistance. Il existe des appareils spécifiques pour différentes formes de courant.",
    "points": [
     "Le multimètre peut mesurer **voltage, courant (ampères) et résistance** selon le mode sélectionné.",
     "Pour mesurer un courant continu (CC), comme celui exigé par un petit récepteur portatif, on utilise un **ampèremètre à courant continu**.",
     "Lors de la mesure du courant, il faut toujours insérer l'ampèremètre **en série dans l'un des fils d'alimentation** du dispositif.",
     "Le courant mesuré par l'ampèremètre provient de la source, il est important que l'ampèremètre pose une **résistance faible** pour ne pas influencer le circuit."
    ]
   }
  ],
  "B-006-004": [
   {
    "title": "Les lignes d'alimentation et leurs pertes",
    "body": "La ligne de transmission transporte le signal RF de l'émetteur à l'antenne. La qualité du câble et des connecteurs impacte directement les pertes de puissance RF, c'est pourquoi il faut utiliser d'excellents composants.",
    "points": [
     "Utiliser des câbles coaxiaux et connecteurs de qualité réduit la perte RF.",
     "Les pertes dans une ligne de transmission s'expriment en décibels (dB) par unité de longueur.",
     "Plus la longueur du câble augmente, plus les pertes augmentent proportionnellement.",
     "Une ligne ouverte (deux conducteurs parallèles) offre moins de pertes en HF et supporte un ROS élevé.",
     "La fréquence plus élevée entraîne une augmentation des pertes dans la ligne."
    ]
   },
   {
    "title": "Choix de la ligne de transmission et sa gestion",
    "body": "Pour minimiser les pertes, il faut préférer les lignes adaptées selon la fréquence et réduire la longueur du câble coaxial autant que possible.",
    "points": [
     "Une ligne parallèle supporte un ROS élevé et a moins de pertes que le câble coaxial.",
     "À fréquence élevée, la perte spécialement dans le coaxial augmente; donc conserver la ligne aussi courte que possible.",
     "Doubler la longueur d'un câble coaxial double aussi la perte de puissance RF.",
     "Des pertes dans la ligne entraînent une baisse de la puissance effectivement rayonnée par l'antenne."
    ]
   }
  ],
  "B-006-002": [
   {
    "title": "Types de lignes d'alimentation et transmission",
    "body": "Les lignes de transmission acheminent le signal RF entre l'émetteur et l'antenne. Elles peuvent être symétriques ou asymétriques, avec des constructions spécifiques.",
    "points": [
     "**Câble coaxial** : fil central entouré d'un isolant, lui-même entouré d'une gaine conductrice ou tresse métallique. Ligne asymétrique avec une impédance caractéristique typique de **50 ohms** ou **75 ohms**.",
     "Ligne symétrique : composée de **deux fils parallèles** séparés par un isolant ou des tiges isolantes (ligne ouverte dite « en échelle »).",
     "Ligne ouverte de 600 ohms : deux conducteurs maintenus à distance uniforme par des isolateurs (tiges)."
    ]
   },
   {
    "title": "Adaptation et rôle du symétriseur (balun)",
    "body": "Le symétriseur, communément appelé balun, permet de relier des systèmes qui ont des modes de transmission différents, symétrique et asymétrique.",
    "points": [
     "Un **balun** est un adaptateur placé entre une ligne et une antenne lorsque leurs modes sont différents, par exemple entre une ligne coaxiale (asymétrique) et un dipôle (symétrique).",
     "Le balun doit être placé **entre le câble coaxial et l'antenne** pour assurer une adaptation correcte.",
     "Une ligne asymétrique est caractérisée par un conducteur relié à la terre, alors qu'une ligne symétrique ne l'est pas.",
     "Pour adapter une antenne de 300 ohms à une ligne de 75 ohms, on utilise un **transformateur d'impédance 4:1**."
    ]
   }
  ],
  "B-005-008": [
   {
    "title": "Comprendre le Décibel (dB) en Radioamateur",
    "body": "Le décibel (dB) est une unité logarithmique utilisée pour exprimer des rapports, notamment de puissance en radioamateur. Il permet de mesurer les augmentations ou diminutions de puissance de manière relative.",
    "points": [
     "**Décibel (dB)** exprime un rapport entre deux puissances.",
     "Une **augmentation de 3 dB** correspond à un doublement de la puissance.",
     "Une **diminution de 3 dB** correspond à une division de la puissance par 2.",
     "Formule de conversion: dB = 10 x log10(P2/P1), où P1 et P2 sont des puissances."
    ]
   },
   {
    "title": "Calculs Pratiques avec les Décibels",
    "body": "Les variations de puissance en dB peuvent être converties en multiplication ou division directe de la puissance émise. Ceci est utile pour ajuster la puissance de sortie et estimer la force des signaux reçus.",
    "points": [
     "Augmentation de **6 dB** = multiplication de la puissance par **4**.",
     "Par exemple, passer de 1 watt à 2 watts = **+3 dB**, de 2 watts à 8 watts = **+6 dB**.",
     "Un gain en dB se calcule aussi avec le logarithme: gain (dB) = 10 x log10(P2 / P1).",
     "Augmenter 5 watts à 50 watts = gain de **10 dB** (car 50/5 = 10)."
    ]
   },
   {
    "title": "Applications et Exemples en Radioamateur",
    "body": "En radio, la lecture d'un signal en dB par rapport à un niveau de référence (ex: S9) permet d'évaluer la puissance d'émission. On peut ainsi ajuster la puissance pour obtenir un niveau désiré.",
    "points": [
     "Si un signal est **S9 + 10 dB** à 1500 W, réduire à 150 W ramènera le signal à **S9**.",
     "Réduire un signal de 30 dB au-dessus de S9 à S9 nécessite une baisse de puissance à **100 mW** (diminuée d'un facteur 1000).",
     "Un amplificateur de **9 dB** appliqué à 2 W donnera environ **16 W** : 2 W x 10^(9/10) ≈ 16 W.",
     "La règle générale est d’utiliser la formule log pour passer entre puissance et décibels selon les besoins."
    ]
   }
  ],
  "B-006-003": [
   {
    "title": "Lignes de transmission pour antennes radioamateurs",
    "body": "Le câble coaxial est couramment utilisé par les radioamateurs pour alimenter les antennes grâce à sa bonne adaptation d'impédance et sa robustesse aux intempéries.",
    "points": [
     "Le câble coaxial est **à l'épreuve des intempéries**.",
     "Son impédance typique est souvent en accord avec la plupart des antennes (environ **50 ohms**).",
     "Le câble coaxial est le choix recommandé près d'objets métalliques reliés à la terre.",
     "Les lignes bifilaires ont une impédance d'environ **300 ohms**, mais demandent un symétriseur et peuvent causer des pertes proches de la terre."
    ]
   },
   {
    "title": "Connecteurs et entretien des lignes coaxiales",
    "body": "Les connecteurs adaptés assurent une bonne transmission du signal RF et un entretien régulier maintient la qualité du contact électrique.",
    "points": [
     "Pour un câble coaxial RG-213, on utilise un connecteur **PL-259**.",
     "Les émetteurs portatifs utilisent généralement des connecteurs **SMA**.",
     "Le connecteur de type **N** présente le moins de pertes en UHF.",
     "Il est important de nettoyer et serrer régulièrement les connecteurs pour éviter une résistance de contact élevée."
    ]
   },
   {
    "title": "Choix des câbles coaxiaux en fonction de la distance et l'utilisation",
    "body": "Le câble coaxial RG-213 est souvent choisi pour les longues distances, offrant moins de pertes sur 60 mètres ou plus.",
    "points": [
     "Le RG-213 a une meilleure performance sur de longues distances par rapport à d'autres coaxiaux communs.",
     "Certains câbles coaxiaux peuvent être enterrés directement sans effets défavorables.",
     "Attention aux lignes bifilaires qui ont un rendement diminué près des objets métalliques ou soluts par contact direct."
    ]
   }
  ],
  "B-006-001": [
   {
    "title": "Introduction aux lignes de transmission",
    "body": "Une ligne de transmission relie l'émetteur-récepteur à l'antenne et a pour fonction de transmettre le signal avec un minimum de perte et de réflexion.",
    "points": [
     "**Ligne de transmission** relie l'émetteur-récepteur à l'antenne.",
     "Elle transmet la puissance RF avec un minimum de pertes.",
     "**Impédance caractéristique (Z0)** est une propriété fondamentale de la ligne."
    ]
   },
   {
    "title": "Impédance caractéristique d'une ligne de transmission",
    "body": "L'impédance caractéristique est une résistance virtuelle qui correspond à la charge que la ligne présente à son extrémité, permettant d'absorber toute la puissance sans réflexion.",
    "points": [
     "Elle dépend des **dimensions physiques** et des **positions relatives des conducteurs**.",
     "Pour une ligne coaxiale, c'est le **rapport du diamètre du conducteur intérieur sur celui du conducteur extérieur** qui détermine Z0.",
     "Pour une ligne à fils parallèles, la distance entre conducteurs et leur rayon sont les facteurs déterminants.",
     "L'impédance caractéristique ne change pas si on coupe une partie de la ligne."
    ]
   },
   {
    "title": "Comportements et caractéristiques des lignes",
    "body": "La ligne de transmission possède un délai de propagation de l'énergie qui la distingue d'un circuit ordinaire, et son impédance apparente peut varier en fonction de sa charge et de sa longueur.",
    "points": [
     "Si la charge diffère de Z0, l'impédance vue à l'entrée varie avec la longueur de la ligne.",
     "La vélocité de propagation n'affecte pas l'impédance caractéristique dans le cas des lignes à fils parallèles.",
     "Le câble coaxial peut être enterré directement dans le sol sans dégradation notable.",
     "L'impédance caractéristique est une résistance pure qui élimine les réflexions quand elle est parfaitement adaptée."
    ]
   }
  ],
  "B-006-006": [
   {
    "title": "Adaptation d'impédance en radioamateur",
    "body": "L'adaptation d'impédance est essentielle pour assurer un transfert maximal de puissance entre un émetteur et une antenne, même si leurs impédances diffèrent. Un bloc d'accord d'antenne permet cette adaptation en ajustant l'impédance apparente vue par l'émetteur.",
    "points": [
     "L'impédance de la charge doit être égale à celle de la source pour un transfert maximal de puissance.",
     "Le bloc d'accord d'antenne adapte un système d'antenne non prévu à une bande différente.",
     "Un adaptateur d'impédance est utilisé pour relier des composants ayant des impédances différentes (ex : 50 Ω coaxial à 17 Ω antenne)."
    ]
   },
   {
    "title": "Fonctionnement et importance des blocs d'accord et adaptateurs",
    "body": "L'accord d'impédance assure que la puissance de l'émetteur est efficacement transmise sans pertes importantes. La longueur de la ligne de transmission n'influence pas l'adaptation si cette dernière est bien réalisée.",
    "points": [
     "L'accord d'impédance à l'extrémité de la ligne permet une transmission maximale à l'antenne.",
     "La longueur de la ligne coaxiale correctement adaptée n'affecte pas l'impédance finale.",
     "Exemple : pour passer d'une antenne à 300 Ω à un câble coaxial à 50 Ω, un transformateur 6:1 est nécessaire."
    ]
   }
  ],
  "B-006-005": [
   {
    "title": "Comprendre le Rapport d'Onde Stationnaire (ROS)",
    "body": "Le Rapport d'Onde Stationnaire (ROS) exprime la qualité d'adaptation entre la ligne de transmission et l'antenne. Il est défini comme le rapport entre le maximum et le minimum de tension sur la ligne.",
    "points": [
     "**ROS = tension max / tension min** sur la ligne de transmission",
     "Une lecture **1:1** indique un **accord parfait d'impédance**",
     "Un ROS inférieur à **1,5:1** est considéré comme un accord acceptable",
     "Un ROS très élevé révèle un **mauvais accord** ou un problème dans le système (ligne ouverte ou court-circuitée)"
    ]
   },
   {
    "title": "Conséquences des mauvaises correspondances et lecture du ROS-mètre",
    "body": "Un mauvais accord d'impédance provoque des ondes stationnaires dans la ligne, réduisant l'efficacité du transfert d'énergie à l'antenne et peut causer des pertes importantes.",
    "points": [
     "Les ondes stationnaires apparaissent si l'impédance de la ligne diffère de celle de l'antenne",
     "Un ROS élevé fait chauffer la ligne, signe de pertes ou d'un mauvais accord",
     "Une lecture erratique du ROS-mètre peut indiquer un **mauvais contact électrique**",
     "Le ROS-mètre compare la **tension incidente** et la **tension réfléchie** pour évaluer l'accord"
    ]
   },
   {
    "title": "Calcul du ROS et choix de la ligne de transmission",
    "body": "Le ROS peut être calculé à partir des impédances d'antenne et de ligne. Le choix de la ligne influe sur la tolérance au ROS élevé.",
    "points": [
     "Pour une antenne de 200 ohms et une ligne de 50 ohms, le ROS est de **4:1**",
     "La ligne ouverte de **600 ohms** fonctionne mieux avec un ROS élevé qu'une ligne à faible impédance",
     "Maintenir une bonne adaptation limite les pertes et optimise la performance du système"
    ]
   }
  ],
  "B-006-009": [
   {
    "title": "Principe des antennes directionnelles à éléments parasites",
    "body": "Une antenne directionnelle 'beam' comprend un élément alimenté et plusieurs éléments parasites, qui ne sont pas directement alimentés mais captent l'énergie par induction ou rayonnement, modifiant ainsi la directivité de l'antenne.",
    "points": [
     "Un élément parasite plus court qu'un dipôle agit comme un réflecteur, créant un lobe majeur dirigé vers cet élément.",
     "Un élément parasite plus long agit comme un conducteur, orientant le lobe majeur vers l'élément alimenté.",
     "La distance typique entre l'élément alimenté et les éléments parasites est environ **0,1 longueur d'onde**."
    ]
   },
   {
    "title": "Caractéristiques et paramètres clés des antennes",
    "body": "Le gain et la largeur de bande sont essentiels pour évaluer la performance d'une antenne, révélant respectivement sa directivité et la gamme de fréquences utilisables efficacement.",
    "points": [
     "Le **gain** d'une antenne est le rapport de la puissance rayonnée par rapport à une antenne de référence (souvent isotrope).",
     "Un dipôle demi-onde a un gain typique d'environ **2,1 dBi**.",
     "La largeur de bande correspond à la gamme de fréquences où l'antenne fonctionne efficacement.",
     "Le gain est souvent exprimé en **dBi**, où le 'i' signifie isotrope.",
     "Le diagramme de rayonnement d'un dipôle demi-onde en espace libre présente un minimum aux extrémités et un maximum dans le plan transversal."
    ]
   },
   {
    "title": "Directivité et rapport avant-arrière des antennes beam",
    "body": "La directivité permet de concentrer l'énergie dans une direction précise, et le rapport avant-arrière évalue la puissance relative entre l'avant et l'arrière de l'antenne.",
    "points": [
     "Le rapport avant-arrière est le rapport de la puissance maximale du lobe principal à l'avant par rapport à la puissance maximale du rayonnement arrière.",
     "Augmenter le diamètre des éléments parasites augmente la largeur de bande d'une antenne beam."
    ]
   }
  ],
  "B-006-007": [
   {
    "title": "Polarisation des ondes électromagnétiques",
    "body": "La polarisation d'une onde électromagnétique décrit l'orientation de son champ électrique par rapport au sol. Elle est essentielle pour assurer une bonne réception entre antennes émettrices et réceptrices.",
    "points": [
     "**Polarisation horizontale** : les lignes de force électrique sont **parallèles au sol**.",
     "**Polarisation verticale** : les lignes de force électrique sont **perpendiculaires au sol**.",
     "L'orientation de l'antenne détermine la polarisation de l'onde émise, par exemple un dipôle monté verticalement émet une onde à polarisation verticale.",
     "Une antenne Yagi avec éléments parallèles au sol émet une onde à polarisation horizontale."
    ]
   },
   {
    "title": "Diagramme de rayonnement et types d'antennes",
    "body": "Le diagramme de rayonnement décrit la distribution spatiale de l'énergie émise par une antenne. L'antenne isotrope est un concept théorique utile comme référence.",
    "points": [
     "Une **antenne isotrope** est une source ponctuelle hypothétique qui rayonne uniformément dans toutes les directions, soit une **sphère** en diagramme de rayonnement.",
     "Une antenne verticale monte en polarisation verticale et est efficace en VHF lorsque utilisée avec un plan de sol.",
     "Une onde de sol garde la polarisation de l'onde émise lors de la réception."
    ]
   },
   {
    "title": "Importance de la polarisation en réception",
    "body": "Pour optimiser la réception, il faut que la polarisation de l'antenne réceptrice corresponde à celle de l'onde incidente.",
    "points": [
     "Une antenne verticale capte mieux une onde polarisée verticalement, offrant une **intensité de réception plus élevée** par rapport à une antenne horizontale.",
     "Mismatch de polarisation entre antennes entraîne une perte significative du signal reçu.",
     "Utiliser une antenne adaptée à la polarisation de l'onde améliore la qualité et la puissance du signal."
    ]
   }
  ],
  "B-006-010": [
   {
    "title": "Calcul de la longueur des antennes quart d'onde et demi-onde",
    "body": "Pour créer des antennes efficaces aux fréquences inférieures à 30 MHz, la longueur est calculée en fonction de la fréquence d'opération. Une antenne quart d'onde est typiquement utilisée pour ces bandes.",
    "points": [
     "La longueur d'une antenne quart d'onde (en mètres) = **71,5 ÷ fréquence en MHz** ; en pieds = **234 ÷ fréquence en MHz**.",
     "Exemple : Une antenne quart d'onde à 21,125 MHz mesure environ **3,36 mètres (11,0 pieds)**.",
     "Une antenne dipôle demi-onde à 223 MHz mesure environ **67 cm (26,4 pouces)**."
    ]
   },
   {
    "title": "Types d'antennes verticales et leurs caractéristiques",
    "body": "Les antennes verticales se distinguent par leur longueur et leur angle de rayonnement, influençant leur gain et leur directivité.",
    "points": [
     "Une antenne verticale de **5/8 de longueur d'onde** offre plus de **gain** qu'une antenne de 1/4 de longueur pour les opérations mobiles VHF/UHF.",
     "L'angle de rayonnement bas des antennes 5/8 de longueur d'onde améliore les communications sur de plus longues distances.",
     "Une antenne verticale émet et reçoit de manière uniforme dans toutes les directions horizontales, surtout une antenne à base magnétique installée sur une voiture."
    ]
   },
   {
    "title": "Impédance, radiales et adaptation des lignes d'alimentation",
    "body": "Un bon système d'antenne dépend aussi de la configuration des radiales et de l'adaptation de l'impédance à la ligne de transmission.",
    "points": [
     "Des radiales en pente vers le bas augmentent l'impédance au point d'alimentation à environ **50 ohms**, facilitant l'adaptation.",
     "Changer les radiales horizontales pour des radiales en pente augmente l'impédance au point d'alimentation.",
     "Le meilleur câble pour adapter une antenne quart d'onde à plan de sol est un câble coaxial de **50 ohms**.",
     "Les bobines de charge sur antennes HF verticales mobiles sont utilisées pour **annuler la réactance capacitive**, améliorant le réglage."
    ]
   }
  ],
  "B-006-012": [
   {
    "title": "Caractéristiques des antennes dipôles et leurs dimensions",
    "body": "Un dipôle demi-onde résonne à une longueur liée à la fréquence d'émission. Sa longueur approximative est calculée par la formule standard ajustée pour les radioamateurs. Par exemple, un dipôle pour 28,150 MHz mesure environ 5,08 mètres.",
    "points": [
     "La longueur d'un dipôle demi-onde (en mètres) ≈ 143 / fréquence en MHz",
     "Dipôle à 28,150 MHz ≈ **5,08 mètres (16,62 pieds)**",
     "Dipôle à 3,75 MHz ≈ **38 mètres (125 pieds)**",
     "Dipôle replié a une impédance d'environ **300 Ω**, contre **73 Ω** pour un dipôle simple"
    ]
   },
   {
    "title": "Diagramme de rayonnement et orientation de l’antenne dipôle",
    "body": "Un dipôle demi-onde horizontal rayonne un champ électromagnétique perpendiculaire à son axe, formant un diagramme en huit en espace libre. L’orientation de l’antenne détermine la direction des lobes d’émission principaux.",
    "points": [
     "Diagramme idéal en espace libre : forme de huit perpendiculaire au dipôle",
     "Dipôle horizontal orienté nord/sud rayonne plus fortement vers l’est et l’ouest",
     "Hauteur idéale améliore le rendement et la portée du rayonnement"
    ]
   },
   {
    "title": "Avantages et inconvénients des antennes à pièges et fils \"random\"",
    "body": "Les antennes à pièges sont multibandes, mais peuvent générer plus d'harmoniques. Les fils de longueur quelconque sont simples mais peuvent causer du retour RF parasite nuisible à la station.",
    "points": [
     "Antenne à pièges : multibande mais plus susceptible de rayonner des harmoniques",
     "Fils \"random\" : flexibles mais peuvent causer du retour RF parasite vers la station",
     "La largeur de bande d'un dipôle replié est plus large qu'un dipôle simple"
    ]
   }
  ],
  "B-006-011": [
   {
    "title": "Composition et caractéristiques des antennes Yagi",
    "body": "Une antenne Yagi se compose d'éléments métalliques alignés sur un bras support (boom), dont un seul élément est directement alimenté par la ligne d'antenne. Chaque élément a une longueur adaptée à la fréquence de travail, déterminée par la longueur d'onde.",
    "points": [
     "Un seul élément est directement alimenté, appelé élément rayonnant.",
     "À 14 MHz (bande 20 mètres), l'élément rayonnant mesure environ **10,21 mètres** (33,5 pieds).",
     "Les éléments directeurs sont légèrement plus courts ; par exemple, à 21,1 MHz, un directeur mesure environ **6,4 mètres** (21 pieds).",
     "L'élément réflecteur est plus long que l'alimenté ; par exemple, à 28,1 MHz, il mesure environ **5,33 mètres** (17,5 pieds)."
    ]
   },
   {
    "title": "Optimisation et gain des antennes Yagi",
    "body": "Le gain d'une antenne Yagi dépend du nombre d'éléments, de l'espacement entre eux et du boom. L'espacement et le choix précis des longueurs d'éléments sont cruciaux pour maximiser le rendement.",
    "points": [
     "Augmenter la longueur du boom et ajouter des directeurs accroît le gain.",
     "Un espacement d'environ **0,20 longueur d'onde** entre les éléments est optimal pour une Yagi à trois éléments.",
     "Des éléments très espacés offrent un gain plus élevé, une syntonisation moins critique et une plus grande largeur de bande.",
     "Le rapport avant/arrière mesure la puissance rayonnée dans le lobe principal comparée à la puissance rayonnée à l'arrière."
    ]
   },
   {
    "title": "Utilisation pratique des antennes Yagi",
    "body": "Les antennes Yagi sont prisées pour leur directivité, qui permet de réduire les interférences et de concentrer l'énergie dans une direction précise, notamment en bande 20 mètres.",
    "points": [
     "Elles réduisent les interférences provenant des côtés et de l'arrière en concentrant le signal vers l'avant.",
     "Pour un rendement idéal, il faut choisir des longueurs et des distances entre éléments optimales.",
     "Le jumelage (« stacking ») de deux antennes Yagi à six éléments augmente le gain global d'environ **3 dB**, passant de **10 dBi** à **13 dBi**."
    ]
   }
  ],
  "B-006-008": [
   {
    "title": "Fréquence de résonance et longueur d'antenne",
    "body": "La fréquence de résonance d'une antenne est inversement proportionnelle à sa longueur. Plus l'antenne est longue, plus sa fréquence de résonance diminue, et inversement.",
    "points": [
     "Allonger une antenne diminue sa fréquence de résonance.",
     "Raccourcir une antenne augmente sa fréquence de résonance.",
     "Ajouter une inductance en série à une antenne diminue également sa fréquence de résonance."
    ]
   },
   {
    "title": "Vitesse de propagation, longueur d'onde et calculs associés",
    "body": "La vitesse des ondes radio dans l'espace libre est égale à la vitesse de la lumière, soit environ 300 000 km/s. La longueur d'onde se calcule en divisant cette vitesse par la fréquence.",
    "points": [
     "Vitesse de propagation = **300 000 km/s** (égal à la vitesse de la lumière).",
     "Longueur d'onde (λ) = vitesse / fréquence.",
     "Exemples : à 25 MHz, λ = **12 mètres** ; à 2 MHz, λ = **150 mètres**."
    ]
   },
   {
    "title": "Conception et adaptation des antennes",
    "body": "Les isolateurs aux extrémités des fils d’antenne définissent la longueur électrique. Les pièges sont des circuits LC parallèles qui permettent à une antenne raccourcie de fonctionner sur plusieurs bandes.",
    "points": [
     "Isolateurs délimitent la longueur électrique de l'antenne.",
     "Pièges = bobine + condensateur en parallèle, utilisés pour multibande sur antennes raccourcies.",
     "Pour abaisser une fréquence de résonance trop élevée, on allonge l'antenne."
    ]
   }
  ],
  "B-007-001": [
   {
    "title": "Types de propagation des ondes radio",
    "body": "Les ondes radio peuvent se propager par différents modes selon la fréquence et la distance entre émetteurs et récepteurs.",
    "points": [
     "**Propagation à vue** concerne les communications VHF et UHF entre émetteurs proches, reliant directement sans obstacles majeurs.",
     "**Onde de sol** circule le long de la surface terrestre, adaptée aux basses fréquences et distances modérées, surtout en dessous de 200 km.",
     "**Onde de ciel** ou **onde ionosphérique** est redirigée vers la Terre par l'ionosphère, permettant de franchir de longues distances."
    ]
   },
   {
    "title": "Particularités des propagations VHF et HF",
    "body": "Les ondes VHF utilisent majoritairement la propagation directe à vue, tandis que les ondes HF s'appuient sur l'ionosphère pour les longues distances.",
    "points": [
     "Les signaux VHF se propagent par **ondes directes** jusqu'à l'horizon visible sans rebond ionosphérique.",
     "La portée de la propagation ionosphérique est **beaucoup plus longue** que celle des ondes de sol.",
     "La propagation de l'onde de sol diminue avec l'augmentation de la fréquence."
    ]
   },
   {
    "title": "Distance et portée des ondes selon la propagation",
    "body": "La portée des signaux varie fortement selon le mode de propagation et la fréquence utilisée.",
    "points": [
     "Les ondes de sol assurent la communication jusqu'à environ **200 km** en basse fréquence (HF).",
     "Les ondes ionosphériques peuvent permettre la réception au-delà de **4000 km** en haute fréquence (HF).",
     "La propagation par onde ionosphérique implique un trajet rayonné vers l'ionosphère puis réfléchie vers la terre."
    ]
   }
  ],
  "B-007-002": [
   {
    "title": "Formation et composition de l'ionosphère",
    "body": "L'ionosphère est formée par l'ionisation de la couche extérieure de l'atmosphère, principalement causée par le rayonnement ultraviolet du soleil. Cette ionisation varie selon le moment de la journée.",
    "points": [
     "Le rayonnement solaire, surtout l'**ultraviolet**, ionise les gaz atmosphériques.",
     "L'ionisation est maximale au **milieu de la journée** et minimale juste avant l'**aurore**.",
     "L'ionosphère se compose de plusieurs couches: **D**, **E**, **F1** et **F2**.",
     "La couche **D** est la plus proche de la Terre, suivie de la couche **E**, puis des couches **F1** et **F2** plus hautes."
    ]
   },
   {
    "title": "Caractéristiques des couches ionosphériques et impact sur la propagation",
    "body": "Chaque couche ionosphérique influence différemment la propagation des ondes radio, ce qui affecte la portée des communications.",
    "points": [
     "La couche **D** existe principalement le jour et provoque une forte absorption des ondes de bandes basses (160, 80, 40 m), limitant leur portée à courte distance.",
     "Les couches **F1** et **F2** ne sont séparées qu'en plein jour; la couche **F2** est la plus haute et la meilleure pour les communications longue distance.",
     "La couche **E** se trouve sous la couche **F** et joue un rôle intermédiaire dans la réflexion des ondes radio.",
     "Les bandes basses sont moins efficaces pour la longue distance pendant le jour à cause de l'absorption dans la couche D."
    ]
   }
  ],
  "B-006-013": [
   {
    "title": "Antennes Quad Cubique et Boucle Delta",
    "body": "Les antennes Quad Cubique et à boucle delta sont des antennes constituées de boucles fermées ayant chacune une longueur d'onde électrique. Ces antennes sont particulièrement efficaces pour la transmission et la réception en HF.",
    "points": [
     "Une antenne Quad Cubique est constituée de deux ou plusieurs boucles de quatre côtés, parallèles entre elles, avec chaque boucle d'environ **une longueur d'onde**.",
     "Une antenne à boucle delta est formée de boucles à trois côtés (triangle équilatéral en général), chacune ayant une longueur proche d'**une longueur d'onde électrique**.",
     "Ces antennes peuvent être montées en plusieurs éléments pour améliorer les performances directionnelles."
    ]
   },
   {
    "title": "Dimensions des éléments et fréquence d'accord",
    "body": "La taille des éléments d'antenne est inversement proportionnelle à la fréquence de syntonisation. Dimensions précises sont calculées pour une résonance optimale à la fréquence choisie.",
    "points": [
     "Pour une Quad Cubique syntonisée à **21,4 MHz**, la longueur approximative de chaque côté de l'élément alimenté est **3,54 m (11,7 pieds)**.",
     "Pour une Quad Cubique syntonisée à **14,3 MHz**, la longueur approximative de chaque côté est **5,36 m (17,6 pieds)**.",
     "Pour une boucle delta équilatérale à **28,7 MHz**, la longueur approximative d'un côté est **3,32 m (10,89 pieds)**."
    ]
   },
   {
    "title": "Caractéristiques de rayonnement et polarisation",
    "body": "Les antennes Quad et boucle delta offrent une directivité supérieure et peuvent changer de polarisation selon le point d'alimentation, influençant leur performance selon l'utilisation.",
    "points": [
     "L'antenne Quad a une **directivité accrue** tant sur le plan horizontal que vertical comparée à un dipôle simple.",
     "Changer le point d'alimentation d'une antenne Quad d'un côté parallèle au sol à un côté perpendiculaire modifie sa polarisation de **horizontale à verticale**.",
     "Le rapport avant/arrière exprime la puissance radioélectrique dirigée vers l'avant comparée à celle dirigée à l'arrière dans une antenne delta.",
     "Les antennes à boucle delta 2 éléments et Quad 2 éléments sont performantes et peuvent rivaliser avec une antenne Yagi à 3 éléments."
    ]
   }
  ],
  "B-007-003": [
   {
    "title": "Propagation des ondes radio et zones de silence",
    "body": "Les ondes radio peuvent se propager par onde de sol ou être réfléchies par l'ionosphère. La zone de silence est une zone sans réception, située entre la portée maximale de l'onde de sol et le point d'arrivée de la première onde ionosphérique réfléchie.",
    "points": [
     "**Zone de silence** : située au-delà de la portée de l'onde de sol mais trop proche pour recevoir l'onde réfléchie de l'ionosphère.",
     "Ondes de sol : suivent la surface terrestre sur une courte distance.",
     "Ondes ionosphériques : sont réfléchies ou réfractées par des couches ionisées en altitude, comme la couche E ou la couche F2."
    ]
   },
   {
    "title": "Distances maximales des réflexions ionosphériques",
    "body": "La distance parcourue par les ondes radio sur la surface de la Terre dépend de la couche ionosphérique qui réfléchit le signal. La couche F2 permet des distances de saut plus longues que la couche E.",
    "points": [
     "Réflexion simple sur la couche E : distance maximale d'environ **2000 km (1250 milles)**.",
     "Réflexion simple sur la couche F2 : distance maximale d'environ **4000 km (2500 milles)**.",
     "La distance entre l’émetteur et le premier point de retour de l’onde ionosphérique est appelée **distance d'un saut**."
    ]
   },
   {
    "title": "Facteurs influençant la distance d’un saut ionosphérique",
    "body": "La distance d’un saut dépend de la hauteur de la couche réfléchissante et de l’angle sous lequel l’onde est rayonnée vers l’ionosphère. Un angle de rayonnement plus faible et une couche plus haute allongent cette distance.",
    "points": [
     "**Distance d'un saut** : distance minimale parcourue par un signal après réflexion ionosphérique.",
     "Le saut résulte de la **réflexion et la réfraction** des ondes dans l'ionosphère.",
     "Plus l'angle entre la direction du rayonnement et le sol est petit, plus la distance d'un saut est longue.",
     "Une augmentation de la hauteur de la couche réfléchissante (HF) **augmente la distance d'un saut**.",
     "Pour des distances supérieures à 4000 km, la propagation se fait généralement par **sauts multiples**."
    ]
   }
  ],
  "B-007-004": [
   {
    "title": "Propagation et absorption des ondes HF par l'ionosphère",
    "body": "Les ondes HF traversant la couche D durant le jour sont absorbées, réduisant la portée des signaux. Cette absorption est la raison pour laquelle les stations en bande AM ou 160 m ne sont pas audibles le jour.",
    "points": [
     "La couche D est fortement ionisée en journée, causant une **absorption** importante des ondes HF basses fréquences.",
     "Cette absorption limite la propagation ionosphérique diurne, surtout pour les bandes **AM et 160 m**.",
     "La réflexion ionosphérique est différente selon la couche (D, E, F) et l'heure du jour."
    ]
   },
   {
    "title": "Évanouissement et variations du signal ionosphérique",
    "body": "La propagation multiple des ondes radio via différents trajets peut provoquer des différences de phase, ce qui cause un changement d'intensité du signal appelé évanouissement. Ces variations sont influencées par les conditions ionosphériques et orages.",
    "points": [
     "**Évanouissement** = variation de l'intensité du signal causée par différences de phase entre trajets multiples.",
     "Les trajets à un saut ou plusieurs sauts subissent des modulations d'intensité dues à des fluctuations ionosphériques.",
     "Les orages ionosphériques provoquent un évanouissement marqué sur les signaux ionosphériques.",
     "L'évanouissement sélectif résulte de différences de phase entre composantes d'une même émission.",
     "Plus la largeur de bande du signal est grande, plus l’évanouissement sélectif est prononcé."
    ]
   },
   {
    "title": "Polarisation et distorsion dans la propagation ionosphérique",
    "body": "Sur VHF/UHF, la polarisation de l'antenne émettrice et réceptrice doit correspondre, mais sur HF, l'ionosphère modifie la polarisation. La réflexion ionosphérique en BLU cause peu ou pas de distorsion de phase.",
    "points": [
     "Sur HF, la polarisation peut changer en raison de l'ionosphère, donc elle est moins critique que sur VHF/UHF.",
     "Les changements de polarisation ne sont pas causés par l'**interaction parabolique**.",
     "La réflexion ionosphérique en BLU ne génère pas ou très peu de distorsion de phase des signaux."
    ]
   }
  ],
  "B-007-005": [
   {
    "title": "Cycle solaire et ionisation de l'atmosphère",
    "body": "Le nombre de taches solaires influence directement l'ionisation de l'atmosphère. Un nombre élevé de taches augmente le rayonnement solaire, ce qui renforce l'ionisation nécessaire pour la propagation des ondes radio.",
    "points": [
     "Un cycle de taches solaires dure en moyenne **11 ans**.",
     "Plus il y a de taches solaires, plus l'ionisation atmosphérique est importante.",
     "L'ionisation est essentielle pour la réflexion des signaux radio haute fréquence."
    ]
   },
   {
    "title": "Flux solaire et propagation des ondes radio",
    "body": "Le flux solaire correspond à l'énergie radio émise par le soleil, mesurée par l'indice du flux solaire à une fréquence spécifique. Cette énergie impacte la propagation des ondes radio, surtout au-delà des communications à vue et ondes de sol.",
    "points": [
     "Le **flux solaire** est l'énergie radio émise par le soleil.",
     "L'**indice du flux solaire** mesure l'activité solaire sur une fréquence donnée.",
     "Le rayonnement solaire influence toutes les fréquences de communication à divers degrés."
    ]
   },
   {
    "title": "Types de rayonnement solaire et effet sur la propagation",
    "body": "Deux types principaux de rayonnement solaire affectent les ondes radio : les émissions électromagnétiques et les émissions de particules. Un nombre élevé de taches solaires rend les fréquences jusqu'à **40 MHz** (et plus) utilisables pour les communications à longues distances.",
    "points": [
     "Le rayonnement solaire comprend les émissions électromagnétiques et les émissions de particules.",
     "Avec beaucoup de taches solaires, les bandes HF élevées deviennent plus efficaces.",
     "La propriété de réflexion de l'ionosphère dépend de la quantité de rayonnement solaire reçu."
    ]
   }
  ],
  "B-007-007": [
   {
    "title": "Propagation ionosphérique des ondes radio VHF",
    "body": "La couche E de l'ionosphère joue un rôle clé dans la propagation des ondes de ciel, notamment sur la bande des 6 mètres. Un phénomène particulier est l'état sporadique E, caractérisé par des plaques denses d'ionisation qui augmentent la portée des signaux.",
    "points": [
     "La **couche E** affecte surtout la propagation sur la bande **6 mètres**.",
     "L'**état sporadique E** correspond à des plaques denses d'ionisation dans la couche E.",
     "La propagation sporadique E peut étendre la portée des signaux au-delà de la normale.",
     "L'activité aurorale se produit dans la **couche E**, et orientez l'antenne vers le **nord** dans l'hémisphère nord pour en profiter.",
     "Le mode **CW** est le plus efficace lors de la propagation aurorale."
    ]
   },
   {
    "title": "Propagation troposphérique des ondes VHF",
    "body": "Les ondes VHF, notamment celles de 2 mètres, sont affectées par la réfraction et la conduction troposphériques. Ces phénomènes permettent des communications à plus grande distance que la portée directe normale.",
    "points": [
     "La réfraction troposphérique provoque la formation d'**ondes troposphériques** proches de la surface de la Terre.",
     "La conduction troposphérique est due à une **inversion de température** dans la troposphère.",
     "Elle permet de contacter des stations à plus de **800 km (500 milles)**.",
     "Au-delà de 800 km, la propagation est souvent due à la conduction troposphérique."
    ]
   }
  ],
  "B-007-006": [
   {
    "title": "Propagation des ondes radio et fréquence maximale utilisable (FMU)",
    "body": "La fréquence maximale utilisable (FMU) est la plus haute fréquence à laquelle un signal radio peut être réfléchi par l'ionosphère pour atteindre sa destination. Les signaux dont la fréquence dépasse la FMU traversent l'ionosphère sans être réfléchis.",
    "points": [
     "**FMU** : fréquence la plus élevée pour transmission ionosphérique réussie.",
     "Fréquences **plus basses que la FMU** : renvoyées vers la Terre par l'ionosphère.",
     "Fréquences **plus élevées que la FMU** : traversent l'ionosphère et ne reviennent pas.",
     "Fréquence maximale utilisable varie avec l'**intensité du rayonnement solaire UV**."
    ]
   },
   {
    "title": "Influence du cycle solaire et gestion des perturbations ionosphériques",
    "body": "La propagation HF dépend du cycle solaire et des conditions ionosphériques fluctuantes. Pour maintenir la communication, il faut ajuster la fréquence en fonction de la FMU, notamment lors de perturbations brusques.",
    "points": [
     "La propagation sur 20 mètres peut se faire durant tout le cycle solaire.",
     "En cas de perturbation ionosphérique soudaine, il faut essayer une **fréquence plus élevée**.",
     "La FMU est influencée par l'intensité des rayons UV solaires.",
     "Tester la réception d'une balise sur 28 MHz (bande 10 m) permet d'évaluer si la FMU permet la liaison Canada-Europe."
    ]
   },
   {
    "title": "Spécificités des bandes HF selon les saisons et la fréquence optimale",
    "body": "Certaines bandes HF sont plus sensibles aux saisons et à la période du jour. La fréquence optimale d'opération est légèrement inférieure à la FMU pour couvrir la meilleure distance et fiabilité.",
    "points": [
     "Les communications sur 80 mètres sont difficiles en été et le jour.",
     "Les bandes 160 et 80 mètres présentent plus de difficultés au-delà des ondes de sol en été pendant le jour.",
     "La fréquence optimale est généralement **un peu plus basse que la FMU** pour une propagation efficace."
    ]
   }
  ],
  "B-007-008": [
   {
    "title": "Propagation par mode dispersé en HF",
    "body": "La propagation par mode dispersé permet de recevoir des signaux faibles venant de zones où la réception est normalement difficile, appelées zones de silence. Ces signaux sont souvent faibles et déformés, particulièrement près ou au-dessus de la fréquence maximale utilisable.",
    "points": [
     "Les signaux dispersés ont une sonorité fluctuante ou caverneuse.",
     "La distorsion vient des trajets multiples empruntés par l'énergie dispersée vers la zone de silence.",
     "Seulement une petite partie de l'énergie de l'onde atteint la zone de silence, rendant les signaux faibles.",
     "Ce mode de propagation permet de recevoir des signaux trop loin pour les ondes de sol et trop près pour les ondes ionosphériques."
    ]
   },
   {
    "title": "Caractéristiques et contexte de la propagation par dispersion",
    "body": "La propagation par mode dispersé se manifeste sur les bandes HF lorsqu'on reçoit des signaux faibles, déformés, provenant de directions inhabituelles et proches ou supérieures à la fréquence maximale utilisable. Elle ne doit pas être confondue avec la dispersion par absorption ou le mode dispersé inversé.",
    "points": [
     "La propagation par mode dispersé n'inclut pas la dispersion par absorption ni le mode dispersé inversé.",
     "Elle est fréquente en HF pour des signaux proches de la fréquence maximale utilisable.",
     "Ce mode de propagation explique certains signaux faibles provenant de directions inattendues."
    ]
   },
   {
    "title": "Dispersion météorique et fréquences efficaces",
    "body": "La propagation par dispersion météorique est particulièrement efficace dans la bande des 6 mètres et dans la gamme 30 à 100 MHz pour les communications à longue distance grâce aux traînées ionisées des météores.",
    "points": [
     "La bande des **6 mètres** est la plus efficace pour la dispersion météorique.",
     "La gamme **30-100 MHz** est idéale pour les communications à grandes distances par ce mode.",
     "La dispersion météorique est un autre mode de propagation basé sur la réflexion d'ondes sur des particules ionisées."
    ]
   }
  ],
  "B-008-002": [
   {
    "title": "Sources et effets du brouillage RF sur les appareils audio domestiques",
    "body": "Les fils des haut-parleurs et autres câbles audio peuvent agir comme des antennes réceptrices captant des signaux radiofréquence (RF). Ces signaux peuvent provoquer un redressement audio, causant des distorsions ou des bruits dans les systèmes de sonorisation.",
    "points": [
     "**Fils d'enceintes longs** agissent souvent comme **antennes** captant des signaux RF.",
     "Le **redressement audio** produit des voix déformées (émissions BLU) ou des ronflements/clics (émissions CW).",
     "Le **brouillage RF** peut affecter les téléphones et les chaînes haute-fidélité même avec le volume réglé."
    ]
   },
   {
    "title": "Techniques de prévention et solutions au brouillage RF",
    "body": "Pour réduire ou éliminer le brouillage RF, on utilise des composants et méthodes spécifiques comme les bobines sur noyau de ferrite, les filtres RF, et une bonne mise à la terre de l'équipement.",
    "points": [
     "Utiliser des **bobines ou noyaux de ferrite** pour filtrer les signaux RF sur câbles audio et téléphones.",
     "**Raccourcir les fils** d'enceintes réduit leur capacité à capter les signaux RF.",
     "Enrouler les paires de fils audio autour d'un **anneau de ferrite** empêche la réception indésirable.",
     "Assurer une **mise à la terre correcte** de toute la station diminue les risques de redressement audio.",
     "Installer des **filtres RF** près des appareils affectés (ex : téléphones) pour supprimer le brouillage."
    ]
   }
  ],
  "B-008-001": [
   {
    "title": "Surcharge et Désensibilisation des Récepteurs",
    "body": "La surcharge d'un récepteur survient lorsqu'une station émettrice très puissante est proche, causant des interférences indépendantes de la fréquence. La désensibilisation, quant à elle, se produit quand un signal fort à proximité réduit la sensibilité du récepteur sur une fréquence voisine.",
    "points": [
     "**Surcharge** = interférence due à un émetteur puissant proche, brouillage stable quelle que soit la fréquence.",
     "**Désensibilisation** = réduction de la sensibilité du récepteur par un signal fort proche.",
     "Surcharge cause des interférences même si le récepteur change de fréquence.",
     "Désensibilisation provoque des problèmes quand plusieurs stations émettent proches en fréquence."
    ]
   },
   {
    "title": "Intermodulation et Brouillage RF",
    "body": "L'intermodulation est le phénomène où deux signaux hors bande se mélangent dans un récepteur, créant des signaux parasites sur une fréquence désirée. Cela peut causer des voix ou bruits indésirables sur le récepteur.",
    "points": [
     "**Intermodulation** = mélange de deux signaux hors bande produisant des brouillages sur une fréquence ciblée.",
     "Provoque apparition de signaux non désirés, par exemple voix d'un amateur dans un récepteur AM.",
     "Utiliser un **filtre approprié** réduit l'intermodulation."
    ]
   },
   {
    "title": "Filtres pour Prévenir les Brouillages",
    "body": "Les filtres adaptés permettent de prévenir la surcharge et l'intermodulation en éliminant les signaux indésirables. Par exemple, un filtre passe-haut placé sur le téléviseur bloque les fréquences basses HF évitant la surcharge RF.",
    "points": [
     "**Filtre passe-haut** au téléviseur bloque signaux HF pour prévenir surcharge.",
     "Installation de filtres appropriés au récepteur réduit intermodulation et interférences.",
     "Pour des brouillages liés à des émissions proches, le filtrage est la clé."
    ]
   }
  ],
  "B-008-003": [
   {
    "title": "Émissions Indésirables et Interférences",
    "body": "Les émissions indésirables proviennent d'un émetteur qui rayonne sur des fréquences hors de sa bande autorisée, causant des brouillages aux stations voisines. Cela peut se produire si l'appareil est mal blindé ou si le couvercle est retiré.",
    "points": [
     "Les émissions hors bande sont appelées **émissions indésirables**.",
     "Un émetteur mal blindé peut **rayonner des signaux indésirables**.",
     "Les appareils portatifs peuvent brouiller d'autres stations si ils émettent des **émissions indésirables**."
    ]
   },
   {
    "title": "Claquements de Manipulation en Code Morse",
    "body": "Les claquements en code Morse sont causés par une mauvaise mise en forme du signal, notamment des temps de montée et de descente trop rapides lors de l'ouverture et la fermeture du manipulateur. Un filtre de claquements réduit ces bruits indésirables.",
    "points": [
     "Les claquements sont produits par l'**ouverture et la fermeture rapide du circuit**.",
     "Une **mauvaise mise en forme** du signal provoque une largeur de bande excessive.",
     "Un **filtre de claquements** permet de prévenir ce type de brouillage.",
     "Si des claquements sont signalés, il faut **vérifier le filtre** et les étages du transmetteur."
    ]
   },
   {
    "title": "Oscillations Parasites en Émetteurs RF",
    "body": "Les oscillations parasites sont des signaux de résonance non désirés apparaissant à des fréquences différentes de celle de l'émission, provoquant des interférences et de la détérioration du signal.",
    "points": [
     "Une oscillation parasite est un **signal résonant non désiré** dans un émetteur.",
     "Elles peuvent survenir à des **fréquences plus basses ou plus élevées** que la fréquence d'émission.",
     "Les amplificateurs RF sont souvent la source de ces oscillations parasites."
    ]
   }
  ],
  "B-008-004": [
   {
    "title": "Les harmoniques : définition et origine",
    "body": "Les harmoniques sont des signaux indésirables dont la fréquence est un multiple entier de la fréquence fondamentale d'un émetteur. Ils résultent souvent d'une mauvaise conception ou d'un mauvais réglage de l'émetteur, notamment lorsque l'amplificateur RF est saturé.",
    "points": [
     "**Harmonique** = fréquence multiple de la fréquence fondamentale.",
     "Apparaissent lors de l'écrêtage ou d'un signal d'entrée trop fort.",
     "Présence fréquente dans les émetteurs mal réglés ou en surcharge.",
     "Rayonnement d'harmoniques peut causer des interférences hors bande."
    ]
   },
   {
    "title": "Effets des harmoniques et interférences associées",
    "body": "Les harmoniques provoquent des brouillages sur des fréquences autres que celles de l'émission principale, par exemple, sur des canaux de télévision. Un amplificateur poussé hors de sa zone linéaire génère un signal écrêté, ce qui accentue ces harmoniques.",
    "points": [
     "Harmoniques causent interférences sur d'autres services radio (ex : TV canal 3 : 60-66 MHz).",
     "Rayonnement d'harmoniques est non conforme et interdit hors bandes allouées.",
     "Modulation trop forte peut aussi provoquer un élargissement spectral (splatter).",
     "Brouillage fréquent sur canaux voisins si modulation mal maitrisée."
    ]
   },
   {
    "title": "Prévention et suppression des harmoniques",
    "body": "Pour réduire les harmoniques, on doit éviter l'écrêtage en diminuant le gain des amplificateurs et s'assurer qu'aucun signal d'attaque trop élevé n'entre dans les étages RF. Un contrôle rigoureux des réglages de l'émetteur est essentiel.",
    "points": [
     "Réduire le gain des amplificateurs microphoniques pour éviter l'écrêtage.",
     "Ne pas appliquer de signal d'attaque excessif aux étages d'amplification.",
     "Utiliser des filtres d'harmoniques et faire des réglages précis.",
     "Contrôler l'émission pour qu'elle ne dépasse pas la bande autorisée."
    ]
   }
  ],
  "B-008-005": [
   {
    "title": "Filtres en HF pour réduire les interférences",
    "body": "Les filtres sont essentiels pour contrôler quelles fréquences sont émises ou reçues, afin de minimiser les interférences causées par des signaux indésirables tels que les harmoniques.",
    "points": [
     "Un **filtre passe-bas** laisse passer les fréquences inférieures à une certaine fréquence de coupure et bloque les fréquences plus élevées, réduisant ainsi les harmoniques indésirables d'un émetteur HF.",
     "Un **filtre passe-bande** ne laisse passer qu'une plage étroite de fréquences, bloquant les signaux au-dessus et en dessous de cette plage.",
     "Un **filtre coupe-bande** bloque une gamme spécifique de fréquences tout en laissant passer celles inférieures ou supérieures à cette plage."
    ]
   },
   {
    "title": "Applications pratiques des filtres",
    "body": "L'intégration appropriée des filtres dans les équipements radioamateurs permet de réduire les interférences avec d'autres appareils et d'améliorer la qualité du signal.",
    "points": [
     "Les émetteurs HF modernes intègrent un **filtre passe-bas** dans le circuit de sortie RF pour diminuer le rayonnement des harmoniques au-dessus de la bande utile (généralement au-dessus de **30 MHz**).",
     "Le filtre passe-bas inséré dans une ligne de transmission doit avoir une **impédance proche de celle de la ligne** (typiquement **50 ohms**) pour minimiser les réflexions et pertes.",
     "Pour éviter que l'énergie RF pénètre dans un téléviseur et cause des interférences, on installe un **filtre passe-haut** au connecteur d'antenne du téléviseur, bloquant les signaux indésirables en dessous d'une certaine fréquence."
    ]
   }
  ]
 },
 "advanced": {
  "A-001-002": [
   {
    "title": "Effet pelliculaire (Skin Effect)",
    "body": "L'effet pelliculaire est le phénomène par lequel, à haute fréquence, le courant RF circule principalement en surface d'un conducteur. Cela augmente la résistance apparente du conducteur aux courants RF.",
    "points": [
     "**Courant RF** circule dans une mince couche à la surface du conducteur",
     "Plus la fréquence augmente, plus la couche conductrice est mince",
     "Conséquence : résistance efficace plus élevée pour le courant RF comparée au courant continu"
    ]
   },
   {
    "title": "Champs électromagnétiques et stockage de l'énergie",
    "body": "Un courant électrique crée un champ électromagnétique autour d'un conducteur. Ce champ contient de l'énergie potentielle, qui peut être stockée dans des composants passifs comme les condensateurs et les bobines.",
    "points": [
     "Le champ magnétique autour d'un fil est orienté selon la règle de la main gauche",
     "Un condensateur stocke l'énergie dans un champ électrostatique entre ses plaques",
     "La capacité d'un condensateur se mesure en **Farad**",
     "Une bobine stocke l'énergie dans un champ magnétique, caractérisé par son inductance en **Henry**"
    ]
   }
  ],
  "A-001-001": [
   {
    "title": "Constante de temps dans les circuits RC et RL",
    "body": "La constante de temps, notée τ (tau), caractérise la vitesse de charge et décharge d'un condensateur dans un circuit RC ou la variation du courant dans un circuit RL. Elle correspond au temps pendant lequel la réponse du circuit atteint environ 63,2 % de sa valeur finale.",
    "points": [
     "**Constante de temps (τ)** : temps nécessaire pour atteindre **63,2 %** de la valeur maximale lors de la charge (condensateur ou courant, selon le circuit).",
     "En circuit RC, τ = R × C, avec R en ohms (Ω) et C en farads (F).",
     "En circuit RL, la constante de temps représente aussi le temps pour que le courant atteigne **63,2 %** de sa valeur finale.",
     "La constante de temps mesure également le temps de décharge à **36,8 %** (valeur résiduelle) pour un condensateur."
    ]
   },
   {
    "title": "Charge et décharge dans un circuit RC",
    "body": "Lors de la charge ou décharge d'un condensateur, la tension varie selon la constante de temps τ. Après deux constantes de temps, la charge atteint environ 86,5 % de la tension appliquée en charge et tombe à 13,5 % de la tension initiale en décharge.",
    "points": [
     "Après **2 τ**, tension en charge ≈ **86,5 %** de la tension appliquée.",
     "Après **2 τ**, tension en décharge ≈ **13,5 %** de la tension initiale.",
     "La constante de temps est précise : par ex., avec C = 100 μF et R = 470 kΩ, τ = 47 secondes.",
     "Pour C = 470 μF et R = 470 kΩ, τ = 221 secondes; pour C = 220 μF et R = 470 kΩ, τ = 103 secondes."
    ]
   },
   {
    "title": "Force contre-électromotrice (f.c.é.m.)",
    "body": "La force contre-électromotrice est une tension qui s'oppose à la tension appliquée dans un circuit, notamment créée par les inductances qui s'opposent aux variations du courant.",
    "points": [
     "La f.c.é.m. agit contre la force électromotrice appliquée.",
     "Elle ralentit l'augmentation ou la diminution du courant dans un circuit inductif.",
     "Elle est responsable du délai dans l'établissement du courant dans un circuit RL."
    ]
   }
  ],
  "A-001-003": [
   {
    "title": "Circuit RLC en série et fréquence de résonance",
    "body": "La fréquence de résonance d'un circuit RLC en série dépend des valeurs de l'inductance (L) et de la capacité (C). La résistance (R) n'influence pas directement cette fréquence mais affecte la qualité du circuit.",
    "points": [
     "La fréquence de résonance f₀ est donnée par la formule : **f₀ = 1 / (2π √(L × C))**",
     "L est l'inductance en henrys (H), généralement en microhenrys (μH) pour la radioamateur (1 μH = 10⁻⁶ H)",
     "C est la capacité en farads (F), souvent en picofarads (pF) (1 pF = 10⁻¹² F)",
     "La fréquence f₀ est en hertz (Hz), souvent convertie en mégahertz (MHz)",
     "La réduction de L ou C augmente la fréquence de résonance, leur augmentation la diminue"
    ]
   },
   {
    "title": "Calculs pratiques pour la fréquence et capacité",
    "body": "Pour calculer la fréquence de résonance, convertissez les microhenrys et picofarads en henrys et farads avant d'utiliser la formule. Pour trouver la capacité quand la fréquence et l'inductance sont données, inversez la formule.",
    "points": [
     "Convertir L en henrys : **L (H) = L (μH) × 10⁻⁶**",
     "Convertir C en farads : **C (F) = C (pF) × 10⁻¹²**",
     "Calcul de fréquence : **f₀ = 1 / (2π √(L × C))** en Hz",
     "Calcul de capacité : **C = 1 / ((2π f₀)² × L)** en farads",
     "Exemple : L=2,84 μH, f₀=14,25 MHz → C ≈ 44 pF"
    ]
   }
  ],
  "A-001-004": [
   {
    "title": "Fréquence de résonance d'un circuit RLC parallèle",
    "body": "La fréquence de résonance d'un circuit RLC parallèle est déterminée par l'inductance (L) et la capacité (C). La résistance (R) n'influence pas la fréquence de résonance, mais affecte la qualité du circuit.",
    "points": [
     "**Fréquence de résonance (f₀)** en Hertz se calcule par la formule :",
     "**f₀ = 1 / (2π √(L × C))**",
     "L s'exprime en Henries (H), souvent microhenrys (μH = 10⁻⁶ H)",
     "C s'exprime en Farads (F), souvent picofarads (pF = 10⁻¹² F)",
     "La résonance survient où l'impédance est maximale dans le cas parallèle"
    ]
   },
   {
    "title": "Calculs pratiques de la fréquence de résonance",
    "body": "Pour calculer f₀, convertissez L et C dans les unités de base (H, F), puis appliquez la formule. Exemples fréquents pour L en microhenrys et C en picofarads donnent des fréquences en MHz.",
    "points": [
     "Exemple : L = 1 μH, C = 10 pF → f₀ ≈ 50,3 MHz",
     "Augmenter L ou C diminue f₀, car ils sont sous la racine au dénominateur",
     "Fréquences obtenues typiquement entre quelques MHz et plusieurs dizaines de MHz",
     "Une fréquence donnée et une capacité connue permettent de calculer l'inductance :",
     "L = 1 / ( (2πf₀)² × C )"
    ]
   }
  ],
  "A-002-001": [
   {
    "title": "Matériaux semi-conducteurs courants",
    "body": "Les semi-conducteurs sont des matériaux qui ont des caractéristiques à la fois métalliques et isolantes. Les deux éléments les plus utilisés sont le silicium et le germanium.",
    "points": [
     "Le silicium et le germanium sont les matériaux semi-conducteurs les plus courants.",
     "À l'état pur, le silicium et le germanium sont de bons isolants.",
     "Un semi-conducteur pur devient conducteur lorsqu'il est dopé avec des impuretés."
    ]
   },
   {
    "title": "Types et dopage des semi-conducteurs",
    "body": "Le dopage introduit des impuretés pour augmenter la conductivité des semi-conducteurs. On distingue les semi-conducteurs de type P et de type N selon les porteurs de charge majoritaires.",
    "points": [
     "Le type P a moins d'électrons libres que le cristaux purs et utilise les trous comme porteurs majoritaires.",
     "Le type N a plus d'électrons libres que les cristaux purs, avec les électrons libres comme porteurs majoritaires.",
     "Le dopage modifie la conductivité en introduisant des impuretés spécifiques."
    ]
   },
   {
    "title": "Usage spécifique des semi-conducteurs",
    "body": "Pour les applications en micro-ondes, on utilise un matériau semi-conducteur différent appelé arséniure de gallium qui convient mieux à ces fréquences élevées.",
    "points": [
     "L'arséniure de gallium est utilisé pour les fréquences micro-ondes.",
     "Le silicium et le germanium ne sont pas adaptés pour les très hautes fréquences."
    ]
   }
  ],
  "A-001-005": [
   {
    "title": "Facteur de qualité (Q) dans un circuit RLC parallèle",
    "body": "Le facteur de qualité, ou Q, caractérise la sélectivité d'un circuit RLC parallèle à la résonance. Il dépend de la fréquence de résonance, de l'inductance et de la résistance du circuit.",
    "points": [
     "**Q = 2πfL / R** où : f = fréquence de résonance (Hz), L = inductance (Henrys), R = résistance (Ohms)",
     "**Q élevé** signifie une bande passante étroite et une meilleure sélectivité.",
     "**Q faible** signifie une bande passante plus large et moins de sélectivité."
    ]
   },
   {
    "title": "Calcul pratique du facteur Q dans un circuit RLC parallèle",
    "body": "Pour calculer Q, convertissez toujours les unités correctement (microhenrys en henrys, kilo-ohms en ohms) et appliquez la formule du facteur de qualité pour un circuit RLC parallèle.",
    "points": [
     "Convertissez L : 1 microhenry (µH) = 1×10⁻⁶ H",
     "Convertissez R selon unité : 1 kilo-ohm (kΩ) = 1000 Ω",
     "Calculez Q avec la formule : **Q = (2π × f × L) / R**",
     "Exemple : f=14,128 MHz = 14.128×10⁶ Hz, L=2,7 µH = 2.7×10⁻⁶ H, R=18 kΩ = 18000 Ω"
    ]
   },
   {
    "title": "Rôle de la résistance dans un circuit résonant parallèle",
    "body": "Ajouter une résistance dans un circuit parallèle diminue le facteur Q, ce qui augmente la largeur de bande du circuit et réduit sa sélectivité.",
    "points": [
     "Augmenter R augmente Q, accrue sélectivité mais bande passante étroite",
     "Diminuer R diminue Q, réduit la sélectivité mais élargit la bande passante",
     "Contrôle de Q permet d'adapter les caractéristiques du circuit aux besoins (filtrage, stabilité)"
    ]
   }
  ],
  "A-002-003": [
   {
    "title": "Transistors bipolaires : notions clés",
    "body": "Les transistors bipolaires NPN et PNP régulent le courant entre l'émetteur et le collecteur en fonction du courant de base. Le type NPN conduit lorsque la base est positive, et le PNP lorsque la base est négative.",
    "points": [
     "Un transistor NPN conduit de l'émetteur négatif au collecteur positif si la base est alimentée positivement.",
     "Un transistor PNP conduit de l'émetteur positif au collecteur négatif si la base est alimentée négativement.",
     "Le courant dans le collecteur dépend fortement du courant fourni à la base."
    ]
   },
   {
    "title": "Rapports alpha (α) et bêta (β) dans les transistors bipolaires",
    "body": "Les rapports alpha et bêta caractérisent le gain en courant selon le montage utilisé. Alpha est le gain en base commune, bêta en émetteur commun ou collecteur commun.",
    "points": [
     "Le rapport alpha (α) = variation du courant collecteur / variation du courant émetteur.",
     "Le rapport bêta (β) = variation du courant collecteur / variation du courant base.",
     "Relations importantes : α = β / (1 + β) et β = α / (1 - α)."
    ]
   },
   {
    "title": "Montages et gains de courant",
    "body": "Le montage en base commune utilise le rapport alpha, tandis que les montages émetteur commun et collecteur commun utilisent le rapport bêta avec un gain de courant plus élevé.",
    "points": [
     "Montage base commune : gain direct en courant = α, généralement proche de 1.",
     "Montage émetteur commun et collecteur commun : gain en courant = β, souvent élevé à très élevé.",
     "Le choix du montage dépend des besoins en amplification et en impédance."
    ]
   }
  ],
  "A-002-002": [
   {
    "title": "Caractéristiques des Diodes à Semi-conducteurs",
    "body": "Les diodes sont des composants semi-conducteurs essentiels avec différentes structures et usages. Les deux principales catégories physiques sont les diodes à jonction et les diodes à point de contact.",
    "points": [
     "Les diodes à jonction ont une jonction PN classique, utilisées pour la redressement et la régulation.",
     "Les diodes à point de contact sont principalement utilisées comme détecteurs de radiofréquences (RF).",
     "Les diodes PIN comprennent une couche intrinsèque, ce qui les rend utiles comme commutateurs RF.",
     "Les paramètres clés des diodes à jonction incluent le courant direct maximal et la tension inverse de crête."
    ]
   },
   {
    "title": "Diodes Spécifiques et Applications",
    "body": "Certaines diodes ont des propriétés particulières adaptées à des fonctions spécifiques en radiofréquence et régulation de tension.",
    "points": [
     "La diode Zener maintient une **tension constante** malgré les variations du courant, utilisée pour la stabilisation de tension.",
     "La capacité interne du varactor varie en fonction de la tension appliquée, ce qui permet son usage en accordage électronique.",
     "La diode Schottky, dite \"hot carrier\", est idéale pour les mélangeurs et détecteurs en UHF et VHF grâce à sa faible chute de tension et rapidité.",
     "La limitation du courant maximal en polarisation directe d'une diode est due à la **température de la jonction**."
    ]
   },
   {
    "title": "Puissance et Température des Diodes Zener",
    "body": "La puissance et la température influencent les performances des diodes Zener, une considération essentielle en conception.",
    "points": [
     "Pour une diode Zener de **10 V, 50 W**, le courant maximal à la puissance nominale est **5 A** (P = U × I donc I = 50 W / 10 V).",
     "La puissance nominale est spécifiée à **25 °C** (température ambiante standard).",
     "Une augmentation de la température engendre une **diminution** de la puissance utilisable pour la diode Zener."
    ]
   }
  ],
  "A-002-006": [
   {
    "title": "Classes d'amplificateurs : notions de base",
    "body": "Les amplificateurs sont classés A, B, AB, ou C selon la portion du cycle du signal qu'ils amplifient et leur linéarité.",
    "points": [
     "Classe A amplifie pendant **le cycle complet (360°)**, assurant une excellente linéarité et faible distorsion.",
     "Classe B amplifie pendant **180° du cycle**, avec une efficacité meilleure que la classe A mais plus de distorsion.",
     "Classe AB travaille entre **180° et 360°**, un compromis entre linéarité et rendement.",
     "Classe C amplifie pendant **moins de 180°**, offrant le rendement le plus élevé mais la moindre linéarité."
    ]
   },
   {
    "title": "Rendement et distorsion des classes d'amplification",
    "body": "Le choix de la classe dépend de l'application, entre linéarité et efficacité.",
    "points": [
     "La classe A a **le plus faible rendement** mais la meilleure qualité de signal (linéarité maximale).",
     "La classe C offre **le rendement le plus élevé** mais induit une distorsion importante, utile pour les signaux avec modulation simple (CW, FM, RTTY).",
     "La classe AB combine une bonne linéarité et un rendement acceptable, adaptée aux signaux modulés complexes."
    ]
   }
  ],
  "A-002-005": [
   {
    "title": "Introduction au redresseur commandé au silicium (SCR)",
    "body": "Le redresseur commandé au silicium, ou SCR, est un composant semi-conducteur utilisé principalement comme interrupteur contrôlé dans les circuits électroniques.",
    "points": [
     "Le SCR a **trois bornes** : l'**anode**, la **cathode** et la **gâchette** (ou porte), qui sert à le déclencher.",
     "Sa structure interne est de type **PNPN**, correspondant à une succession de couches de semi-conducteurs.",
     "Il appartient à la famille des **thyristors**, composants à plusieurs jonctions."
    ]
   },
   {
    "title": "Fonctionnement du SCR et ses états",
    "body": "Le SCR fonctionne essentiellement dans deux états : conducteur ou non conducteur, selon la commande de la gâchette.",
    "points": [
     "Lorsqu'une tension positive est appliquée à la gâchette, le SCR passe en état de **conductivité** et agit comme une diode en polarisation directe entre l'anode et la cathode.",
     "En l'absence de déclenchement, il reste dans un état de **non-conductivité** et bloque le passage du courant.",
     "Une fois déclenché, il continue à conduire même si la porte n’est plus alimentée, jusqu’à ce que le courant chute en dessous d’un certain seuil."
    ]
   },
   {
    "title": "Applications pratiques du SCR en radioamateur",
    "body": "En radioamateurisme, le SCR est couramment utilisé pour protéger les équipements contre les surtensions électriques.",
    "points": [
     "Le SCR est notamment employé dans les circuits de **protection de surtension (crowbar)** dans les blocs d'alimentation.",
     "Son déclenchement rapide permet de sécuriser les composants sensibles en court-circuitant temporairement la surtension.",
     "Sa capacité à agir comme un interrupteur contrôlé en fait un élément clé pour la gestion puissance dans les équipements."
    ]
   }
  ],
  "A-002-004": [
   {
    "title": "Introduction aux Transistors à Effet de Champ (TEC)",
    "body": "Les TEC régulent le passage du courant entre le drain et la source par la tension appliquée à la porte. Il existe deux types principaux: à enrichissement et à appauvrissement, qui diffèrent par le comportement du canal en l'absence de tension à la porte.",
    "points": [
     "**TEC à enrichissement**: pas de canal conducteur à 0 V sur la porte, donc pas de courant.",
     "**TEC à appauvrissement**: canal existant à 0 V, le courant circule sans tension à la porte.",
     "Bornes d'un JFET: **porte**, **drain**, **source**.",
     "Deux types de JFET: canal **P** et canal **N**."
    ]
   },
   {
    "title": "Fonctionnement des MOSFET et Protection",
    "body": "Les MOSFET ont un canal dont la conductivité varie selon la polarisation de la porte, enrichissant ou appauvrissant le canal de type N ou P. Des diodes Zener intégrées protègent la porte des surtensions et décharges électrostatiques.",
    "points": [
     "MOSFET à appauvrissement canal N: le courant diminue car le canal est appauvri.",
     "MOSFET à enrichissement canal N: le canal se forme et le courant augmente.",
     "MOSFET à appauvrissement canal P: déplacement des trous réduit le canal.",
     "MOSFET à enrichissement canal P: déplacement des trous augmente la conduction.",
     "Diode Zener intégrée protège la porte du claquage par électrostatique ou surtension."
    ]
   },
   {
    "title": "Impédance et Manipulation des TEC",
    "body": "Les TEC offrent une haute impédance d'entrée, ce qui les rend sensibles aux charges électrostatiques, contrairement aux transistors bipolaires qui ont une basse impédance d'entrée.",
    "points": [
     "**Haute impédance d'entrée** des TEC protège le circuit mais nécessite une manipulation soigneuse.",
     "Les transistors bipolaires ont une **basse impédance d'entrée**.",
     "Éviter les décharges électrostatiques pour ne pas endommager les FET et CMOS."
    ]
   }
  ],
  "A-002-007": [
   {
    "title": "Amplificateurs à transistor à effet de champ (FET)",
    "body": "Les amplificateurs FET peuvent être montés en source commune, drain commun ou porte commune, chaque configuration ayant des caractéristiques spécifiques.",
    "points": [
     "Montage **source commune**: impédance d'entrée principalement déterminée par le circuit de polarisation de la porte.",
     "Impédance de sortie d'un montage source commune: dominée par la résistance de charge au drain.",
     "Montage **drain commun** (ou source follower): présente une haute impédance d'entrée et une basse impédance de sortie, utile pour adaptation d'impédance."
    ]
   },
   {
    "title": "Correspondances entre circuits FET et bipolaires",
    "body": "Chaque montage d'amplificateur FET correspond à un type classique d'amplificateur à transistor bipolaire.",
    "points": [
     "Source commune FET est équivalent à l'amplificateur en **émetteur commun** BJT.",
     "Drain commun FET correspond à l'amplificateur en **collecteur commun** BJT.",
     "Porte commune FET est similaire à l'amplificateur en **base commune** BJT."
    ]
   },
   {
    "title": "Caractéristiques des amplificateurs bipolaires",
    "body": "Les montages en base, émetteur et collecteur commun ont des propriétés de phase et d'impédance spécifiques.",
    "points": [
     "En base commune: signal d'entrée et sortie sont **en phase**, impédance d'entrée est **très basse**.",
     "En émetteur commun: signal de sortie est déphasé de **180°** par rapport à l'entrée.",
     "En collecteur commun: signal d'entrée et sortie sont **en phase**; ce montage offre gain proche de 1 mais bonne adaptation d'impédance.",
     "Paire Darlington offre un gain élevé avec haute impédance d'entrée et basse impédance de sortie."
    ]
   }
  ],
  "A-002-009": [
   {
    "title": "Fonctionnement du mélangeur",
    "body": "Le procédé de mélange consiste à combiner deux signaux d'entrée pour produire des signaux aux fréquences qui représentent leur somme et leur différence. Ces fréquences sont appelées fréquences mélangeées et elles comprennent aussi les fréquences originales.",
    "points": [
     "**Mélangeur**: combine deux signaux pour obtenir la somme et la différence de leurs fréquences",
     "Sortie contient: fréquences originales + somme + différence",
     "Un signal trop fort sur un mélangeur génère des signaux indésirables (distorsion et intermodulation)",
     "Un mélangeur est notamment utilisé dans un émetteur pour transformer une fréquence d'entrée en une fréquence de sortie différente"
    ]
   },
   {
    "title": "Multiplicateurs de fréquence et accords dans un circuit",
    "body": "Un multiplicateur de fréquence utilise un transistor fonctionnant en classe C, un condensateur de blocage CC à la base, une bobine d'arrêt RF, ainsi qu'un circuit accordé formé par une bobine (L1) et un condensateur variable (C2). Ce circuit est réglé pour résonner à l'harmonique désirée, afin de produire une fréquence plus élevée que la fréquence d'entrée.",
    "points": [
     "Le transistor est couplé à la base par un **condensateur de blocage CC** qui bloque le courant continu",
     "La bobine d'arrêt RF empêche un passage direct du signal RF vers la masse",
     "Le transistor fonctionne en **classe C** pour l'efficacité dans la génération d'harmoniques",
     "Le circuit L1 + C2 est accordé pour résonner sur une fréquence harmonique du signal d'entrée, assurant la multiplication de fréquence",
     "Un condensateur fixe (C3) placé entre VCC+ et la masse sert de **condensateur de découplage RF**, stabilisant l'alimentation"
    ]
   }
  ],
  "A-002-008": [
   {
    "title": "Introduction aux Amplificateurs Opérationnels",
    "body": "Un amplificateur opérationnel est un amplificateur différentiel à couplage direct et à gain élevé, dont les caractéristiques sont fixées par des composants externes. Il est largement utilisé en électronique, notamment en radioamateur.",
    "points": [
     "**Amplificateur différentiel** : compare deux tensions d'entrée.",
     "**Gain élevé** : amplification importante du signal d'entrée.",
     "**Caractéristiques dépendantes** des composants externes (résistances, condensateurs).",
     "Impédance d'entrée très élevée (idéalement infinie) et impédance de sortie très faible (idéalement nulle)."
    ]
   },
   {
    "title": "Fonctionnement et Caractéristiques Idéales",
    "body": "Un amplificateur opérationnel idéal a un gain infini, une réponse en fréquence uniforme, une très haute impédance d'entrée et une impédance de sortie pratiquement nulle. Le gain réel en boucle fermée est déterminé par le circuit de rétroaction externe.",
    "points": [
     "**Gain infini** en boucle ouverte (sans rétroaction).",
     "Le **circuit de rétroaction (feedback)** définit le gain en boucle fermée.",
     "**Tension de décalage (offset voltage)** : faible tension entre les entrées même sans signal appliqué.",
     "L'impédance d'entrée élevée minimise la charge sur la source.",
     "La faible impédance de sortie permet de driver efficacement la charge."
    ]
   },
   {
    "title": "Applications en Radioamateur et Types d'Amplificateurs",
    "body": "Les amplificateurs opérationnels remplacent souvent les composants LC dans les filtres audio actifs, offrant un gain au lieu d’un affaiblissement. Les filtres actifs RC avec amplificateurs opérationnels sont couramment utilisés en réception radioamateur pour le traitement audio.",
    "points": [
     "Le filtre actif RC avec op amp est utilisé comme **filtre audio dans les récepteurs**.",
     "Utilisation d'amplificateurs pour obtenir du **gain au lieu de perte de signal** (contrairement aux filtres LC passifs).",
     "**Amplificateur inverseur** : sortie déphasée de 180° par rapport à l'entrée.",
     "**Amplificateur non inverseur** : sortie en phase avec l'entrée."
    ]
   }
  ],
  "A-002-011": [
   {
    "title": "Propriétés et applications des cristaux de quartz",
    "body": "Les cristaux de quartz exploitent l'effet piézo-électrique, qui produit une tension lorsqu'ils sont déformés mécaniquement. Électriquement, un cristal agit comme un circuit syntonisé ayant un facteur Q très élevé, ce qui permet une excellente stabilité et sélectivité en fréquence.",
    "points": [
     "**Effet piézo-électrique** : tension générée par déformation de cristaux spécifiques",
     "Un cristal électrique = circuit syntonisé avec **facteur Q élevé**",
     "Utilisé pour obtenir une **stabilité de fréquence supérieure** dans les oscillateurs",
     "Les cristaux ne conviennent pas aux filtres actifs"
    ]
   },
   {
    "title": "Filtres en treillis à quartz et oscillateurs associés",
    "body": "Les filtres en treillis à quartz sont des filtres à bande étroite avec pente raide, composés de plusieurs cristaux dont la fréquence relative détermine la largeur de bande et la forme de réponse. Les oscillateurs à cristal peuvent fonctionner en mode fondamental ou en mode partiel (harmonique).",
    "points": [
     "Filtre en treillis = filtre à **bande étroite** et **pente raide** avec cristaux",
     "La largeur de bande dépend de la **relation entre fréquences des cristaux**",
     "Pour la bande latérale unique en phonie, largeur typique ≈ **2,4 kHz**",
     "Oscillateur en mode partiel produit fréquence à un **multiple** du cristal",
     "Oscillateurs à cristal ont stabilité bien supérieure aux oscillateurs LC"
    ]
   }
  ],
  "A-002-010": [
   {
    "title": "Portes logiques fondamentales",
    "body": "Les portes logiques sont des circuits électroniques traitant des signaux numériques en entrée pour produire une sortie selon une fonction logique spécifique.",
    "points": [
     "Porte AND produit **1** seulement si **toutes les entrées sont 1**.",
     "Porte OR produit **1** si **au moins une entrée est 1**.",
     "Porte NOT (inverseur) produit une sortie inversée : en entrée 1, sortie **0**.",
     "Porte NAND (NON-ET) produit une sortie **0** seulement si **toutes les entrées sont 1**.",
     "Porte NOR (NON-OU) produit une sortie **0** si **au moins une entrée est 1**."
    ]
   },
   {
    "title": "Portes logiques exclusives et combinées",
    "body": "Ces portes traitent les entrées selon des règles plus spécifiques pour certaines applications numériques.",
    "points": [
     "Porte XOR (OU exclusif) produit un **1** si **une seule entrée est à 1**.",
     "Porte XNOR (NON-OU exclusif) produit un **1** si **toutes les entrées sont à 1**."
    ]
   },
   {
    "title": "Circuits bistables: bascules et multivibrateurs",
    "body": "Les bascules sont des circuits logiques avec deux états stables, utilisés pour mémoriser une information binaire.",
    "points": [
     "Un circuit à bascule (flip-flop) a **deux états stables** et sert à stocker des bits.",
     "Multivibrateur bistable est un autre nom pour un **flip-flop**.",
     "Circuit à verrouillage (latch) est un type de flip-flop.",
     "Dans un multivibrateur, quand un transistor conduit, l'autre est **en mode coupure**."
    ]
   }
  ],
  "A-003-001": [
   {
    "title": "Mesure des tensions en courant alternatif (CA)",
    "body": "La tension dans un circuit CA sinusoïdal peut être caractérisée par plusieurs valeurs : la tension de crête, la tension crête à crête et la tension efficace (RMS). La tension de crête à crête est la différence entre la valeur maximale et minimale, facile à mesurer à l'oscilloscope.",
    "points": [
     "**Tension de crête à crête** : différence entre la valeur maxi et mini de l'onde",
     "**Tension efficace (RMS)** : égalise la puissance dissipée par rapport au courant continu",
     "Pour une onde sinusoïdale, la tension efficace est environ **70,7% de la tension de crête**",
     "La tension de crête à crête est donc environ **2,828 fois la valeur RMS**"
    ]
   },
   {
    "title": "Calculs et relations importantes pour les mesures CA",
    "body": "Pour une onde sinusoïdale pure, on relie la tension de crête, la tension crête à crête et la valeur efficace par des formules précises. La valeur efficace est la plus couramment utilisée car elle reflète la puissance dissipée équivalente en courant continu.",
    "points": [
     "Tension efficace (RMS) = Tension de crête × **0,707**",
     "Tension crête à crête = Tension de crête × **2**",
     "Tension crête à crête = Tension efficace × **2,828** (environ)",
     "Exemple : une tension crête à crête de 340 V correspond à une tension efficace de **120 V**",
     "Le voltmètre CA est étalonné pour afficher la tension efficace (RMS)"
    ]
   }
  ],
  "A-002-012": [
   {
    "title": "Types de filtres en radioamateur",
    "body": "Il existe trois principaux groupes de filtres utilisés en radio : les filtres passe-bas, passe-haut et passe-bande, chacun adapté à des besoins spécifiques de fréquence.",
    "points": [
     "**Passe-bas** : laisse passer les fréquences inférieures à une fréquence de coupure.",
     "**Passe-haut** : laisse passer les fréquences supérieures à une fréquence de coupure.",
     "**Passe-bande** : laisse passer une plage spécifique de fréquences entre deux valeurs."
    ]
   },
   {
    "title": "Filtres Butterworth et Tchebychev",
    "body": "Le filtre Butterworth est caractérisé par une réponse en fréquence avec une bande passante très uniforme, tandis que le filtre Tchebychev présente des ondulations dans la bande passante mais des pentes de coupure plus abruptes.",
    "points": [
     "Le filtre **Butterworth** offre une courbe de réponse la plus rectiligne, utile pour des signaux à bande passante constante.",
     "Le filtre **Tchebychev** accepte une ondulation dans la bande passante afin d'obtenir des transitions plus nettes entre bandes passantes et atténuation.",
     "Le choix entre eux dépend du compromis souhaité entre ondulation et pente de filtrage."
    ]
   },
   {
    "title": "Filtres et résonateurs en VHF et au-delà",
    "body": "Aux fréquences VHF et plus élevées, on utilise des cavités résonantes comme filtres passe-bande étroits et des résonateurs hélicoïdaux pour protéger et améliorer la réception.",
    "points": [
     "Les **cavités résonantes** fonctionnent comme filtres passe-bande très étroits adaptés aux fréquences VHF et supérieures.",
     "Une cavité d'un quart de longueur d'onde pour 50 MHz fait environ **1,5 mètre (5 pieds)** de longueur avec un diamètre autour de **10 cm (4 pouces)**.",
     "Le **résonateur hélicoïdal** placé à l'entrée RF prévient la surcharge et atténue les signaux indésirables.",
     "Les cavités ne sont pas adaptées aux fréquences audio et basses fréquences radio.",
     "Pour une largeur de bande proche d'un canal de télévision en VHF, aucun des filtres classiques n'est optimal."
    ]
   }
  ],
  "A-003-002": [
   {
    "title": "Puissance en crête de modulation (PEP) en émission RF",
    "body": "La puissance en crête de modulation (PEP) correspond à la puissance maximale fournie à la ligne de transmission durant le cycle RF au sommet de l'enveloppe de modulation. Elle se calcule à partir de la tension crête mesurée en sortie dans une charge résistive.",
    "points": [
     "**PEP** = puissance maximale durant un cycle RF au pic de modulation.",
     "Charge typique de mesure : **50 ohms** résistifs.",
     "Tension mesurée souvent en **crête à crête** (Vpp) ou en crête (Vp)."
    ]
   },
   {
    "title": "Calcul de la puissance en crête de modulation",
    "body": "Pour convertir la tension crête à crête mesurée en puissance, on transforme la mesure en valeur efficace (RMS), puis on applique la loi de l'électricité pour une charge résistive. Formules clés utilisent la tension crête de l'enveloppe et la résistance de charge.",
    "points": [
     "Valeur efficace (RMS) = tension crête × **0,707**.",
     "Puissance = (V_RMS)² ÷ résistance de charge.",
     "Pour tension crête à crête (Vpp), Vp = Vpp ÷ 2.",
     "Exemple : PEP = ((0,707 × Vp)²) / R.",
     "PEP indique la puissance maximale, différente de la puissance moyenne."
    ]
   },
   {
    "title": "Exemples pratiques pour charge de 50 ohms",
    "body": "Utiliser la formule pour des tensions courantes mesurées à l'oscilloscope permet de trouver rapidement la PEP. La puissance moyenne, en absence de modulation (porteuse non modulée), est égale à la puissance en crête.",
    "points": [
     "200 Vpp → Vp = 100 V; PEP = (0,707×100)² ÷ 50 ≈ **100 watts**.",
     "500 Vpp → Vp = 250 V; PEP = (0,707×250)² ÷ 50 ≈ **625 watts**.",
     "800 Vpp → Vp = 400 V; PEP = (0,707×400)² ÷ 50 ≈ **1600 watts**.",
     "Porteuse non modulée : puissance moyenne = puissance en crête.",
     "Puissance moyenne avec 500 Vpp (non modulée) = **625 watts**."
    ]
   }
  ],
  "A-003-003": [
   {
    "title": "Ondemètre dynamique (Dip Meter) : principes et utilisations",
    "body": "Un ondemètre dynamique est un oscillateur à fréquence variable dont le niveau d'activité est visible sur un indicateur. Il sert principalement à identifier la fréquence de résonance des circuits, notamment en radioamateur.",
    "points": [
     "C'est un oscillateur à fréquence variable avec indicateur d'activité.",
     "Utilisé pour déceler la fréquence de résonance d'un circuit syntonisé en parallèle.",
     "Doit être couplé légèrement au circuit testé pour une bonne précision.",
     "Ne peut pas mesurer directement les valeurs de capacité ou d'inductance."
    ]
   },
   {
    "title": "Applications spécifiques et précision de l'ondemètre dynamique",
    "body": "L'ondemètre dynamique est utile pour vérifier les fréquences de résonance des pièges d'antennes et autres circuits syntonisés. La puissance de sortie de l'émetteur n'affecte pas la précision de la mesure.",
    "points": [
     "Mesure la fréquence de résonance des pièges d'antennes et circuits syntonisés.",
     "Ne permet pas la mesure directe de capacité ou d'inductance.",
     "La puissance de sortie n'affecte pas la précision.",
     "L'atténuateur de sortie d'un générateur de signaux est précis seulement si bien adapté."
    ]
   },
   {
    "title": "Générateur de signaux et mesure de la sensibilité FM",
    "body": "Le générateur de signaux est un oscillateur stable capable de produire diverses fréquences et amplitudes. Pour mesurer la sensibilité d'un récepteur FM au rapport SINAD de 12 dB, on combine un générateur RF modulé en FM avec un analyseur de distorsion harmonique.",
    "points": [
     "Générateur de signaux : oscillateur stable à large plage de fréquences et amplitudes.",
     "Mesure de sensibilité FM (SINAD 12 dB) utilise un générateur RF avec modulation FM par tonalité.",
     "Un analyseur de distorsion harmonique (THD) complète la mesure."
    ]
   }
  ],
  "A-003-004": [
   {
    "title": "Fonction et précision du fréquencemètre",
    "body": "Un fréquencemètre sert à mesurer la fréquence d'un signal. Sa précision dépend principalement de la qualité de sa base de temps, de la vitesse des circuits logiques et de la stabilité de cette base.",
    "points": [
     "Un fréquencemètre mesure la fréquence d'un signal électrique.",
     "La base de temps interne est souvent un oscillateur à cristal pour une haute stabilité.",
     "La précision est limitée par la stabilité et la précision de la base de temps et la vitesse des circuits.",
     "Améliorer la base de temps améliore directement la précision de mesure."
    ]
   },
   {
    "title": "Calcul de l'erreur de mesure selon la précision",
    "body": "L'erreur maximale d'une mesure se calcule en multipliant la fréquence mesurée par la précision en PPM (parties par million) de la base de temps.",
    "points": [
     "Erreur (Hz) = Fréquence (Hz) × Précision (PPM) / 1 000 000",
     "Pour 0,1 PPM et 146 520 000 Hz, erreur max = 14,652 Hz",
     "Pour 10 PPM et 146 520 000 Hz, erreur max = 1465,2 Hz"
    ]
   },
   {
    "title": "Étalonnage et stabilité des oscillateurs",
    "body": "L'étalonnage des fréquencemètres et oscillateurs se fait souvent par battement avec un signal horaire stable, comme WWV. Seuls certains oscillateurs, comme les oscillateurs à cristal classiques, sont considérés à haute stabilité.",
    "points": [
     "L'oscillateur à cristal est la base de temps standard pour un fréquencemètre numérique.",
     "Un générateur de repères utilise un oscillateur basse fréquence riche en harmoniques pour calibrer les cadrans.",
     "L'oscillateur à cristal commandé en tension (VCXO) n'est pas considéré de haute stabilité intrinsèquement.",
     "La méthode de battement nul (« zero-beat ») compare l'oscillateur à un signal horaire pour vérifier sa précision.",
     "La note de battement doit être la plus basse possible pour une mesure précise, c’est-à-dire avec une longue période."
    ]
   }
  ],
  "A-003-005": [
   {
    "title": "Principes de base de l'oscilloscope",
    "body": "L'oscilloscope permet de visualiser des signaux électriques en fonction du temps ou en mode XY pour observer des relations entre deux signaux.",
    "points": [
     "Un signal de 100 Hz en horizontal et 150 Hz en vertical produit un tracé à boucles (courbes de Lissajous) avec 3 boucles horizontales et 2 verticales.",
     "La largeur de bande de l'oscilloscope correspond à la plus haute fréquence qu'il peut afficher correctement.",
     "Un oscilloscope à deux traces sert à comparer simultanément deux signaux, par exemple l'entrée et la sortie d'un circuit."
    ]
   },
   {
    "title": "Facteurs affectant la qualité de l'oscilloscope",
    "body": "Plusieurs éléments limitent la précision et la fidélité des mesures sur un oscilloscope.",
    "points": [
     "La précision de la base de temps, la linéarité et la largeur de bande des amplificateurs de déviation sont essentiels pour une bonne réponse en fréquence et stabilité.",
     "On améliore la réponse en fréquence en augmentant la vitesse du balayage horizontal et la bande passante de l'amplificateur vertical.",
     "Une sonde d'oscilloscope doit être compensée à chaque fois qu'elle est connectée à un oscilloscope différent, pour garantir la fidélité du signal."
    ]
   },
   {
    "title": "Applications pratiques et limitations",
    "body": "L'oscilloscope est un outil puissant mais avec des limites spécifiques à certaines mesures.",
    "points": [
     "Les courbes de Lissajous permettent de déterminer le déphasage entre signaux ; un déphasage de 0° ou 180° se traduit par une ligne droite diagonale.",
     "Pour un signal inconnu en vertical et 100 kHz en horizontal, le nombre de boucles permet de calculer la fréquence inconnue (ex : 5 boucles verticales, 2 horizontales = 40 kHz).",
     "L'oscilloscope ne permet pas de mesurer directement l'excursion de fréquence d'une porteuse FM.",
     "Pour vérifier la qualité d'un signal émis, connectez l'entrée verticale de l'oscilloscope à un échantillonneur de la sortie RF de l'émetteur.",
     "L'oscilloscope est l'instrument recommandé pour analyser la qualité des signaux CW et BLU."
    ]
   }
  ],
  "A-003-006": [
   {
    "title": "Adaptation des appareils de mesure : ampèremètre et voltmètre",
    "body": "Pour modifier la gamme de mesure d'un ampèremètre ou d'un voltmètre, on utilise des résistances en dérivation ou en série selon le type de mesure souhaité.",
    "points": [
     "**Ampèremètre** : pour augmenter le courant maximal mesurable, on place une résistance faible en parallèle (résistance shunt) afin de dériver une partie du courant et protéger l'appareil.",
     "**Voltmètre** : pour étendre la plage de tension, on ajoute une résistance élevée en série afin de réduire le courant traversant l'appareil et augmenter la tension mesurable.",
     "Exemples : un ampèremètre de 40 µA avec 96 Ω interne peut être transformé  pour lire jusqu'à 1 mA avec un shunt de **4 Ω** ; un voltmètre 1 mA / 0.5 Ω modifié pour 20 V nécessite une résistance série de près de **19999.5 Ω**."
    ]
   },
   {
    "title": "Sensibilité et principe de fonctionnement des appareils",
    "body": "La sensibilité caractérise la capacité de l'appareil à détecter un signal faible et s'exprime différemment selon qu'il s'agit d'ampèremètre ou de voltmètre.",
    "points": [
     "Sensibilité d'un ampèremètre : le **courant plein échelle** (exemple : 1 mA signifie un appareil très sensible).",
     "Sensibilité d'un voltmètre : exprimée en **ohms par volt**, elle indique la résistance interne par volt mesuré (exemple : 1000 Ω/V signifie une résistance totale de 150 000 Ω pour 150 V).",
     "Un voltmètre de 20 kΩ/V correspond à un microampèremètre de 50 µA (faible courant de bobine mobile).",
     "Le passage d'une gamme basse à haute tension sur un multimètre ajoute une résistance en série, limitant ainsi le courant traversant le mouvement mobile."
    ]
   },
   {
    "title": "Mesure de puissance RF : wattmètre",
    "body": "Pour mesurer correctement la puissance RF d'un émetteur, le wattmètre doit être placé à la sortie correspondant à l'impédance caractéristique de l'émetteur.",
    "points": [
     "La mesure doit être faite **à la sortie de l'émetteur** pour obtenir des données fiables.",
     "La plupart des wattmètres RF sont conçus pour fonctionner avec une **impédance de 50 ohms**, correspondant à la norme des équipements radio."
    ]
   }
  ],
  "A-004-003": [
   {
    "title": "Principes des régulateurs de tension",
    "body": "Les régulateurs de tension maintiennent une tension stable malgré les variations de charge ou de source. Il existe deux types principaux : linéaire et à découpage.",
    "points": [
     "Régulateur linéaire : l'élément régulateur ajuste sa conduction proportionnellement à la tension source ou au courant de charge.",
     "Régulateur à découpage : contrôle en alternant entre marche et arrêt proportionnellement aux conditions de la ligne et de la charge.",
     "Une diode Zener est utilisée comme référence de tension stable dans les régulateurs linéaires."
    ]
   },
   {
    "title": "Régulateurs linéaires spécifiques",
    "body": "Les régulateurs linéaires se déclinent en plusieurs types adaptés aux besoins d’application et d’efficacité énergétique.",
    "points": [
     "Le régulateur en série offre le meilleur rendement énergétique parmi les régulateurs linéaires.",
     "Le régulateur en dérivation est utilisé quand la charge demande un courant constant à la source non régulée.",
     "Le 'remote sensing' permet d'asservir un régulateur linéaire directement à la charge via une rétroaction distincte."
    ]
   },
   {
    "title": "Régulateur à trois bornes et caractéristiques clés",
    "body": "Les régulateurs à trois bornes intègrent plusieurs composants dans un seul boîtier pour une régulation efficace.",
    "points": [
     "Intègrent une référence de tension, un amplificateur d'erreur, des résistances de détection de courant et un transistor ballast.",
     "Principales caractéristiques : gamme de tensions d'entrée, tension de sortie nominale et courant de sortie maximal.",
     "Utilisés pour des alimentations nécessitant une faible ondulation et une tension stable malgré les fluctuations."
    ]
   }
  ],
  "A-004-001": [
   {
    "title": "Principes des blocs d'alimentation et redresseurs",
    "body": "Un bloc d'alimentation convertit le courant alternatif (CA) en courant continu (CC) à l'aide de redresseurs. Le redresseur en pont fournit la tension moyenne la plus élevée pour une même tension secondaire de transformateur, car il utilise pleinement les deux alternances du courant d'entrée.",
    "points": [
     "**Redresseur en pont** utilise les deux alternances et donne une tension moyenne plus élevée que les redresseurs simple ou double alternance avec prise médiane.",
     "Le redresseur double alternance avec **prise médiane** utilise une prise centrale au secondaire pour redresser les deux alternances mais avec une sortie inférieure à celle du pont.",
     "Le redresseur simple alternance redresse une seule alternance avec une fréquence d'ondulation égale à **60 Hz** (fréquence du courant domestique)."
    ]
   },
   {
    "title": "Tensions, fréquences et ondulations",
    "body": "La tension inverse de crête aux bornes d'une diode peut être élevée selon la configuration du redresseur et la charge. La fréquence d'ondulation dépend du type de redressement et monte à 120 Hz en double alternance sur le courant domestique à 60 Hz.",
    "points": [
     "Dans une alimentation simple alternance avec filtre, la tension inverse de crête peut atteindre **2,8 fois** la tension efficace lorsque la charge est faible ou nulle.",
     "Dans un redresseur double alternance (avec prise médiane ou pont), la tension inverse de crête est aussi de **2,8 fois** la tension efficace, peu importe la charge.",
     "La fréquence d'ondulation pour un redresseur double alternance est de **120 Hz**, soit le double de la fréquence du réseau électrique.",
     "La forme d'onde sur une charge résistive alimentée par un redresseur double alternance sans filtrage est une série d'impulsions à **deux fois** la fréquence du CA."
    ]
   },
   {
    "title": "Composants et sécurité dans les blocs d'alimentation",
    "body": "Les diodes en silicium ont des limites nominales importantes à respecter. Des protections supplémentaires améliorent la fiabilité et préviennent des surtensions dangereuses.",
    "points": [
     "Deux valeurs nominales à ne jamais dépasser pour les diodes : la **tension inverse de crête** et le **courant moyen en polarisation directe**.",
     "Les résistances et condensateurs connectés en parallèle avec les diodes égalisent les chutes de tension entre diodes en série et bloquent les surtensions transitoires.",
     "Les doubleurs de tension utilisent les deux moitiés de l'onde alternative pour obtenir une tension plus élevée sans transformer."
    ]
   }
  ],
  "A-005-001": [
   {
    "title": "Types d'oscillateurs et leur rétroaction positive",
    "body": "Les oscillateurs Hartley, Colpitts et Pierce utilisent différents moyens pour assurer la rétroaction positive nécessaire à l'oscillation. Cette rétroaction renforce le signal à la fréquence désirée.",
    "points": [
     "L'oscillateur Hartley utilise une **bobine à prise** pour la rétroaction positive.",
     "L'oscillateur Colpitts utilise un **diviseur capacitif** pour le couplage de rétroaction.",
     "L'oscillateur Pierce utilise un **couplage capacitif en série** avec le cristal pour la rétroaction."
    ]
   },
   {
    "title": "Stabilité et composants des oscillateurs",
    "body": "La stabilité est cruciale en radio pour maintenir une fréquence constante. Les oscillateurs utilisent des composants spécifiques pour minimiser les variations et le bruit.",
    "points": [
     "L'oscillateur Colpitts est souvent choisi pour les VFO en raison de sa **bonne stabilité**.",
     "Les condensateurs de rétroaction dans les oscillateurs haute stabilité sont généralement des **condensateurs mica argenté** pour réduire les pertes et variations.",
     "Un oscillateur de référence stable est nécessaire dans un synthétiseur à boucle à phase (PLL) car toute **variation de phase génère du bruit de phase** à la sortie."
    ]
   },
   {
    "title": "Applications pratiques des oscillateurs et amplificateurs",
    "body": "Combiner un oscillateur avec un amplificateur approprié permet de créer des émetteurs efficaces en radioamateur.",
    "points": [
     "Un oscillateur produisant une **rétroaction positive via un diviseur capacitif** est de type **Colpitts**.",
     "Un oscillateur comportant un seul condensateur en série avec un cristal est un oscillateur de type **Pierce**.",
     "Un circuit basé sur la rétroaction positive peut constituer un **oscillateur à fréquence variable (VFO)**.",
     "Un émetteur CW efficace utilise un oscillateur associé à un amplificateur de **classe C** sur deux étages."
    ]
   }
  ],
  "A-004-004": [
   {
    "title": "Principes des blocs d'alimentation stabilisée",
    "body": "Un bloc d'alimentation convertit et stabilise la tension. Il utilise un transformateur, un pont redresseur, un condensateur de filtrage, et un régulateur de tension pour fournir une tension continue stable.",
    "points": [
     "Le pont redresseur est formé par **quatre diodes** qui convertissent le courant alternatif en courant continu.",
     "Le condensateur électrolytique suit le pont redresseur pour lisser la tension continue avant la régulation.",
     "Les fusibles protègent le circuit en coupant l'alimentation en cas de surcharge ou court-circuit.",
     "Le régulateur de tension maintient une tension de sortie constante malgré les variations de charge et d'entrée."
    ]
   },
   {
    "title": "Fonctionnement et caractéristiques clés",
    "body": "La régulation garantit la stabilité de tension au point de surveillance, améliorée par un condensateur de sortie de grande valeur. Le transistor de régulation dissipe de la puissance proportionnelle au courant et à la chute de tension.",
    "points": [
     "La tension de sortie la plus stable se mesure au point où l'amplificateur d'erreur ou le réseau d’échantillonnage est connecté.",
     "La dissipation de puissance dans le transistor pass est égale à la **tension d'entrée moins sortie** multipliée par le courant de charge.",
     "La résistance de charge est calculée par **la tension de sortie divisée par le courant total débité**, incluant le courant du 'bleeder'.",
     "La régulation statique intervient pour des variations de charge à long terme, la régulation dynamique pour des variations rapides.",
     "Augmenter la valeur du condensateur de sortie améliore la régulation dynamique, particulièrement important pour émetteurs BLU ou code Morse."
    ]
   },
   {
    "title": "Protections et composants associés",
    "body": "Des diodes de protection autour du régulateur évitent les dommages causés par des surtensions inverses susceptibles d’apparaître lors de mises hors tension rapides.",
    "points": [
     "Une diode placée entre les bornes d'entrée et de sortie du régulateur protège contre les tensions inverses accidentelles.",
     "Le 'bleeder' est une résistance de fuite destinée à stabiliser la tension aux bornes du condensateur de sortie en minimisant les effets de la variation de charge.",
     "La bonne conception de l’alimentation prend en compte à la fois la régulation statique et dynamique pour assurer un fonctionnement fiable."
    ]
   }
  ],
  "A-005-002": [
   {
    "title": "Adaptation d'impédance et transfert de puissance",
    "body": "Dans un émetteur, un réseau d'adaptation variable de type Pi permet d'ajuster l'impédance de sortie d'un amplificateur de puissance pour optimiser le transfert d'énergie vers l'antenne.",
    "points": [
     "Le réseau Pi ajuste l'impédance pour assurer un transfert efficace de la puissance.",
     "Une bonne adaptation minimise les pertes et les réflexions vers l'amplificateur.",
     "Un transfert optimal améliore la puissance rayonnée par l'antenne."
    ]
   },
   {
    "title": "Amplificateur en grille commune avec triode à vide",
    "body": "Le fonctionnement de l'amplificateur en grille commune repose sur des connexions spécifiques du tube pour assurer une amplification efficace en radiofréquence.",
    "points": [
     "Le signal d'entrée est appliqué à la **cathode** du tube.",
     "L'anode est connectée au réseau Pi via un **condensateur de blocage** pour isoler le courant continu.",
     "L'anode est reliée à la haute tension **B+** par une bobine d'arrêt RF, limitant les courants alternatifs.",
     "La cathode est connectée à la polarisation **B-** à travers une bobine d'arrêt RF.",
     "Le filament est alimenté via un transformateur, dont l'enroulement secondaire est connecté directement au tube."
    ]
   },
   {
    "title": "Précautions et réduction des harmoniques",
    "body": "Pour garantir la sécurité et la performance après intervention sur un amplificateur RF, certaines mesures sont indispensables.",
    "points": [
     "Toujours remettre en place tous les blindages de l'amplificateur avant de remettre sous tension pour éviter les interférences et assurer la sécurité.",
     "Les harmoniques générées dans les premiers étages peuvent être atténuées en utilisant des couplages par circuits accordés entre les étages, améliorant la qualité du signal émis."
    ]
   }
  ],
  "A-005-004": [
   {
    "title": "Modulation en bande latérale unique (BLU)",
    "body": "La modulation BLU supprime la porteuse et une des deux bandes latérales, ce qui réduit la bande passante et améliore l'efficacité du signal.",
    "points": [
     "Un modulateur équilibré produit un signal à **double bande latérale** avec la **porteuse supprimée**.",
     "La BLU est obtenue en combinant un **modulateur équilibré** suivi d'un **filtre** pour enlever une bande latérale.",
     "La suppression de la porteuse se fait dans l'**étage du modulateur équilibré**.",
     "La porteuse est supprimée d'au moins **40 dB** par rapport à la puissance crête de sortie.",
     "Comparée à l'AM ordinaire, la BLU donne un gain de **6 dB** à l'émetteur et **3 dB** au récepteur."
    ]
   },
   {
    "title": "Tests et linéarité d'un émetteur BLU",
    "body": "Pour garantir la qualité de la transmission BLU, on teste la linéarité de l'émetteur avec des signaux à deux tonalités observés sur un oscilloscope.",
    "points": [
     "Le test à deux tonalités utilise **deux signaux sinusoïdaux audio sans relation harmonique** à l'entrée du microphone.",
     "La puissance crête mesurée est égale à **deux fois la puissance de sortie RF** d'une seule tonalité.",
     "L'observation sur un oscilloscope permet de mesurer la **linéarité** de l'amplificateur de l'émetteur.",
     "L'**écrêtage du signal** (flat topping) désigne la distorsion causée par un signal d'attaque trop fort, déformant la forme d'onde."
    ]
   }
  ],
  "A-005-003": [
   {
    "title": "Émetteur à ondes entretenues (CW) : architecture et fonctions",
    "body": "Un émetteur CW comprend principalement un oscillateur et un amplificateur de puissance de classe C, couplés par un transformateur RF qui joue aussi un rôle crucial dans le circuit résonant.",
    "points": [
     "Le transformateur RF assure le couplage inductif entre l'oscillateur et l'amplificateur de puissance.",
     "Ce transformateur fait partie d'un circuit résonant, important pour la sélectivité en fréquence.",
     "L'amplificateur de puissance de classe C est utilisé pour amplifier le signal RF en sortie."
    ]
   },
   {
    "title": "Filtrage et neutralisation dans l'amplificateur de puissance",
    "body": "La bobine d'arrêt RF et les condensateurs forment un filtre passe-bas qui élimine les harmoniques indésirables, tandis que la neutralisation est utilisée pour éviter les oscillations parasites dans l'amplificateur RF.",
    "points": [
     "La bobine d'arrêt RF avec des condensateurs à la masse forment un filtre passe-bas pour nettoyer le signal.",
     "La neutralisation annule les effets de rétroaction positive qui provoquent des oscillations parasites.",
     "La neutralisation est essentielle pour assurer la stabilité des amplificateurs, notamment à tubes ou transistors.",
     "Les oscillations parasites prennent souvent naissance dans les amplificateurs de puissance RF à cause de résonances accidentelles."
    ]
   },
   {
    "title": "Avantages et réglages dans les émetteurs CW",
    "body": "L'utilisation d'un étage tampon réduit les variations de fréquence de l'oscillateur, et la bonne neutralisation se détecte par un changement minimal dans le courant de grille lors de la modification du circuit de sortie.",
    "points": [
     "L'étage tampon stabilise la fréquence en isolant l'oscillateur des charges variables.",
     "La meilleure neutralisation est indiquée par une variation minimale du courant de grille.",
     "Neutraliser l'étage final élimine les oscillations parasites, garantissant un signal propre et stable."
    ]
   }
  ],
  "A-004-002": [
   {
    "title": "Filtres et régulation dans les blocs d'alimentation",
    "body": "Les blocs d'alimentation utilisent principalement deux types de filtres : à inductance (bobine) à l'entrée ou à condensateur à l'entrée. Le filtre à bobine en tête assure une meilleure régulation de la tension tandis que le filtre à condensateur en tête fournit une tension de sortie plus élevée.",
    "points": [
     "Filtres courants : **filtre à inductance (bobine) à l'entrée** et **filtre à condensateur à l'entrée**.",
     "Le filtre à bobine d'arrêt à l'entrée donne la **meilleure régulation avec charge normale**.",
     "Le filtre à condensateur en tête offre une **tension de sortie plus élevée**.",
     "**Bobine en série** : laisse passer le courant continu, bloque la composante alternative (ondulation)."
    ]
   },
   {
    "title": "Dimensionnement et sécurité des composants",
    "body": "La valeur nominale des bobines dépend de leur inductance et du courant qu'elles doivent supporter. Les condensateurs doivent avoir une tension nominale adaptée à la tension de crête, surtout pour éviter les surtensions liées aux résonances possibles entre la première bobine et le premier condensateur.",
    "points": [
     "Bobines choisies selon **inductance** et **courant maximal supporté**.",
     "Toujours privilégier un condensateur avec une **tension nominale correspondant à la tension de crête** du transformateur.",
     "Risque de surtension dû à la résonance série entre la première bobine et le premier condensateur.",
     "Résistance de fuite (« bleeder ») décharge les condensateurs à la coupure et **améliore la régulation**."
    ]
   },
   {
    "title": "Aspects pratiques et fonctionnement",
    "body": "Pour maintenir un courant minimal dans un filtre à inductance à l'entrée, on utilise une résistance de fuite. Cette configuration évite des problèmes liés à la résonance et protège les redresseurs contre les pics de courant et de tension.",
    "points": [
     "Une **résistance de fuite (« bleeder »)** est nécessaire pour décharger les condensateurs quand l'alimentation est coupée.",
     "La résistance de fuite assure aussi un **courant minimal permanent** dans le filtre à inductance.",
     "Un redresseur à double alternance avec filtre à bobine d'arrêt offre la **meilleure régulation** sous charge.",
     "Résonance mal contrôlée peut provoquer des **pics de tension et de courant dangereux**."
    ]
   }
  ],
  "A-005-005": [
   {
    "title": "Comprendre la modulation de fréquence (FM) et l'indice de modulation",
    "body": "En modulation de fréquence, la variation instantanée de la fréquence porteuse est proportionnelle à l'amplitude du signal modulant. L'indice de modulation (β) est le rapport entre l'excursion maximale de fréquence et la fréquence modulante.",
    "points": [
     "**Excursion de fréquence** : déviation maximale de la fréquence porteuse (en Hz).",
     "**Indice de modulation (β) = Excursion de fréquence / Fréquence modulante**.",
     "Exemple : une excursion de ±3 000 Hz avec une fréquence modulante de 1 000 Hz donne β = 3.",
     "L'indice de modulation reflète l'ampleur de la variation de fréquence par rapport à la fréquence modulante."
    ]
   },
   {
    "title": "Facteur d'excursion (Deviation Ratio) et calcul de la largeur de bande FM",
    "body": "Le facteur d'excursion (ou deviation ratio) est le rapport entre l'excursion de fréquence maximale et la fréquence modulante maximale. La largeur de bande essentielle d'une émission FM peut être estimée par la règle de Carson.",
    "points": [
     "**Facteur d'excursion = Excursion maximale / Fréquence modulante maximale**.",
     "Exemple : excursion ±5 kHz et fréquence modulante 3 kHz ⇒ facteur ≈ 1,66.",
     "**Largeur de bande essentielle (carson) ≈ 2 × (excursion + fréquence modulante)**.",
     "Pour excursion ±5 kHz et fréquence modulante 3 kHz : BW ≈ 2 × (5 000 + 3 000) = 16 kHz."
    ]
   },
   {
    "title": "Caractéristiques supplémentaires et mesures en FM",
    "body": "La fréquence porteuse non modulée est appelée fréquence centrale. L'excursion dépend uniquement de l'amplitude du signal modulant. Les excursiomètres mesurent l'excursion en fonction de la fréquence et de l'indice de modulation. Lors d'une conversion de fréquence (mélangeur), l'excursion se divise proportionnellement.",
    "points": [
     "Fréquence centrale = fréquence de la porteuse non modulée (signal modulant à zéro).",
     "L'excursion dépend **seulement de l'amplitude** du signal de modulation.",
     "Onde FM modulée par une seule tonalité génère un nombre infini de fréquences latérales.",
     "Excursiomètres nécessitent connaissance de la fréquence modulante et de l'indice de modulation.",
     "Lors d'une conversion de fréquence, l'excursion se calcule par : (excursion sortie × fréquence oscillateur) / fréquence sortie."
    ]
   }
  ],
  "A-005-007": [
   {
    "title": "Commande Automatique de Niveau (ALC) et Compression dans les Émetteurs BLU",
    "body": "La commande automatique de niveau, ou ALC, est un circuit essentiel dans un émetteur BLU pour maintenir constante la puissance de sortie RF de crête. La compression de la voix permet d'amplifier les signaux faibles tout en réduisant l'amplification des signaux forts, assurant une modulation efficace et stable.",
    "points": [
     "**ALC (Commande Automatique de Niveau)** maintient la puissance RF de crête constante.",
     "La **compression vocale** amplifie les signaux faibles et réduit ceux qui sont forts.",
     "ALC est aussi connu sous le nom de **compression RF**.",
     "Écrêtage audio mal appliqué augmente la **distorsion harmonique**."
    ]
   },
   {
    "title": "Traitement Numérique des Signaux et Gamme Dynamique",
    "body": "Un processeur de signal numérique (DSP) convertit d'abord un signal analogique en numérique, traite le signal par des transformations mathématiques, puis le convertit en analogique pour filtrage. La résolution d'échantillonnage détermine la précision, où 8 bits permettent 256 niveaux distincts et chaque bit ajouté augmente la gamme dynamique d'environ 6 dB.",
    "points": [
     "Un **processeur de signal numérique** utilise un convertisseur A/N, traitement mathématique, convertisseur N/A et filtre passe-bas.",
     "**8 bits** correspondent à **256 niveaux** distincts (2^8 = 256).",
     "Chaque bit ajouté augmente la gamme dynamique d'environ **6 dB**.",
     "Un amplificateur de repliement n'est pas une fonction d'un processeur de signal numérique."
    ]
   },
   {
    "title": "Principes et Limitations du Traitement des Signaux",
    "body": "Le traitement des signaux analogiques n'inclut pas la division de fréquence. Pour limiter les crêtes dans les signaux, on évite l'écrêtage spectral, qui induit des distorsions indésirables. Construire un écrêteur RF est plus complexe que son homologue audio.",
    "points": [
     "La **division de fréquence** n'est pas associée au traitement analogique des signaux.",
     "L'**écrêtage spectral** n'est pas une méthode valide pour limiter les crêtes.",
     "L'écrêtage fréquentiel audio peut causer une **augmentation de la distorsion harmonique**.",
     "Un **écrêteur RF** est plus difficile à construire que l'écrêteur audio."
    ]
   }
  ],
  "A-005-009": [
   {
    "title": "Introduction à l'étalement du spectre",
    "body": "L'étalement du spectre est une méthode de modulation dans laquelle la porteuse RF est modifiée selon une séquence prédéterminée, ce qui permet une communication à large bande.",
    "points": [
     "**Étalement du spectre (spread spectrum)** : technique de communication à large bande.",
     "Permet d'améliorer la résistance aux interférences et la sécurité.",
     "Le signal modulé semble pseudo-aléatoire mais suit une séquence connue du récepteur."
    ]
   },
   {
    "title": "Techniques d'étalement du spectre : Sauts de fréquence et Séquence directe",
    "body": "Il existe deux principales méthodes : les sauts de fréquence où la fréquence de la porteuse change rapidement, et la séquence directe où la phase de la porteuse est modifiée par un flot binaire rapide.",
    "points": [
     "**Sauts de fréquence (frequency hopping)** : fréquence centrale change suivant une liste pseudo-aléatoire plusieurs fois par seconde.",
     "**Séquence directe (direct sequence)** : phase de la porteuse modifiée rapidement par une séquence binaire pseudo-aléatoire.",
     "Les deux techniques sont des formes d'étalement du spectre employées pour sécuriser et rendre robuste la communication."
    ]
   },
   {
    "title": "Avantages et fonctionnement de l'étalement du spectre",
    "body": "La synchronisation entre émetteur et récepteur est essentielle. Cette technique rend difficile l'interception et l'interférence car seuls les récepteurs synchronisés reçoivent clairement le signal.",
    "points": [
     "Un signal pseudo-aléatoire synchronisé contrôle la modulation de la porteuse.",
     "Les signaux non conformes à l'algorithme d'étalement du spectre sont supprimés à la réception.",
     "**Résistance aux interférences** grâce au filtrage des signaux non synchrones.",
     "Fréquence ou phase de la porteuse varie selon une séquence connue uniquement des utilisateurs légitimes."
    ]
   }
  ],
  "A-005-008": [
   {
    "title": "Codes et Encodages en Radioamateur",
    "body": "Les codes numériques utilisés en radioamateur varient selon leurs caractéristiques et usages. Le code Varicode est un code binaire à longueurs variables utilisé pour transmettre efficacement des caractères fréquents avec moins de bits. Le code Baudot est un code à **5 bits** tandis que l'extension ISO-8859 du code ASCII utilise **8 bits**.",
    "points": [
     "**Varicode** : code à longueurs variables optimisé pour le texte.",
     "**Code Baudot** : fixe, 5 bits d'information par caractère.",
     "**ASCII étendu (ISO-8859)** : 8 bits, inclut minuscules, majuscules et symboles.",
     "ASCII inclut lettres majuscules et minuscules, contrairement au code Baudot."
    ]
   },
   {
    "title": "Transmission, Erreurs et Protocoles",
    "body": "Les communications numériques en radioamateur utilisent différentes méthodes pour détecter et corriger les erreurs. Le contrôle de redondance cyclique (CRC) sert exclusivement à la détection d'erreurs. Les corrections d'erreur peuvent être faites via des répétitions de caractères (AMTOR FEC) ou via un protocole de correction automatique par répétition (AMTOR ARQ).",
    "points": [
     "Le **CRC** est un algorithme de hachage utilisé pour détecter les erreurs dans les données.",
     "AMTOR Mode A (ARQ) utilise la correction automatique par répétition avec interaction entre stations.",
     "AMTOR Mode B (FEC) double chaque caractère émis pour corriger les erreurs par redondance.",
     "Le mode **AX.25** est associé aux communications par paquets numériques."
    ]
   },
   {
    "title": "Architecture et Fonctions en Communication Radioamateur",
    "body": "L'architecture des systèmes de communication se base souvent sur le modèle OSI. Le branchement entre un contrôleur de nœud terminal (TNC) et un ordinateur relève de la couche **physique**. Le système APRS est utilisé pour le reporting et la localisation, mais il ne réalise pas l'établissement automatique de liaison.",
    "points": [
     "Modèle OSI : le raccordement TNC - ordinateur est à la couche **Physique**.",
     "APRS (Automatic Packet Reporting System) ne gère pas l'établissement automatique de liaison.",
     "Le protocole AX.25 est souvent utilisé avec APRS pour la transmission en mode paquet."
    ]
   }
  ],
  "A-005-006": [
   {
    "title": "Intermodulation et interférences entre répéteurs",
    "body": "L'intermodulation se produit lorsque les signaux de deux répéteurs proches se mélangent dans un amplificateur, créant des signaux indésirables à des fréquences somme ou différence. Ce phénomène cause des brouillages sur des fréquences voisines.",
    "points": [
     "**Intermodulation** = mélange non linéaire des signaux dans un amplificateur.",
     "Cause : proximité des répéteurs et mélange des signaux dans un amplificateur de puissance.",
     "Exemple: un récepteur à 146,70 MHz peut être brouillé par émetteurs à 146,52 MHz et 146,34 MHz ou 146,61 MHz.",
     "Réduction : installation d'un **circulateur avec terminaison** (ou isolateur en ferrite) dans la ligne de transmission."
    ]
   },
   {
    "title": "Modulation, circuits et filtres en émetteur FM",
    "body": "La modulation de fréquence (FM) est générée par un modulateur de phase qui fait varier la syntonisation du circuit résonant. Un circuit de préaccentuation atténue les basses fréquences audio pour améliorer la qualité du signal.",
    "points": [
     "Le modulateur de phase modifie la fréquence du signal porteur par variation de phase.",
     "La **préaccentuation** atténue les basses fréquences dans le signal audio FM.",
     "Un compresseur et un écrêteur sont placés entre l'amplificateur audio et le modulateur pour améliorer la sonorité.",
     "Filtres idéaux pour duplexeur 2 mètres : filtres à **cavités**, offrant faible perte et bonne sélectivité."
    ]
   },
   {
    "title": "Paramètres clés et composants en émetteur FM",
    "body": "La puissance, l'excursion de fréquence et la stabilité en fréquence sont les trois paramètres essentiels à vérifier sur un émetteur FM. Les produits d'intermodulation n'apparaissent généralement pas à l'étage de fréquence intermédiaire.",
    "points": [
     "Paramètres à contrôler : **puissance**, **excursion de fréquence**, **stabilité en fréquence**.",
     "La préaccentuation distingue un modulateur de phase d'un modulateur de fréquence.",
     "Les brouillages par intermodulation ne sont pas typiques de l'étage de fréquence intermédiaire."
    ]
   }
  ],
  "A-006-001": [
   {
    "title": "Principe du Récepteur Superhétérodyne",
    "body": "Le récepteur superhétérodyne convertit la fréquence du signal reçu en une fréquence intermédiaire (FI) pour faciliter le traitement. Cette conversion améliore la sélectivité et permet une conception optimale des circuits résonants.",
    "points": [
     "La conversion en FI améliore la réjection des signaux hors-bande.",
     "La FI est choisie pour minimiser la fréquence image et les interférences.",
     "L'étage amplificateur RF comprend un circuit d'entrée et de sortie accordés à la fréquence réceptionnée."
    ]
   },
   {
    "title": "Fréquence Intermédiaire et Conversions Multiples",
    "body": "Le choix de la fréquence intermédiaire dépend du rejet de la fréquence image et de la minimisation des réponses parasites. Les récepteurs à double conversion utilisent deux FI successives pour améliorer la sélectivité et réduire le brouillage et la fréquence image.",
    "points": [
     "Une fréquence FI mal choisie augmente la réception de la fréquence image.",
     "Le récepteur à double conversion comporte deux oscillateurs locaux et deux étages FI.",
     "Le premier FI est utilisé pour le rejet de la fréquence image, le second pour une meilleure sélectivité.",
     "Plusieurs conversions augmentent le risque de réponses parasites à cause des multiples oscillateurs."
    ]
   },
   {
    "title": "Fonctionnement des Étapes Clés",
    "body": "L'étage mélangeur se situe entre un étage accordable (filtré sur la fréquence reçue) et un étage à fréquence fixe. L'oscillateur local opère à une fréquence calculée pour produire la FI lors du mélange. Par exemple, pour une FI de 9 MHz et une fréquence locale à 16 MHz, la fréquence reçue est 7 MHz.",
    "points": [
     "Le filtre à cristal est placé dans les circuits FI pour affiner la sélectivité.",
     "L'étage mélangeur convertit le signal reçu à la FI en utilisant l'oscillateur local.",
     "Le récepteur à double conversion est moins sensible au brouillage provenant de la fréquence image.",
     "Une conception avec double conversion améliore la sélectivité et réduit le bruit indésirable."
    ]
   }
  ],
  "A-006-002": [
   {
    "title": "Fonctionnement du récepteur superhétérodyne",
    "body": "Le récepteur superhétérodyne convertit le signal radio capté en une fréquence intermédiaire (FI) plus facile à traiter, grâce à un mélangeur et un oscillateur local.",
    "points": [
     "Le **mélangeur** combine le signal capté avec celui de l'oscillateur local pour produire une **fréquence intermédiaire (FI)**.",
     "L'oscillateur local fonctionne souvent à une fréquence telle que FI = |Fréquence du signal - Fréquence de l'oscillateur local|.",
     "Exemple : Pour un signal à **3 600 kHz** et une FI de **9 000 kHz**, l'oscillateur local est à **5 400 kHz**."
    ]
   },
   {
    "title": "Accord et stabilité des oscillateurs",
    "body": "Les oscillateurs et circuits accordés garantissent la sélectivité et la performance du récepteur. La stabilité est essentielle pour éviter les dérives et interférences.",
    "points": [
     "Le condensateur variable ajustable dans le circuit avant l'amplificateur FI permet d'**accorder l'oscillateur local**.",
     "Sans amplificateur RF, un condensateur variable accorde le **présélecteur** pour sélectionner la fréquence désirée.",
     "Les oscillateurs doivent être **stables** et produire un spectre **pur** pour un fonctionnement fiable."
    ]
   },
   {
    "title": "Oscillateur de battement (BFO) et détection en BLU",
    "body": "Pour recevoir la bande latérale unique (BLU), le récepteur utilise un oscillateur de battement (BFO) afin de réintroduire la porteuse supprimée et rendre le signal audible.",
    "points": [
     "Le BFO produit une fréquence légèrement différente (décalage de **500 à 1 500 Hz**) pour générer un battement audible.",
     "Ce battement facilite la détection des signaux BLU en recréant la porteuse nécessaire à la démodulation.",
     "Le mélangeur et le BFO sont essentiels pour produire et détecter la fréquence intermédiaire."
    ]
   }
  ],
  "A-006-003": [
   {
    "title": "Principes de Sensibilité et de Bruit dans un Récepteur",
    "body": "Le seuil du niveau de bruit ou \"noise floor\" est le signal le plus faible détectable au-dessus du bruit interne. Le facteur de bruit (\"noise figure\") mesure la dégradation du rapport signal-bruit par le récepteur. Un facteur de bruit faible améliore la sensibilité, bien que le bruit externe puisse parfois dominer.",
    "points": [
     "**Seuil du niveau de bruit** : plus faible signal détectable juste au-dessus du bruit interne",
     "**Facteur de bruit** faible signifie une meilleure sensibilité",
     "Dans les bandes HF, le **bruit externe** (parasites naturels ou humains) dépasse souvent le bruit interne"
    ]
   },
   {
    "title": "Amplification, Gain et Sélectivité dans un Récepteur",
    "body": "L'amplificateur RF augmente le gain pour que les signaux faibles surpassent le bruit du mélangeur, améliorant ainsi le facteur de bruit et la sensibilité. L'amplificateur FI améliore principalement la sélectivité et le gain, tandis que le présélecteur filtre les signaux avant l'étage RF pour réduire les interférences.",
    "points": [
     "Amplificateur RF : gain suffisant pour dépasser le bruit du mélangeur",
     "Amplificateur RF améliore le **facteur de bruit** du récepteur",
     "Amplificateur FI : augmente le gain et améliore la sélectivité",
     "Présélecteur : filtres résonants protégeant l'étage RF contre les signaux indésirables"
    ]
   },
   {
    "title": "Gamme Dynamique et Sensibilité des Récepteurs FM UHF",
    "body": "La sensibilité en FM UHF s'exprime par l'amplitude du signal RF nécessaire pour obtenir un rapport SINAD de 12 dB. La gamme dynamique est le rapport en décibels entre le signal maximal admissible sans distorsion audible et la sensibilité, définissant l'excellence du récepteur à gérer de faibles et fortes amplitudes sans dégradation.",
    "points": [
     "Sensibilité FM UHF : signal RF pour un rapport **SINAD de 12 dB**",
     "Gamme dynamique : différence en dB entre le signal maximal admissible et la sensibilité",
     "Gamme dynamique exprime la capacité à accepter signaux faibles et forts sans distorsion"
    ]
   }
  ],
  "A-006-004": [
   {
    "title": "Fonctionnement de la Commande Automatique de Gain (AGC)",
    "body": "La AGC ajuste automatiquement le gain des amplificateurs RF et FI pour éviter la distorsion due à des signaux forts. Elle agit en réduisant le gain lorsque le signal augmente, maintenant ainsi la qualité de réception.",
    "points": [
     "La tension AGC est appliquée aux amplificateurs RF et FI",
     "Elle provient généralement des étages FI ou audiofréquence",
     "Deux variables clés : seuil (threshold) et délai de fonctionnement (decay time)",
     "Une défectuosité de l'AGC peut causer de la distorsion avec des signaux forts"
    ]
   },
   {
    "title": "Rôle des détecteurs et circuits associés dans un récepteur superhétérodyne",
    "body": "Le détecteur, notamment le détecteur de produit, mélange le signal amplifié FI avec une porteuse locale (BFO) pour produire le signal audio. Ce signal est ensuite envoyé vers l'amplificateur audiofréquence.",
    "points": [
     "Le signal FI amplifié est appliqué à l'étage détecteur",
     "Le détecteur de produit mélange FI et BFO pour extraire le signal audio",
     "Le signal audio à bas niveau sort du détecteur vers l'amplificateur AF",
     "Le BFO est essentiel pour la démodulation des modes CW/BLU"
    ]
   },
   {
    "title": "Correction de la réponse en fréquence dans les récepteurs FM",
    "body": "Un circuit de désaccentuation est ajouté après la détection FM pour restaurer proportionnellement les basses fréquences atténuées lors de l'émission, améliorant ainsi la qualité audio.",
    "points": [
     "La préaccentuation en émission amplifie les hautes fréquences",
     "La désaccentuation en réception compense cette amplification",
     "Le circuit de désaccentuation restaure la réponse en fréquence naturelle",
     "Ce circuit est indispensable pour une bonne fidélité audio en FM"
    ]
   }
  ],
  "A-007-001": [
   {
    "title": "Types de blocs d'accord et adaptateurs d'antenne",
    "body": "Il existe plusieurs types de circuits d'accord d'antenne : en série, en L, en pi, et pi-L. Chaque type utilise une combinaison spécifique de bobines et condensateurs pour adapter l'impédance de l'antenne au transmetteur.",
    "points": [
     "Un bloc d'accord en **pi** comprend un condensateur et deux bobines, ou une bobine et deux condensateurs formant une topologie en forme de π.",
     "Le bloc en **série** consiste en des éléments passifs alignés l'un après l'autre (bobines ou condensateurs en série).",
     "Le bloc en **L** utilise un seul condensateur et une bobine en configuration en forme de L, adaptée à une plage restreinte d'impédances.",
     "Le bloc **pi-L** combine les avantages du pi et de L, notamment pour la suppression des harmoniques."
    ]
   },
   {
    "title": "Fonctionnement des adaptateurs d'impédance",
    "body": "Un adaptateur annule la composante réactive de l'impédance de l'antenne puis transforme la partie résistive pour correspondre à l'impédance du système d'émission. Ceci assure un transfert efficace de puissance.",
    "points": [
     "L'adaptateur en **pi** offre la gamme d'adaptation la plus étendue parmi les types courants.",
     "L'adaptateur en **L** est limité à une gamme restreinte d'impédances pour lesquelles il est efficace.",
     "La fonction principale est d'ajuster l'impédance afin de minimiser le ROS (rapport d'ondes stationnaires).",
     "L'adaptateur **pi-L** favorise la **meilleure suppression des harmoniques**, idéal pour les amplificateurs à tube."
    ]
   },
   {
    "title": "Outil d'aide : L'abaque de Smith",
    "body": "L'abaque de Smith est un graphique permettant de simplifier les calculs d'impédance complexes en radioélectricité. Il fait le lien entre impédance, admittance, et paramètres réactifs.",
    "points": [
     "Il permet de visualiser la transformation d'impédance par les adaptateurs.",
     "Il simplifie les calculs nécessaires à l'adaptation d'antenne et au réglage des circuits d'accord.",
     "Très utilisé pour le diagnostic et le réglage des lignes d'alimentation et antennes."
    ]
   }
  ],
  "A-006-005": [
   {
    "title": "Principes des récepteurs superhétérodynes et fréquence image",
    "body": "Un récepteur superhétérodyne utilise un présélecteur dans l'amplificateur RF pour rejeter la fréquence image, ce qui améliore la sélectivité. L'utilisation d'une fréquence intermédiaire VHF dans un récepteur HF permet d'éloigner la fréquence image de la bande passante principale pour une meilleure réception.",
    "points": [
     "**Présélecteur RF** : filtre en amont qui réduit les signaux hors bande, notamment la fréquence image",
     "**Fréquence intermédiaire (FI)** : choisie haut en VHF pour séparer la fréquence image de la bande utile",
     "**Réponse image** : fréquence indésirable pouvant brouiller la réception si non filtrée"
    ]
   },
   {
    "title": "Problèmes liés aux signaux forts et non-linéarités",
    "body": "Les signaux très forts proches de la fréquence d'écoute peuvent provoquer la désensibilisation, une perte de sensibilité du récepteur. Cette désensibilisation est causée par des composants non linéaires qui génèrent des distorsions et de l'intermodulation, brouillant la réception. L'utilisation d'un filtre à cavité améliore la sélectivité et réduit ces effets.",
    "points": [
     "**Désensibilisation** : baisse de sensibilité due à un signal fort proche de la fréquence reçue",
     "**Intermodulation** : mélange non linéaire de deux signaux créant des signaux parasites",
     "**Filtre à cavité** : filtre sélectif puissant qui limite les signaux hors bande et la désensibilisation"
    ]
   },
   {
    "title": "Stabilité et comportement dynamique des récepteurs",
    "body": "La stabilité en fréquence est principalement affectée par l'oscillateur local et l'alimentation. Les récepteurs avec faible gamme dynamique sont sensibles aux signaux hors bande, pouvant causer intermodulation et désensibilisation mais pas de rétroaction. Le test de dynamique d'intermodulation à 10 MHz d’espacement est une bonne méthode pour évaluer la résistance aux forts signaux hors bande.",
    "points": [
     "**Stabilité fréquence** : dépend de l'oscillateur local et alimentation, pas du cadran d'accord",
     "**Gamme dynamique faible** : conduit à problèmes en présence de signaux forts proches",
     "**Rétroaction** : n’est pas une conséquence directe d’une faible gamme dynamique",
     "**Test intermodulation (10 MHz)** : mesure la performance vis-à-vis des forts signaux hors bande"
    ]
   }
  ],
  "A-007-004": [
   {
    "title": "Distribution tension et courant dans un dipôle demi-onde",
    "body": "Dans un dipôle demi-onde, la tension et le courant varient le long de l'antenne. La tension est maximale aux extrémités tandis que le courant y est minimal. Au centre, la situation est inverse : la tension est minimale et le courant maximal.",
    "points": [
     "Tension maximale aux **extrémités** du dipôle.",
     "Courant minimal aux **extrémités** du dipôle.",
     "Au **centre**, la tension est **minimale**.",
     "Au **centre**, le courant est **maximal**."
    ]
   },
   {
    "title": "Point d'alimentation et impédance du dipôle demi-onde",
    "body": "Le dipôle demi-onde est normalement alimenté en son centre, où le courant est maximal et la tension minimale, résultant en une impédance faible. Aux extrémités, l'impédance est plus élevée du fait de la tension élevée et du courant faible.",
    "points": [
     "Point d'alimentation au **centre** du dipôle, avec **courant maximal**.",
     "Impédance minimale au **centre** (tension faible, courant élevé).",
     "Impédance plus élevée aux **extrémités** du dipôle.",
     "Signification pratique : adapter l'impédance pour minimiser les pertes."
    ]
   }
  ],
  "A-007-002": [
   {
    "title": "Comportement des lignes de transmission à différentes longueurs",
    "body": "Les lignes de transmission d'un quart et d'une demi-longueur d'onde présentent des impédances spécifiques aux extrémités ouvertes ou court-circuitées. Ces propriétés sont cruciales pour l'adaptation et le réglage des antennes.",
    "points": [
     "Une ligne d'un **quart de longueur d'onde** court-circuitée à l'extrémité présente une **très haute impédance** à la source.",
     "Une ligne d'un **quart de longueur d'onde** ouverte à l'extrémité présente une **très basse impédance** à la source.",
     "Une ligne d'une **demi-longueur d'onde** ouverte à l'extrémité présente une **très haute impédance** à la source.",
     "Une ligne d'une **demi-longueur d'onde** court-circuitée à l'extrémité présente une **très basse impédance** à la source."
    ]
   },
   {
    "title": "Le facteur de vélocité dans les lignes de transmission",
    "body": "Le facteur de vélocité représente le rapport entre la vitesse de propagation des ondes dans une ligne de transmission et celle dans le vide. Il dépend du matériau diélectrique isolant entre les conducteurs.",
    "points": [
     "Le **facteur de vélocité** est égal à la **vitesse de l'onde dans la ligne divisée par la vitesse de la lumière** dans le vide.",
     "Typiquement, dans un câble coaxial avec un diélectrique en polyéthylène, le facteur de vélocité est environ **0,66**.",
     "La vitesse effective dans la ligne est plus lente que dans l'air, ce qui explique pourquoi la **longueur physique du câble est plus courte que sa longueur électrique**.",
     "Le facteur de vélocité se calcule aussi comme l'inverse de la racine carrée de la constante diélectrique de l'isolant."
    ]
   }
  ],
  "A-007-003": [
   {
    "title": "Adaptation d'impédance en antennes Yagi",
    "body": "L'adaptation d'impédance permet de connecter efficacement une ligne de transmission à une antenne en égalisant leurs impédances. Trois types courants sont l'adaptateur en T, l'adaptateur gamma et l'adaptateur à segment de ligne (stub).",
    "points": [
     "**Adaptateur en T** : raccorde une ligne à deux points symétriques autour du centre de l'élément pour adapter une haute impédance à une basse.",
     "**Adaptateur gamma** : relie la tresse coaxiale au centre de l'élément et le conducteur central à un condensateur variable via une tige gamma sur un côté, offrant une adaptation capacitive simple.",
     "**Adaptateur à segment de ligne (stub)** : utilise une courte section de ligne en parallèle à un point sur la ligne d'alimentation pour modifier l'impédance."
    ]
   },
   {
    "title": "Calcul de la longueur des lignes d'adaptation",
    "body": "La longueur physique d'une ligne d'adaptation dépend de la fréquence, de la longueur d'onde et du facteur de vélocité du câble utilisé. Celle-ci s'exprime par : L = (longueur électrique) × (longueur d'onde) × (facteur de vélocité).",
    "points": [
     "À 14,100 MHz, une ligne d'un quart d'onde avec facteur de vélocité **0,66** mesure environ **3,51 mètres (11,5 pieds)**.",
     "À 15 MHz, pour un câble avec facteur de vélocité **0,8**, un quart d'onde correspond à environ **4 mètres (13,1 pieds)**.",
     "**Facteur de vélocité** = vitesse de propagation dans la ligne par rapport à la vitesse dans le vide.",
     "La longueur d'onde dans le vide (λ) = **300 / fréquence (en MHz)** mètres."
    ]
   },
   {
    "title": "Caractéristiques spécifiques de l'adaptateur gamma",
    "body": "L'adaptateur gamma est caractérisé par sa simplicité mécanique et capacitance réglable qui facilite l'ajustement précis de l'impédance d'antenne Yagi.",
    "points": [
     "La **tresse coaxiale** est connectée au **centre de l'élément alimenté**.",
     "Le **conducteur central** est connecté via une **tige gamma ajustable** à un **condensateur variable** monté en série d'un côté de l'élément.",
     "Le condensateur variable et la tige gamma forment un circuit capacitif permettant d'adapter l'impédance sans déformation mécanique importante."
    ]
   }
  ],
  "A-007-005": [
   {
    "title": "Polarisation des ondes électromagnétiques",
    "body": "La polarisation décrit l'orientation du champ électrique d'une onde électromagnétique. Une polarisation circulaire résulte d'un champ électrique en rotation, souvent obtenue avec deux dipôles en croix alimentés avec un déphasage de 90 degrés.",
    "points": [
     "Une onde polarisée circulairement a un champ électrique qui tourne dans le plan perpendiculaire à la direction de propagation.",
     "Deux dipôles en forme de croix, déphasés de 90°, produisent une polarisation circulaire.",
     "Les antennes hélicoïdales peuvent posséder une polarisation horaire ou antihoraire selon leur enroulement.",
     "Une antenne hélice radiale (« loaded helical-wound ») ne produit pas de polarisation circulaire.",
     "En VHF/UHF, une transpolarisation de 90° cause une perte d'au moins 20 dB."
    ]
   },
   {
    "title": "Antennes paraboliques et illumination",
    "body": "Une antenne parabolique concentre toute l'énergie reçue sur un point focal où est placée l'antenne de réception, ce qui justifie son haut gain. Les méthodes d'illumination classiques incluent différents types d'alimentation, mais pas l’excitation Newton.",
    "points": [
     "Le gain dépend du diamètre du réflecteur exprimé en longueurs d'onde (λ).",
     "L'erreur de surface à ne pas dépasser sur un réflecteur parabolique est de 0,1 λ max pour maintenir une bonne efficacité.",
     "L'excitation Newton n'est pas une méthode utilisée pour illuminer un réflecteur parabolique.",
     "L’antenne parabolique fonctionne comme un miroir concentrant l’énergie vers un foyer."
    ]
   },
   {
    "title": "Applications spécifiques en VHF/UHF et orientations polarisées",
    "body": "Le décalage Doppler devient significatif lors de communications avec des satellites en orbite. Les antennes hélicoïdales, polarisées circulairement, sont utilisées pour capter les signaux dans une même polarisation. Une antenne capable de recevoir horizontalement et verticalement est une antenne directionnelle hélicoïdale.",
    "points": [
     "Le décalage Doppler affecte les communications VHF/UHF via satellites.",
     "Une antenne hélicoïdale avec polarisation horaire reçoit mieux les signaux à polarisation horaire.",
     "Une antenne qui capte simultanément les signaux horizontaux et verticaux s'appelle une antenne directionnelle hélicoïdale."
    ]
   }
  ],
  "A-007-006": [
   {
    "title": "Puissance apparente rayonnée (PAR) et lignes d'alimentation",
    "body": "La puissance apparente rayonnée (PAR) est la puissance réellement transmise dans l'espace, après avoir tenu compte des pertes dans les lignes et du gain de l'antenne. Elle tient compte de la puissance émise, des pertes dans la ligne, et du gain d'antenne exprimé en dBd.",
    "points": [
     "La PAR = (Puissance de sortie - pertes dans la ligne) × gain d'antenne",
     "Le gain d'antenne en dBd compare l'antenne au dipôle de référence.",
     "Perte de 3 dB sur la ligne signifie que la puissance est divisée par 2.",
     "Augmenter le gain total de 3 dB double la PAR."
    ]
   },
   {
    "title": "Comprendre les pertes dans la ligne de transmission",
    "body": "Le rapport d'ondes stationnaire (ROS) élevé augmente les pertes dans la ligne de transmission. Ces pertes s'expliquent par l'échauffement du diélectrique et des conducteurs dus à la réflexion et l'impédance non adaptée.",
    "points": [
     "Des pertes dans la ligne sont mesurées en dB ou watts dissipés.",
     "Les pertes se traduisent par des pertes thermiques dans la ligne (câble, connecteurs).",
     "Une ligne bien accordée minimise le ROS et maximise la PAR."
    ]
   },
   {
    "title": "Calculs pratiques de la puissance apparente rayonnée",
    "body": "Pour calculer la PAR, soustraire d'abord les pertes (en dB ou watts) de la puissance d'entrée, puis appliquer le gain d'antenne. En décibel, chaque 3 dB représente un facteur 2.",
    "points": [
     "Pertes en dB : Puissance après perte = Puissance avant × 10^(-pertes/10)",
     "Gain en dB : Puissance finale = Puissance après perte × 10^(gain/10)",
     "Exemple : 100W sortie, 3 dB perte (50W), antenne 6 dBd (×4), PAR = 200W.",
     "Changer d'une antenne 3 dBd à 9 dBd quadruple la PAR (×4)."
    ]
   }
  ],
  "A-007-007": [
   {
    "title": "Hauteur et angle de rayonnement des antennes",
    "body": "La hauteur d'une antenne par rapport au sol influence directement son angle de rayonnement vertical principal et son efficacité pour différents types de communication.",
    "points": [
     "**L'angle de rayonnement du lobe principal diminue** quand on élève une antenne Yagi à trois éléments horizontalement.",
     "La plupart des antennes horizontales n'ont pas de directivité marquée sauf si elles sont placées à **au moins une demi-longueur d'onde au-dessus du sol**.",
     "Un dipôle demi-onde à une demi-longueur d'onde au-dessus du sol minimise le rayonnement vertical ou vers le haut, concentrant l'énergie horizontalement.",
     "Une antenne verticale quart d'onde sur le sol dégagé produit un angle de rayonnement plus bas et est meilleure pour les contacts à longue distance."
    ]
   },
   {
    "title": "Interaction avec le sol et propagation",
    "body": "Le sol agit comme un réflecteur, affectant le diagramme de rayonnement horizontal et la propagation, surtout à basse hauteur et fréquences basses.",
    "points": [
     "Le plan effectif de réflexion du sol se situe entre **plusieurs cm** et **2 mètres sous la surface**, selon les conditions du sol.",
     "Si un dipôle horizontal est installé à moins d'une demi-longueur d'onde, les ondes réfléchies déforment le diagramme de rayonnement azimutal.",
     "Pour la communication à grande distance, **l'angle de rayonnement doit être inférieur à 30 degrés** afin de bénéficier des réflexions ionosphériques.",
     "L'angle de rayonnement vertical plus faible permet des sauts multiples et des distances accrues."
    ]
   },
   {
    "title": "Cas particulier : NVIS (Near Vertical Incidence Skywave)",
    "body": "La communication NVIS utilise des antennes basses et des fréquences sous la fréquence critique pour une propagation ionosphérique à incidence près verticale.",
    "points": [
     "Une antenne horizontale fixée à moins d'un quart de longueur d'onde est idéale pour NVIS.",
     "La fréquence doit être choisie **en dessous de la fréquence critique ionosphérique** pour favoriser ce mode de propagation.",
     "Cette technique est adaptée aux communications sur de courtes distances via l'ionosphère."
    ]
   }
  ],
  "A-007-009": [
   {
    "title": "Guide d'onde : usage et caractéristiques",
    "body": "Le guide d'onde est une ligne de transmission utilisée principalement aux fréquences élevées, au-delà de 3 000 MHz. Pour fonctionner correctement, sa section transversale doit être d'au moins une demi-longueur d'onde.",
    "points": [
     "Utilisé aux fréquences supérieures à **3 000 MHz**",
     "Section transversale d'au moins **une demi-longueur d'onde** pour un bon transfert d'énergie",
     "Agit comme un **filtre passe-haut** : il transmet les fréquences au-dessus de sa fréquence de coupure"
    ]
   },
   {
    "title": "Avantages et limites du guide d'onde par rapport aux autres lignes",
    "body": "Le guide d'onde présente des pertes très faibles à haute fréquence, bien meilleures que celles du câble coaxial. Contrairement à une idée reçue, il ne souffre pas de pertes importantes au-dessus de la fréquence de coupure.",
    "points": [
     "Très faible perte comparé au câble coaxial aux fréquences micro-ondes",
     "Contrairement au câble coaxial, il ne souffre pas de pertes par hystérésis",
     "Les pertes sont faibles au-dessus de la fréquence de coupure, mais importantes en dessous"
    ]
   },
   {
    "title": "Lignes en circuit imprimé et sécurité en maintenance",
    "body": "Les lignes microruban (microstrip) et stripline sont des lignes de transmission réalisées sur circuit imprimé. La ligne microruban est moins bien blindée que le câble coaxial. Avant toute intervention sur un guide d'onde ou un cornet à micro-ondes, il est impératif de couper et débrancher l'émetteur.",
    "points": [
     "Une ligne microruban (microstrip line) est une ligne de transmission sur circuit imprimé",
     "La ligne microruban est moins bien blindée que le câble coaxial",
     "La ligne stripline est aussi une ligne de transmission réalisée sur circuit imprimé",
     "Toujours mettre hors tension et débrancher avant de réparer un guide d'onde ou cornet micro-ondes"
    ]
   }
  ],
  "A-007-008": [
   {
    "title": "Résistance de rayonnement et efficacité d'une antenne",
    "body": "La résistance de rayonnement d'une antenne représente la résistance équivalente qui dissiperait la même puissance que celle rayonnée par l'antenne. C'est un élément clé pour évaluer l'efficacité globale de l'antenne.",
    "points": [
     "**Résistance de rayonnement** : résistance fictive équivalente à la puissance rayonnée.",
     "La résistance totale = résistance de rayonnement + résistance ohmique (pertes internes).",
     "L'**efficacité de l'antenne** = (résistance de rayonnement / résistance totale) × 100.",
     "Connaître la résistance de rayonnement est essentiel pour accorder l'impédance et maximiser le transfert d'énergie."
    ]
   },
   {
    "title": "Facteurs influençant la résistance de rayonnement",
    "body": "La résistance de rayonnement dépend de la localisation de l'antenne dans son environnement immédiat ainsi que des caractéristiques géométriques comme le rapport longueur/diamètre des conducteurs utilisés.",
    "points": [
     "L'environnement proche (sol, objets) modifie la résistance de rayonnement.",
     "Le rapport **longueur/diamètre** des conducteurs influe sur cette résistance.",
     "Les pertes dans les conducteurs ajoutent à la résistance ohmique et diminuent l'efficacité."
    ]
   },
   {
    "title": "Largeur de faisceau et mesures associées",
    "body": "La largeur approximative du faisceau d'une antenne directionnelle est évaluée par l'angle entre les deux azimuts où le gain de l'antenne diminue de 3 dB (la moitié de la puissance maximale).",
    "points": [
     "La largeur du faisceau correspond à la distance angulaire entre les points à demi-puissance du lobe principal.",
     "Une largeur de faisceau plus étroite indique une antenne plus directive.",
     "Exemples d'efficacité : dipôle demi-onde (97,3 % avec 2 Ω ohmiques, 72 Ω rayonnement), boucle compacte (96,15 % avec 2 mΩ ohmiques et 50 mΩ rayonnement)."
    ]
   }
  ]
 }
};
